import constants from "../constants.js";
import { 
  DebtorAgencyVirtualCreditCardConfigurationsProvider,
  DebtorAgencyVirtualCreditCardConfigurationsRegionalConsumerId,
  DebtorAgencyVirtualCreditCardConfigurationsCacCode,
  DebtorAgencyVirtualCreditCardConfigurationsCustomNameDisplayed,
  DebtorAgencyVirtualCreditCardConfigurationsSectorTypes,
  DebtorAgencyVirtualCreditCardConfigurationsProvidersAllowed,
  DebtorAgencyVirtualCreditCardConfigurationsAggregatorsAllowed,
  DebtorAgencyVirtualCreditCardConfigurationsVirtualCreditCardApplicationType,
  DebtorAgencyVirtualCreditCardConfigurationsPaymentInformation,
  DebtorAgencyVirtualCreditCardConfigurationsItem,
  DebtorAgencyVirtualCreditCardConfigurations,
  DebtorAgencyVirtualCreditCardConfigurationsCompanyReferenceMappingSourceFieldType,
  DebtorAgencyVirtualCreditCardConfigurationsCompanyReferenceMappingSourceFieldCode,
  DebtorAgencyVirtualCreditCardConfigurationsCompanyReferenceMappingCustomDataKey,
  DebtorAgencyVirtualCreditCardConfigurationsCompanyReferenceMappingReportKey,
  DebtorAgencyVirtualCreditCardConfigurationsCompanyReferenceMappingItem,
  DebtorAgencyVirtualCreditCardConfigurationsCompanyReferenceMappings,
  DebtorAgencyVirtualCreditCardConfigurationsNotificationEmail
} from '../components/debtors/agencyVirtualCreditCardConfiguration';

import {
  ItineraryPoliciesProfileAttributeSourceType,
  ItineraryPoliciesProfileAttributesItem,
  ItineraryPoliciesProfileAttributesItems,
  ItineraryPolicyEnhancedPolicyRulesConditionsItem,
  ItineraryPolicyEnhancedPolicyRulesConditions
} from '../components/debtors/profileAttribute'

const PaymentConfigurationsPaymentTypesConfigurationsSuppliersSettings = {
  displayName: "Settings",
  dataAt:
    "PaymentConfigurations.$payConItem.PaymentTypes.$payConPayTypItem.Configurations.$payTypeConItem.Suppliers.$payConSupItem.Settings",
  displayAs: constants.DISPLAY_AS.KEY_VALUE_PAIRS,
  keyOptions: "SuppliersSettingsOptions",
};

const PaymentConfigurationsPaymentTypesConfigurationsSuppliersName = {
  displayName: "Name",
  dataAt:
    "PaymentConfigurations.$payConItem.PaymentTypes.$payConPayTypItem.Configurations.$payTypeConItem.Suppliers.$payConSupItem.Name",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const PaymentConfigurationsPaymentTypesConfigurationsSuppliersItem = {
  displayName: "Suppliers",
  dataAt:
    "PaymentConfigurations.$payConItem.PaymentTypes.$payConPayTypItem.Configurations.$payTypeConItem.Suppliers.$payConSupItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    PaymentConfigurationsPaymentTypesConfigurationsSuppliersName,
    PaymentConfigurationsPaymentTypesConfigurationsSuppliersSettings,
  ],
  endpoint: "Debtors",
  routeParamId: "debtorId",
  removeParamId: "payConSupItem",
  canDelete: true,
};

const DebtorGdsPassiveFlightSegmentRemarkTemplate = {
  displayName: "Item",
  dataAt: "Gds.$GdsItem.PassiveFlightSegmentRemarks.$RemarkTemplate",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    {
      displayName: "Type",
      dataAt: "Gds.$GdsItem.PassiveFlightSegmentRemarks.$RemarkTemplate.Type",
      displayAs: constants.DISPLAY_AS.SELECT,
      optionsAt: "RemarkType",
    },
    {
      displayName: "Template",
      dataAt:
        "Gds.$GdsItem.PassiveFlightSegmentRemarks.$RemarkTemplate.Template",
      displayAs: constants.DISPLAY_AS.TEXT_INPUT,
    },
  ],
  endpoint: "Debtors",
  removeParamId: "RemarkTemplate",
  canDelete: true,
};

const GdsPassiveFlightSegmentRemarks = {
  displayName: "Passive Flight Segment Remarks",
  dataAt: "Gds.$GdsItem.PassiveFlightSegmentRemarks",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: DebtorGdsPassiveFlightSegmentRemarkTemplate,
  gridCols: [
    { name: "Type", key: "Type" },
    { name: "Template", key: "Template" },
  ],
};

const DebtorGdsMiQuestionsItemQuestionsItemAnswerFormat = {
  displayName: "Answer Format",
  dataAt: "Gds.$GdsItem.MiQuestions.$MiItem.Questions.$question.AnswerFormat",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const DebtorGdsMiQuestionsItemQuestionsItemQuestion = {
  displayName: "Question",
  dataAt: "Gds.$GdsItem.MiQuestions.$MiItem.Questions.$question.Question",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const PaymentConfigurationsPaymentTypesConfigurationsSuppliers = {
  displayName: "Suppliers",
  dataAt:
    "PaymentConfigurations.$payConItem.PaymentTypes.$payConPayTypItem.Configurations.$payTypeConItem.Suppliers",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: PaymentConfigurationsPaymentTypesConfigurationsSuppliersItem,
  gridCols: [{ name: "Name", key: "Name" }],
};

const PaymentConfigurationsPaymentTypesConfigurationsSector = {
  displayName: "Sector",
  dataAt:
    "PaymentConfigurations.$payConItem.PaymentTypes.$payConPayTypItem.Configurations.$payTypeConItem.Sector",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "SectorTypes",
};

const ItineraryPoliciesCarPolicyRestrictionPolicyType = {
  displayName: "Policy Type",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Car.PolicyRestriction.$carPolRestrictedItem.PolicyType",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "CarPolicyTypes",
};

const ItineraryPoliciesCarPolicyRestrictionMaximumDailyRate = {
  displayName: "Maximum Daily Rate",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Car.PolicyRestriction.$carPolRestrictedItem.MaximumDailyRate",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: "number",
};

const ItineraryPoliciesCarPolicyRestrictionSipps = {
  displayName: "Sipps",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Car.PolicyRestriction.$carPolRestrictedItem.Sipps",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const ItineraryPoliciesCarPolicyRestrictionCountryCodes = {
  displayName: "Country Codes",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Car.PolicyRestriction.$carPolRestrictedItem.CountryCodes",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const ItineraryPoliciesCarPolicyRestrictionLocationCodes = {
  displayName: "Location Codes",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Car.PolicyRestriction.$carPolRestrictedItem.LocationCodes",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const ItineraryPoliciesCarPolicyRestrictionSuppliers = {
  displayName: "Suppliers",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Car.PolicyRestriction.$carPolRestrictedItem.Suppliers",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const ItineraryPoliciesCarPolicyPreferredSipps = {
  displayName: "Sipps",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Car.PolicyPreferred.$carPolPrefItem.Sipps",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const ItineraryPoliciesCarPolicyPreferredCountryCodes = {
  displayName: "Country Codes",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Car.PolicyPreferred.$carPolPrefItem.CountryCodes",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const ItineraryPoliciesCarPolicyPreferredLocationCodes = {
  displayName: "Location Codes",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Car.PolicyPreferred.$carPolPrefItem.LocationCodes",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const ItineraryPoliciesCarPolicyPreferredSuppliers = {
  displayName: "Suppliers",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Car.PolicyPreferred.$carPolPrefItem.Suppliers",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const ItineraryPoliciesCarPolicyExceptionSettingsSipps = {
  displayName: "Sipps",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Car.PolicyExceptionSettings.$carPolExcSetItem.Sipps",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const ItineraryPoliciesCarPolicyExceptionSettingsSuppliers = {
  displayName: "Supplier Codes",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Car.PolicyExceptionSettings.$carPolExcSetItem.Suppliers",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const ItineraryPoliciesCarPolicyExceptionSettingsCountryCodes = {
  displayName: "Country Codes",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Car.PolicyExceptionSettings.$carPolExcSetItem.CountryCodes",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const ItineraryPoliciesCarPolicyExceptionSettingsLocationCodes = {
  displayName: "Location Codes",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Car.PolicyExceptionSettings.$carPolExcSetItem.LocationCodes",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const ItineraryPoliciesCarPolicyExceptionSettingsMaximumDailyRate = {
  displayName: "Maximum Daily Rate",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Car.PolicyExceptionSettings.$carPolExcSetItem.MaximumDailyRate",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: "number",
};

const ItineraryPoliciesCarPolicyExceptionSettingsSupplierCode = {
  displayName: "Supplier Code (depreciated)",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Car.PolicyExceptionSettings.$carPolExcSetItem.SupplierCode",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const ItineraryPoliciesCarPolicyExceptionSettingsCountryCode = {
  displayName: "Country Code (depreciated)",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Car.PolicyExceptionSettings.$carPolExcSetItem.CountryCode",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const ItineraryPoliciesCarPolicyExceptionSettingsLocationCode = {
  displayName: "Location Code (depreciated)",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Car.PolicyExceptionSettings.$carPolExcSetItem.LocationCode",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const ItineraryPoliciesCarPolicyExceptionsCountries = {
  displayName: "Countries",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Car.PolicyExceptions.$carPolExcItem.Countries",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const ItineraryPoliciesCarPolicyExceptionsCode = {
  displayName: "Code",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Car.PolicyExceptions.$carPolExcItem.Code",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const ItineraryPoliciesCarPolicyExceptionsTitle = {
  displayName: "Title",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Car.PolicyExceptions.$carPolExcItem.Title",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const ItineraryPoliciesCarPoliciesAllowDeliveryAndCollection = {
  displayName: "Allow Delivery And Collection",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Car.Policies.$carPolItem.AllowDeliveryAndCollection",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const ItineraryPoliciesCarPoliciesCostCentres = {
  displayName: "Debtor Cost Centres",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Car.Policies.$carPolItem.CostCentres",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const ItineraryPoliciesCarPoliciesDepartments = {
  displayName: "Debtor Departments",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Car.Policies.$carPolItem.Departments",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const ItineraryPoliciesCarPoliciesRate = {
  displayName: "Car Policies Rate",
  dataAt: "ItineraryPolicies.$ItinPolIndex.Car.Policies.$carPolItem.Rate",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const ItineraryPoliciesCarPoliciesCorporateCode = {
  displayName: "Car Policies Corporate Code",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Car.Policies.$carPolItem.CorporateCode",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const ItineraryPoliciesCarPoliciesGuaranteeText = {
  displayName: "Car Policies Guarantee Text",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Car.Policies.$carPolItem.GuaranteeText",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const ItineraryPoliciesCarPoliciesDebtorRateOverTravelerId = {
  displayName: "Car Policies Use Debtor Rate Over Traveler ID",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Car.Policies.$carPolItem.DebtorRateOverTravelerId",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const ItineraryPoliciesCarPoliciesSupplierTitle = {
  displayName: "Car Policies Supplier Title",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Car.Policies.$carPolItem.Supplier.Title",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const ItineraryPoliciesCarPoliciesSupplierCode = {
  displayName: "Car Policies Supplier Code",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Car.Policies.$carPolItem.Supplier.Code",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const ItineraryPoliciesCarPoliciesName = {
  displayName: "Car Policy Name",
  dataAt: "ItineraryPolicies.$ItinPolIndex.Car.Policies.$carPolItem.Name",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const ItineraryPoliciesCarPoliciesBillingReference = {
  displayName: "Car Billing Reference",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Car.Policies.$carPolItem.BillingReference",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const ItineraryPoliciesCarPoliciesUseCompanyRefCodeForBillingRef = {
  displayName: "Car Billing Reference Use Company Reference Code",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Car.Policies.$carPolItem.UseCompanyRefCodeForBillingRef",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const ItineraryPoliciesCarPoliciesUseCompanyRefCodeForBillingRefSub = {
  displayAs: constants.DISPLAY_AS.SUB_HEADING,
  label:
    "Billing Reference = CompanyReference.Code. If Company Reference is not found or is empty then no Billing Reference is sent.",
};

const ItineraryPoliciesCarDisableCar = {
  displayName: "Disable Car",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Car.DisableCar",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const ItineraryPoliciesHotelPolicyExceptionSettingsLatLong = {
  displayName: "Address Search",
  displayAs: constants.DISPLAY_AS.LAT_LONG_MAP_SEARCH,
  latField: "ItineraryPolicies.$ItinPolIndex.Hotel.PolicyExceptionSettings.$ItinPolExcSetItem.Latitude",
  longField: "ItineraryPolicies.$ItinPolIndex.Hotel.PolicyExceptionSettings.$ItinPolExcSetItem.Longitude",
  radiusField: "ItineraryPolicies.$ItinPolIndex.Hotel.PolicyExceptionSettings.$ItinPolExcSetItem.Radius",
  hotelsField: "ItineraryPolicies.$ItinPolIndex.Hotel.PolicyExceptionSettings.$ItinPolExcSetItem.HotelIDs",
  IsImperialSystemField: "HotelConfiguration.IsImperialSystem",
};

const ItineraryPoliciesHotelPolicyExceptionSettingsLongitude = {
  displayName: "Longitude",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Hotel.PolicyExceptionSettings.$ItinPolExcSetItem.Longitude",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: "number",
  min: -9999999999,
  max: 9999999999,
};

const ItineraryPoliciesHotelPolicyExceptionSettingsLatitude = {
  displayName: "Latitude",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Hotel.PolicyExceptionSettings.$ItinPolExcSetItem.Latitude",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: "number",
  min: -9999999999,
  max: 9999999999,
};

const ItineraryPoliciesHotelPolicyExceptionSettingsName = {
  displayName: "Name",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Hotel.PolicyExceptionSettings.$ItinPolExcSetItem.Name",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const ItineraryPoliciesHotelPolicyExceptionSettingsLocationCode = {
  displayName: "Location Code",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Hotel.PolicyExceptionSettings.$ItinPolExcSetItem.LocationCode",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const ItineraryPoliciesHotelPolicyExceptionSettingsAirportCodes = {
  displayName: "Airport Codes",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Hotel.PolicyExceptionSettings.$ItinPolExcSetItem.AirportCodes",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
  html:"<small>If there are multiple airports in a city location, identify all airports here. Use the codes that the Sabre hotels are associated to in that area.</small>"
};

const ItineraryPoliciesHotelPolicyExceptionSettingsHotelIDs = {
  displayName: "Hotel IDs",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Hotel.PolicyExceptionSettings.$ItinPolExcSetItem.HotelIDs",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
  
};

const ItineraryPoliciesHotelPolicyExceptionSettingsCountryCode = {
  displayName: "Country Code",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Hotel.PolicyExceptionSettings.$ItinPolExcSetItem.CountryCode",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const ItineraryPoliciesHotelPolicyExceptionSettingsMaximumDailyRate = {
  displayName: "Maximum Daily Rate",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Hotel.PolicyExceptionSettings.$ItinPolExcSetItem.MaximumDailyRate",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: "number",
  html:"<small>If Maximum Daily Rate is blank or is set to zero then the system will apply the Price Tolerance against the Hotel Lost Savings calculation, otherwise the Price Tolerance will be applied against the Maximum Daily Rate amount.</small>"
};

const ItineraryPoliciesHotelPolicyExceptionSettingsPriceTolerance = {
  displayName: "Price Tolerance",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Hotel.PolicyExceptionSettings.$ItinPolExcSetItem.PriceTolerance",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: "number",
};

const ItineraryPoliciesHotelPolicyExceptionSettingsPriceToleranceType = {
  displayName: "Price Tolerance Type",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Hotel.PolicyExceptionSettings.$ItinPolExcSetItem.PriceToleranceType",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "PriceToleranceType",
};

const ItineraryPoliciesHotelPolicyExceptionSettingsRadius = {
  displayName: "Radius",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Hotel.PolicyExceptionSettings.$ItinPolExcSetItem.Radius",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: "number",
};

const ItineraryPoliciesHotelPolicyExceptionsCountries = {
  displayName: "Countries",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Hotel.PolicyExceptions.$hotelPolExcItem.Countries",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const ItineraryPoliciesHotelPolicyExceptionsCode = {
  displayName: "Code",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Hotel.PolicyExceptions.$hotelPolExcItem.Code",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const ItineraryPoliciesHotelPolicyExceptionsTitle = {
  displayName: "Title",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Hotel.PolicyExceptions.$hotelPolExcItem.Title",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const ItineraryPoliciesHotelRateCategoriesCategory = {
  displayName: "Rate Category",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Hotel.RateCategories.$hotelRCItem.Category",
  defaultValue: "Government",
  displayAs: constants.DISPLAY_AS.O_DATA_SELECT,
  endpoint: "Settings",
  queryOption: "select",
  selectProperty: "HotelRateCategories",
  selectChoiceName: "Name",
  entityIdentifier: "Name",
  searchAllNo: true,
  inputTitle: "Name",
  required: true,
  validationMessage: "Rate Category is required."
};

const ItineraryPoliciesHotelRateCategoriesPriority = {
  displayName: "Display Priority",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Hotel.RateCategories.$hotelRCItem.Priority",
  optionsAt: "HotelRateCategoriesPriorities",
  defaultValue: "No priority",
  displayAs: constants.DISPLAY_AS.SELECT,
};

const ItineraryPoliciesHotelExcludedAggregatorChainsAggregator = {
  displayName: "Aggregator",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Hotel.ExcludedAggregatorChains.$hotelEACItem.Aggregator",
  displayAs: constants.DISPLAY_AS.O_DATA_SELECT,
  endpoint: "Settings",
  queryOption: "select",
  selectProperty: "HotelRateCategories",
  inputTitle: "Name",
  selectChoiceName: "Name",
  entityIdentifier: "Name",
  searchAllNo: true,
  isMultiSelect: false,
  additionalFilters: {
    "IsAggregator": true
  },
  showOnlySelectedField: true
};

const ItineraryPoliciesHotelExcludedAggregatorChainsChains = {
  displayName: "Exclude from:",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Hotel.ExcludedAggregatorChains.$hotelEACItem.Chains",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const ItineraryPoliciesHotelNoHotelPoliciesTitle = {
  displayName: "Title",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Hotel.NoHotelPolicies.$hotelNHPItem.Title",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const ItineraryPoliciesHotelNoHotelPoliciesCode = {
  displayName: "Code",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Hotel.NoHotelPolicies.$hotelNHPItem.Code",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const ItineraryPoliciesHotelNoHotelPoliciesInfo = {
  displayAs: constants.DISPLAY_AS.SUB_HEADING,
  label: "(Only active when Overnight Hotel Prompt is enabled)",
};

const ItineraryPoliciesHotelPoliciesLatLong = {
  displayName: "Address Search",
  displayAs: constants.DISPLAY_AS.LAT_LONG_MAP_SEARCH,
  latField: "ItineraryPolicies.$ItinPolIndex.Hotel.Policies.$hotelPolItem.Latitude",
  longField: "ItineraryPolicies.$ItinPolIndex.Hotel.Policies.$hotelPolItem.Longitude",
  radiusField: "ItineraryPolicies.$ItinPolIndex.Hotel.Policies.$hotelPolItem.Radius",
  IsImperialSystemField: "HotelConfiguration.IsImperialSystem",
  additionalPlots: "ItineraryPolicies.$ItinPolIndex.Hotel.Policies.$hotelPolItem.Hotels",
};

const ItineraryPoliciesHotelPoliciesLongitude = {
  displayName: "Policy Longitude",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Hotel.Policies.$hotelPolItem.Longitude",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: "number",
  min: -9999999999,
  max: 9999999999,
};

const ItineraryPoliciesHotelPoliciesLatitude = {
  displayName: "Policy Latitude",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Hotel.Policies.$hotelPolItem.Latitude",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: "number",
  min: -9999999999,
  max: 9999999999,
};

const ItineraryPoliciesHotelPoliciesRadius = {
  displayName: "Policy Radius",
  dataAt: "ItineraryPolicies.$ItinPolIndex.Hotel.Policies.$hotelPolItem.Radius",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: "number",
};

const ItineraryPoliciesHotelPoliciesExcludedHotels = {
  displayName: "Excluded Hotels",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Hotel.Policies.$hotelPolItem.ExcludedHotels",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const ItineraryPoliciesHotelPoliciesExcludedChainCodes = {
  displayName: "Excluded Chains",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Hotel.Policies.$hotelPolItem.ExcludedChainCodes",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const ItineraryPoliciesHotelPoliciesMinimumHotelRating = {
  displayName: "Minimum Hotel Rating",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Hotel.Policies.$hotelPolItem.MinimumHotelRating",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: "number",
  min: 0,
  max: 4,
};

const ItineraryPoliciesHotelPoliciesMaximumHotelRating = {
  displayName: "Maximum Hotel Rating",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Hotel.Policies.$hotelPolItem.MaximumHotelRating",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: "number",
  min: 0,
  max: 4,
};

const ItineraryPoliciesHotelPoliciesPostCode = {
  displayName: "Post Code",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Hotel.Policies.$hotelPolItem.PostCode",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const ItineraryPoliciesHotelPoliciesCountryCode = {
  displayName: "Hotel Policies Country Code",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Hotel.Policies.$hotelPolItem.CountryCode",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const ItineraryPoliciesHotelPoliciesLocationCode = {
  displayName: "Hotel Policies Location Code",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Hotel.Policies.$hotelPolItem.LocationCode",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const ItineraryPoliciesHotelPoliciesRateMax = {
  displayName: "Hotel Policies Maximum Rate",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Hotel.Policies.$hotelPolItem.Rate.Max",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: "number",
};

const ItineraryPoliciesHotelPoliciesRateMin = {
  displayName: "Hotel Policies Minimum Rate",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Hotel.Policies.$hotelPolItem.Rate.Min",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: "number",
};

const ItineraryPoliciesHotelPoliciesMostPreferredHotels = {
  displayName: "Most Preferred Hotel IDs",
  dataAt: "ItineraryPolicies.$ItinPolIndex.Hotel.Policies.$hotelPolItem.MostPreferredHotels",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const ItineraryPoliciesHotelPoliciesMostPreferredChainCodes = {
  displayName: "Most Preferred Hotel Chains",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Hotel.Policies.$hotelPolItem.MostPreferredChainCodes",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const ItineraryPoliciesHotelPoliciesHighlyPreferredHotels = {
  displayName: "Highly Preferred Hotel IDs",
  dataAt: "ItineraryPolicies.$ItinPolIndex.Hotel.Policies.$hotelPolItem.HighlyPreferredHotels",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const ItineraryPoliciesHotelPoliciesHighlyPreferredChainCodes = {
  displayName: "Highly Preferred Hotel Chains",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Hotel.Policies.$hotelPolItem.HighlyPreferredChainCodes",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const ItineraryPoliciesHotelPoliciesHotels = {
  displayName: "Preferred Hotel IDs",
  dataAt: "ItineraryPolicies.$ItinPolIndex.Hotel.Policies.$hotelPolItem.Hotels",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const ItineraryPoliciesHotelPoliciesChainCodes = {
  displayName: "Preferred Hotel Chains",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Hotel.Policies.$hotelPolItem.ChainCodes",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const ItineraryPoliciesHotelPoliciesPolicyName = {
  displayName: "Hotel Policy Name",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Hotel.Policies.$hotelPolItem.PolicyName",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const ItineraryPoliciesHotelDisableHotel = {
  displayName: "Disable Hotel",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Hotel.DisableHotel",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const ItineraryPoliciesRailPolicyExceptionsCountries = {
  displayName: "Countries",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Rail.PolicyExceptions.$railPolExcItem.Countries",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const ItineraryPoliciesRailPolicyExceptionsCode = {
  displayName: "Code",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Rail.PolicyExceptions.$railPolExcItem.Code",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const ItineraryPoliciesRailPolicyExceptionsTitle = {
  displayName: "Title",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Rail.PolicyExceptions.$railPolExcItem.Title",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const ItineraryPoliciesRailPoliciesGroupTypes = {
  displayName: "Group Types",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Rail.Policies.$railPolItem.GroupTypes",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const ItineraryPoliciesRailPoliciesPolicyType = {
  displayName: "Policy Type",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Rail.Policies.$railPolItem.PolicyType",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "PolicyTypes",
};

const ItineraryPoliciesRailPoliciesSuppliers = {
  displayName: "Suppliers",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Rail.Policies.$railPolItem.Suppliers",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const ItineraryPoliciesRailPoliciesCorporateCode = {
  displayName: "Corporate Code",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Rail.Policies.$railPolItem.CorporateCode",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const ItineraryPoliciesRailDisableRail = {
  displayName: "Disable Rail",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Rail.DisableRail",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const ItineraryPoliciesFlightPolicyExceptionSettingsBenchmarkMostDirect = {
  displayName: "Benchmark Most Direct",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Flight.PolicyExceptionSettings.$flightPolExcSetItem.BenchmarkMostDirect",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const ItineraryPoliciesFlightPolicyExceptionSettingsFlightType = {
  displayName: "Flight Type",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Flight.PolicyExceptionSettings.$flightPolExcSetItem.FlightType",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "FlightTypes",
};

const ItineraryPoliciesFlightPolicyExceptionSettingsLowestFareGroupType = {
  displayName: "Lowest Fare Group Type",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Flight.PolicyExceptionSettings.$flightPolExcSetItem.LowestFareGroupType",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const ItineraryPoliciesFlightPolicyExceptionSettingsPriceTolerance = {
  displayName: "Price Tolerance",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Flight.PolicyExceptionSettings.$flightPolExcSetItem.PriceTolerance",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: "number",
};

const ItineraryPoliciesFlightPolicyExceptionSettingsPriceToleranceType = {
  displayName: "Price Tolerance Type",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Flight.PolicyExceptionSettings.$flightPolExcSetItem.PriceToleranceType",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "PriceToleranceType",
};

const ItineraryPoliciesFlightPolicyExceptionSettingsGroupTypes = {
  displayName: "Group Types",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Flight.PolicyExceptionSettings.$flightPolExcSetItem.GroupTypes",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const ItineraryPoliciesFlightPolicyExceptionSettingsDurationTo = {
  displayName: "Duration To",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Flight.PolicyExceptionSettings.$flightPolExcSetItem.DurationTo",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: "number",
};

const ItineraryPoliciesFlightPolicyExceptionSettingsDurationFrom = {
  displayName: "Duration From",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Flight.PolicyExceptionSettings.$flightPolExcSetItem.DurationFrom",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: "number",
};

const ItineraryPoliciesFlightPolicyExceptionSettingsDestinationCountryCode = {
  displayName: "Destination Country Code",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Flight.PolicyExceptionSettings.$flightPolExcSetItem.DestinationCountryCode",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const ItineraryPoliciesFlightPolicyExceptionSettingsOriginCountryCode = {
  displayName: "Origin Country Code",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Flight.PolicyExceptionSettings.$flightPolExcSetItem.OriginCountryCode",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const ItineraryPoliciesFlightPolicyExceptionsCountries = {
  displayName: "Countries",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Flight.PolicyExceptions.$flightPolExcItem.Countries",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const ItineraryPoliciesFlightPolicyExceptionsCode = {
  displayName: "Code",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Flight.PolicyExceptions.$flightPolExcItem.Code",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const ItineraryPoliciesFlightPolicyExceptionsTitle = {
  displayName: "Title",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Flight.PolicyExceptions.$flightPolExcItem.Title",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const ItineraryPoliciesLessThanXDayExceptionsTitle = {
  displayName: "Title",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Flight.PolicyLessThanXDays.$flightLessThanXPolItem.Title",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const ItineraryPoliciesLessThanXDayExceptionsCode = {
  displayName: "Code",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Flight.PolicyLessThanXDays.$flightLessThanXPolItem.Code",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const ItineraryPoliciesFlightFlyAmericaPolicyExceptionsTitle = {
  displayName: "Title",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Flight.FlyAmericaPolicy.FlyAmericaPolicyExceptions.$flyAmericaPolicyExceptionItem.Title",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const ItineraryPoliciesFlightFlyAmericaPolicyExceptionsCode = {
  displayName: "Code",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Flight.FlyAmericaPolicy.FlyAmericaPolicyExceptions.$flyAmericaPolicyExceptionItem.Code",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};
const ItineraryPoliciesFlightPoliciesPolicyType = {
  displayName: "Policy Type",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Flight.Policies.$flightPolItem.PolicyType",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "PolicyTypes",
};

const ItineraryPoliciesFlightPoliciesFareClasses = {
  displayName: "Fare Classes",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Flight.Policies.$flightPolItem.FareClasses",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const ItineraryPoliciesFlightPoliciesBrandCodes = {
  displayName: "Brand Codes",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Flight.Policies.$flightPolItem.BrandCodes",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const ItineraryPoliciesFlightPoliciesGroupTypes = {
  displayName: "Group Types",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Flight.Policies.$flightPolItem.GroupTypes",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const ItineraryPoliciesFlightPoliciesDurationTo = {
  displayName: "Duration To",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Flight.Policies.$flightPolItem.DurationTo",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: "number",
};

const ItineraryPoliciesFlightPoliciesDurationFrom = {
  displayName: "Duration From",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Flight.Policies.$flightPolItem.DurationFrom",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: "number",
};

const ItineraryPoliciesFlightPoliciesDurationType = {
  displayName: "Duration Type",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Flight.Policies.$flightPolItem.DurationType",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "DurationTypeOptions",
};

const ItineraryPoliciesFlightPoliciesDestinationCountryCode = {
  displayName: "Destination Country Code",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Flight.Policies.$flightPolItem.DestinationCountryCode",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const ItineraryPoliciesFlightPoliciesOriginCountryCode = {
  displayName: "Origin Country Code",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Flight.Policies.$flightPolItem.OriginCountryCode",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const ItineraryPoliciesFlightPoliciesOriginLocationCode = {
  displayName: "Origin Location Code",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Flight.Policies.$flightPolItem.OriginLocationCode",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const ItineraryPoliciesFlightPoliciesDestinationLocationCode = {
  displayName: "Destination Location Code",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Flight.Policies.$flightPolItem.DestinationLocationCode",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const ItineraryPoliciesFlightPoliciesBookingCodes = {
  displayName: "Booking Codes",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Flight.Policies.$flightPolItem.BookingCodes",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const ItineraryPolicyFlightWeight = {
  displayName: "Weight (Highest weight will apply in conflicting policy settings)",
  dataAt: "ItineraryPolicies.$ItinPolIndex.Flight.Policies.$flightPolItem.Weight",
  displayAs: constants.DISPLAY_AS.RANGE,
  min: 0,
  max: 1000,
  step: 1,
};

const ItineraryPolicyFlightWeightSub = {
  displayAs: constants.DISPLAY_AS.SUB_HEADING,
  label:
    "Exclude of the same weight will be applied over an include.",
};

const ItineraryPoliciesFlightPoliciesCarrier = {
  displayName: "Carrier",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Flight.Policies.$flightPolItem.Carrier",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const ItineraryPoliciesFlightBenchmarksExceptionsOriginLocationCode = {
  displayName: "Origin Location Code",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Flight.Benchmarks.Exceptions.$flightBenchExcItem.OriginLocationCode",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const ItineraryPoliciesFlightBenchmarksExceptionsDestinationLocationCode = {
  displayName: "Destination Location Code",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Flight.Benchmarks.Exceptions.$flightBenchExcItem.DestinationLocationCode",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const ItineraryPoliciesFlightBenchmarksExceptionsCarrier = {
  displayName: "Carrier",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Flight.Benchmarks.Exceptions.$flightBenchExcItem.Carrier",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const ItineraryPoliciesFlightBenchmarksPoliciesBookingCodes = {
  displayName: "Booking Codes",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Flight.Benchmarks.Policies.$flightBenchPolItem.BookingCodes",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const ItineraryPoliciesFlightBenchmarksPoliciesCarrier = {
  displayName: "Carrier",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Flight.Benchmarks.Policies.$flightBenchPolItem.Carrier",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const ItineraryPoliciesItemsTitle = {
  displayName: "Title",
  dataAt: "ItineraryPolicies.$ItinPolIndex.Items.$ItinPolItemIndex.Title",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const ItineraryPoliciesItemsCode = {
  displayName: "Code",
  dataAt: "ItineraryPolicies.$ItinPolIndex.Items.$ItinPolItemIndex.Code",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const DebtorGdsMiQuestionsItemQuestionsItem = {
  displayName: "Question",
  dataAt: "Gds.$GdsItem.MiQuestions.$MiItem.Questions.$question",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    DebtorGdsMiQuestionsItemQuestionsItemQuestion,
    DebtorGdsMiQuestionsItemQuestionsItemAnswerFormat,
  ],
  endpoint: "Debtors",
  removeParamId: "question",
  canDelete: true,
};

const PaymentTypesConfigurationsItem = {
  displayName: "Configuration",
  dataAt:
    "PaymentConfigurations.$payConItem.PaymentTypes.$payConPayTypItem.Configurations.$payTypeConItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    PaymentConfigurationsPaymentTypesConfigurationsSector,
    PaymentConfigurationsPaymentTypesConfigurationsSuppliers,
  ],
  endpoint: "Debtors",
  routeParamId: "debtorId",
  removeParamId: "payTypeConItem",
  canDelete: true,
};

const ItineraryPoliciesCarPolicyRestrictionItem = {
  displayName: "Policy Restriction",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Car.PolicyRestriction.$carPolRestrictedItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    ItineraryPoliciesCarPolicyRestrictionSuppliers,
    ItineraryPoliciesCarPolicyRestrictionLocationCodes,
    ItineraryPoliciesCarPolicyRestrictionCountryCodes,
    ItineraryPoliciesCarPolicyRestrictionSipps,
    ItineraryPoliciesCarPolicyRestrictionMaximumDailyRate,
    ItineraryPoliciesCarPolicyRestrictionPolicyType,
  ],
  endpoint: "Debtors",
  routeParamId: "debtorId",
  removeParamId: "carPolRestrictedItem",
  canDelete: true,
};

const ItineraryPoliciesCarPolicyPreferredItem = {
  displayName: "Policy Preferred",
  dataAt: "ItineraryPolicies.$ItinPolIndex.Car.PolicyPreferred.$carPolPrefItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    ItineraryPoliciesCarPolicyPreferredSuppliers,
    ItineraryPoliciesCarPolicyPreferredLocationCodes,
    ItineraryPoliciesCarPolicyPreferredCountryCodes,
    ItineraryPoliciesCarPolicyPreferredSipps,
  ],
  endpoint: "Debtors",
  routeParamId: "debtorId",
  removeParamId: "carPolPrefItem",
  canDelete: true,
};

const ItineraryPoliciesCarPolicyExceptionSettingsItem = {
  displayName: "Policy Exception Settings",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Car.PolicyExceptionSettings.$carPolExcSetItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    ItineraryPoliciesCarPolicyExceptionSettingsLocationCode,
    ItineraryPoliciesCarPolicyExceptionSettingsCountryCode,
    ItineraryPoliciesCarPolicyExceptionSettingsSupplierCode,
    ItineraryPoliciesCarPolicyExceptionSettingsMaximumDailyRate,
    ItineraryPoliciesCarPolicyExceptionSettingsLocationCodes,
    ItineraryPoliciesCarPolicyExceptionSettingsCountryCodes,
    ItineraryPoliciesCarPolicyExceptionSettingsSuppliers,
    ItineraryPoliciesCarPolicyExceptionSettingsSipps,
  ],
  endpoint: "Debtors",
  routeParamId: "debtorId",
  removeParamId: "carPolExcSetItem",
  canDelete: true,
};

const ItineraryPoliciesCarPolicyExceptionsItem = {
  displayName: "Item",
  dataAt: "ItineraryPolicies.$ItinPolIndex.Car.PolicyExceptions.$carPolExcItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    ItineraryPoliciesCarPolicyExceptionsTitle,
    ItineraryPoliciesCarPolicyExceptionsCode,
    ItineraryPoliciesCarPolicyExceptionsCountries,
  ],
  endpoint: "Debtors",
  routeParamId: "debtorId",
  removeParamId: "carPolExcItem",
  canDelete: true,
};

const ItineraryPoliciesLessThanXDayExceptionsItem = {
  displayName: "Item",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Flight.PolicyLessThanXDays.$flightLessThanXPolItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    ItineraryPoliciesLessThanXDayExceptionsTitle,
    ItineraryPoliciesLessThanXDayExceptionsCode,
  ],
  endpoint: "Debtors",
  routeParamId: "debtorId",
  removeParamId: "flightLessThanXPolItem",
  canDelete: true,
};

const ItineraryPoliciesFlightFlyAmericaPolicyExceptionsItem = {
  displayName: "Item",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Flight.FlyAmericaPolicy.FlyAmericaPolicyExceptions.$flyAmericaPolicyExceptionItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    ItineraryPoliciesFlightFlyAmericaPolicyExceptionsTitle,
    ItineraryPoliciesFlightFlyAmericaPolicyExceptionsCode,
  ],
  endpoint: "Debtors",
  routeParamId: "debtorId",
  removeParamId: "flyAmericaPolicyExceptionItem",
  canDelete: true,
};
const ItineraryPoliciesCarPoliciesItem = {
  displayName: "Car Policy",
  dataAt: "ItineraryPolicies.$ItinPolIndex.Car.Policies.$carPolItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    ItineraryPoliciesCarPoliciesName,
    ItineraryPoliciesCarPoliciesSupplierCode,
    ItineraryPoliciesCarPoliciesSupplierTitle,
    ItineraryPoliciesCarPoliciesCorporateCode,
    ItineraryPoliciesCarPoliciesGuaranteeText,
    ItineraryPoliciesCarPoliciesRate,
    ItineraryPoliciesCarPoliciesDebtorRateOverTravelerId,
    ItineraryPoliciesCarPoliciesBillingReference,
    ItineraryPoliciesCarPoliciesUseCompanyRefCodeForBillingRef,
    ItineraryPoliciesCarPoliciesUseCompanyRefCodeForBillingRefSub,
    ItineraryPoliciesCarPoliciesDepartments,
    ItineraryPoliciesCarPoliciesCostCentres,
    ItineraryPoliciesCarPoliciesAllowDeliveryAndCollection,
  ],
  endpoint: "Debtors",
  routeParamId: "debtorId",
  removeParamId: "carPolItem",
  canDelete: true,
};

const ItineraryPoliciesHotelPoliciesItem = {
  displayName: "Hotel Policy",
  dataAt: "ItineraryPolicies.$ItinPolIndex.Hotel.Policies.$hotelPolItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    ItineraryPoliciesHotelPoliciesPolicyName,
    ItineraryPoliciesHotelPoliciesMostPreferredHotels,
    ItineraryPoliciesHotelPoliciesMostPreferredChainCodes,
    ItineraryPoliciesHotelPoliciesHighlyPreferredHotels,
    ItineraryPoliciesHotelPoliciesHighlyPreferredChainCodes,
    ItineraryPoliciesHotelPoliciesHotels,
    ItineraryPoliciesHotelPoliciesChainCodes,
    ItineraryPoliciesHotelPoliciesRateMax,
    ItineraryPoliciesHotelPoliciesLocationCode,
    ItineraryPoliciesHotelPoliciesCountryCode,
    ItineraryPoliciesHotelPoliciesPostCode,
    ItineraryPoliciesHotelPoliciesMinimumHotelRating,
    ItineraryPoliciesHotelPoliciesMaximumHotelRating,
    ItineraryPoliciesHotelPoliciesExcludedChainCodes,
    ItineraryPoliciesHotelPoliciesExcludedHotels,
    ItineraryPoliciesHotelPoliciesRadius,
    ItineraryPoliciesHotelPoliciesLatitude,
    ItineraryPoliciesHotelPoliciesLongitude,
    ItineraryPoliciesHotelPoliciesLatLong,
  ],
  endpoint: "Debtors",
  routeParamId: "debtorId",
  removeParamId: "hotelPolItem",
  canDelete: true,
};

const ItineraryPoliciesHotelRateCategoriesItem = {
  displayName: "Item",
  dataAt: "ItineraryPolicies.$ItinPolIndex.Hotel.RateCategories.$hotelRCItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    ItineraryPoliciesHotelRateCategoriesCategory,
    ItineraryPoliciesHotelRateCategoriesPriority,
  ],
  endpoint: "Debtors",
  routeParamId: "debtorId",
  removeParamId: "hotelRCItem",
  canDelete: true,
};

const ItineraryPoliciesHotelExcludedAggregatorChainsItem = {
  displayName: "Item",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Hotel.ExcludedAggregatorChains.$hotelEACItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    ItineraryPoliciesHotelExcludedAggregatorChainsAggregator,
    ItineraryPoliciesHotelExcludedAggregatorChainsChains,
  ],
  endpoint: "Debtors",
  routeParamId: "debtorId",
  removeParamId: "hotelEACItem",
  canDelete: true,
};

const ItineraryPoliciesHotelNoHotelPoliciesItem = {
  displayName: "Item",
  dataAt: "ItineraryPolicies.$ItinPolIndex.Hotel.NoHotelPolicies.$hotelNHPItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    ItineraryPoliciesHotelNoHotelPoliciesTitle,
    ItineraryPoliciesHotelNoHotelPoliciesCode,
  ],
  endpoint: "Debtors",
  routeParamId: "debtorId",
  removeParamId: "hotelNHPItem",
  canDelete: true,
};

const ItineraryPoliciesRailPolicyExceptionsItem = {
  displayName: "Item",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Rail.PolicyExceptions.$railPolExcItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    ItineraryPoliciesRailPolicyExceptionsTitle,
    ItineraryPoliciesRailPolicyExceptionsCode,
    ItineraryPoliciesRailPolicyExceptionsCountries,
  ],
  endpoint: "Debtors",
  routeParamId: "debtorId",
  removeParamId: "railPolExcItem",
  canDelete: true,
};

const ItineraryPoliciesRailPoliciesItem = {
  displayName: "Policy",
  dataAt: "ItineraryPolicies.$ItinPolIndex.Rail.Policies.$railPolItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    ItineraryPoliciesRailPoliciesSuppliers,
    ItineraryPoliciesRailPoliciesCorporateCode,
    ItineraryPoliciesRailPoliciesPolicyType,
    ItineraryPoliciesRailPoliciesGroupTypes,
  ],
  endpoint: "Debtors",
  routeParamId: "debtorId",
  removeParamId: "railPolItem",
  canDelete: true,
};

const ItineraryPoliciesFlightPolicyExceptionSettingsItem = {
  displayName: "Item",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Flight.PolicyExceptionSettings.$flightPolExcSetItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    ItineraryPoliciesFlightPolicyExceptionSettingsOriginCountryCode,
    ItineraryPoliciesFlightPolicyExceptionSettingsDestinationCountryCode,
    ItineraryPoliciesFlightPolicyExceptionSettingsDurationFrom,
    ItineraryPoliciesFlightPolicyExceptionSettingsDurationTo,
    ItineraryPoliciesFlightPolicyExceptionSettingsGroupTypes,
    ItineraryPoliciesFlightPolicyExceptionSettingsPriceTolerance,
    ItineraryPoliciesFlightPolicyExceptionSettingsPriceToleranceType,
    ItineraryPoliciesFlightPolicyExceptionSettingsLowestFareGroupType,
    ItineraryPoliciesFlightPolicyExceptionSettingsFlightType,
    ItineraryPoliciesFlightPolicyExceptionSettingsBenchmarkMostDirect,
  ],
  endpoint: "Debtors",
  routeParamId: "debtorId",
  removeParamId: "flightPolExcSetItem",
  canDelete: true,
};

const ItineraryPoliciesFlightPolicyExceptionsItem = {
  displayName: "Item",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Flight.PolicyExceptions.$flightPolExcItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    ItineraryPoliciesFlightPolicyExceptionsTitle,
    ItineraryPoliciesFlightPolicyExceptionsCode,
    ItineraryPoliciesFlightPolicyExceptionsCountries,
  ],
  endpoint: "Debtors",
  routeParamId: "debtorId",
  removeParamId: "flightPolExcItem",
  canDelete: true,
};

const ItineraryPoliciesFlightPoliciesItem = {
  displayName: "Policy",
  dataAt: "ItineraryPolicies.$ItinPolIndex.Flight.Policies.$flightPolItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    ItineraryPolicyFlightWeight,
    ItineraryPolicyFlightWeightSub,
    ItineraryPoliciesFlightPoliciesCarrier,
    ItineraryPoliciesFlightPoliciesBookingCodes,
    ItineraryPoliciesFlightPoliciesDestinationLocationCode,
    ItineraryPoliciesFlightPoliciesOriginLocationCode,
    ItineraryPoliciesFlightPoliciesOriginCountryCode,
    ItineraryPoliciesFlightPoliciesDestinationCountryCode,
    ItineraryPoliciesFlightPoliciesDurationType,
    ItineraryPoliciesFlightPoliciesDurationFrom,
    ItineraryPoliciesFlightPoliciesDurationTo,
    ItineraryPoliciesFlightPoliciesGroupTypes,
    ItineraryPoliciesFlightPoliciesFareClasses,
    ItineraryPoliciesFlightPoliciesBrandCodes,
    ItineraryPoliciesFlightPoliciesPolicyType,
  ],
  endpoint: "Debtors",
  routeParamId: "debtorId",
  removeParamId: "flightPolItem",
  canDelete: true,
};

const ItineraryPoliciesFlightBenchmarksExceptionsItem = {
  displayName: "Item",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Flight.Benchmarks.Exceptions.$flightBenchExcItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    ItineraryPoliciesFlightBenchmarksExceptionsCarrier,
    ItineraryPoliciesFlightBenchmarksExceptionsDestinationLocationCode,
    ItineraryPoliciesFlightBenchmarksExceptionsOriginLocationCode,
  ],
  endpoint: "Debtors",
  routeParamId: "debtorId",
  removeParamId: "flightBenchExcItem",
  canDelete: true,
};

const ItineraryPoliciesFlightBenchmarksPoliciesItem = {
  displayName: "Item",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Flight.Benchmarks.Policies.$flightBenchPolItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    ItineraryPoliciesFlightBenchmarksPoliciesCarrier,
    ItineraryPoliciesFlightBenchmarksPoliciesBookingCodes,
  ],
  endpoint: "Debtors",
  routeParamId: "debtorId",
  removeParamId: "flightBenchPolItem",
  canDelete: true,
};

const ItineraryPoliciesItemsItem = {
  displayName: "Item",
  dataAt: "ItineraryPolicies.$ItinPolIndex.Items.$ItinPolItemIndex",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    {
      displayAs: constants.DISPLAY_AS.SUB_HEADING,
      label: "Employee code from profile",
    },
    ItineraryPoliciesItemsCode,
    ItineraryPoliciesItemsTitle,
  ],
  endpoint: "Debtors",
  routeParamId: "debtorId",
  removeParamId: "ItinPolItemIndex",
  canDelete: true,
};

const DebtorGdsCorporateIdentifiersItemCorporateCode = {
  displayName: "Corporate Code",
  dataAt: "Gds.$GdsItem.CorporateIdentifiers.$corpId.CorporateCode",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const DebtorGdsCorporateIdentifiersItemSupplierCode = {
  displayName: "Supplier Code",
  dataAt: "Gds.$GdsItem.CorporateIdentifiers.$corpId.SupplierCode",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const DebtorGdsMiQuestionsItemQuestions = {
  displayName: "Questions",
  dataAt: "Gds.$GdsItem.MiQuestions.$MiItem.Questions",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: DebtorGdsMiQuestionsItemQuestionsItem,
  gridCols: [
    { name: "Question", key: "Question" },
    { name: "Answer Format", key: "AnswerFormat" },
  ],
};

const DebtorGdsMiQuestionsItemSupplier = {
  displayName: "Supplier",
  dataAt: "Gds.$GdsItem.MiQuestions.$MiItem.Supplier",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const PaymentConfigurationsPaymentTypesConfigurations = {
  displayName: "Configurations",
  dataAt:
    "PaymentConfigurations.$payConItem.PaymentTypes.$payConPayTypItem.Configurations",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: PaymentTypesConfigurationsItem,
  gridCols: [{ name: "Sector", key: "Sector" }],
};

const PaymentConfigurationsPaymentTypesIsOptionalPaymentType = {
  displayName: "Is Optional Payment",
  dataAt:
    "PaymentConfigurations.$payConItem.PaymentTypes.$payConPayTypItem.IsOptionalPaymentType",
  displayAs: constants.DISPLAY_AS.BOOLEAN
};
const PaymentConfigurationsPaymentTypesType = {
  displayName: "Type",
  dataAt:
    "PaymentConfigurations.$payConItem.PaymentTypes.$payConPayTypItem.Type",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "PaymentTypes",
};

const CompanyReferencesChildrenMandatory = {
  displayName: "Mandatory",
  dataAt: "CompanyReferences.$compRefItem.Children.$compRefChildItem.Mandatory",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const CompanyReferencesChildrenFlags = {
  displayName: "Flags",
  dataAt: "CompanyReferences.$compRefItem.Children.$compRefChildItem.Flags",
  displayAs: constants.DISPLAY_AS.MULTI_SELECT,
  optionsAt: "CompanyReferencesFlags",
};

const CompanyReferencesChildrenOptions = {
  displayName: "Options",
  dataAt: "CompanyReferences.$compRefItem.Children.$compRefChildItem.Options",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
  helpText: "Use a pipe | to delineate a value and display. \r\nExample: Y|Yes \r\nThis will display Yes to the booker and capture Y as the value."
};

const CompanyReferencesChildrenTitle = {
  displayName: "Title",
  dataAt: "CompanyReferences.$compRefItem.Children.$compRefChildItem.Title",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  validationMessage: "Title is required. Max length 100",
  validationRegex: "^.{1,100}$"
};

const CompanyReferencesChildrenPlaceHolderText = {
  displayName: "PlaceHolder Text",
  dataAt: "CompanyReferences.$compRefItem.Children.$compRefChildItem.PlaceHolderText",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const CompanyReferencesChildrenCode = {
  displayName: "Code",
  dataAt: "CompanyReferences.$compRefItem.Children.$compRefChildItem.Code",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  validationMessage: "Code is required. Max length 50",
  validationRegex: "^.{1,50}$"
};

const CompanyReferencesChildrenListId = {
  displayName: "ListId",
  dataAt: "CompanyReferences.$compRefItem.Children.$compRefChildItem.ListId",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const CompanyReferencesChildrenMatch = {
  displayName: "Match",
  dataAt: "CompanyReferences.$compRefItem.Children.$compRefChildItem.Match",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const ItineraryPoliciesCarPolicyRestriction = {
  displayName: "Policy Restriction",
  dataAt: "ItineraryPolicies.$ItinPolIndex.Car.PolicyRestriction",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: ItineraryPoliciesCarPolicyRestrictionItem,
  gridCols: [
    { name: "PolicyType", key: "PolicyType" },
    { name: "Suppliers", key: "Suppliers" },
    { name: "Sipps", key: "Sipps" },
    { name: "MaxRate", key: "MaximumDailyRate" },
    { name: "Location", key: "LocationCodes" },
    { name: "Country", key: "CountryCodes" },
  ],
};

const ItineraryPoliciesCarPolicyPreferred = {
  displayName: "Policy Preferred",
  dataAt: "ItineraryPolicies.$ItinPolIndex.Car.PolicyPreferred",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: ItineraryPoliciesCarPolicyPreferredItem,
  gridCols: [
    { name: "Suppliers", key: "Suppliers" },
    { name: "Sipps", key: "Sipps" },
    { name: "LocationCodes", key: "LocationCodes" },
    { name: "CountryCodes", key: "CountryCodes" },
  ],
};

const ItineraryPoliciesCarPolicyExceptionSettings = {
  displayName: "Policy Exception Settings",
  dataAt: "ItineraryPolicies.$ItinPolIndex.Car.PolicyExceptionSettings",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: ItineraryPoliciesCarPolicyExceptionSettingsItem,
  gridCols: [
    { name: "Location", key: "LocationCodes" },
    { name: "Country", key: "CountryCodes" },
    { name: "Suppliers", key: "Suppliers" },
    { name: "Sipps", key: "Sipps" },
    { name: "Max Rate", key: "MaximumDailyRate" },
  ],
};

const ItineraryPoliciesCarPolicyExceptions = {
  displayName: "Policy Exceptions",
  dataAt: "ItineraryPolicies.$ItinPolIndex.Car.PolicyExceptions",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: ItineraryPoliciesCarPolicyExceptionsItem,
  gridCols: [
    { name: "Title", key: "Title" },
    { name: "Code", key: "Code" },
  ],
};

const ItineraryPoliciesCarSettingsExcludedRates = {
  displayName: "Car Excluded Rates",
  dataAt: "ItineraryPolicies.$ItinPolIndex.Car.Settings.ExcludedRates",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const ItineraryPoliciesCarSettingsExcludedProviders = {
  displayName: "Car Excluded Providers",
  dataAt: "ItineraryPolicies.$ItinPolIndex.Car.Settings.ExcludedProviders",
  displayAs: constants.DISPLAY_AS.MULTI_SELECT,
  optionsAt: "GDSProviders",
};

const ItineraryPoliciesCarSettingsRateCodes = {
  displayName: "Car Rate Codes",
  dataAt: "ItineraryPolicies.$ItinPolIndex.Car.Settings.RateCodes",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const ItineraryPoliciesCarTypeDuplicateHandling = {
  displayName: "Car Type Duplicate Handling",
  dataAt: "ItineraryPolicies.$ItinPolIndex.Car.CarTypeDuplicateHandling",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "CarTypeDuplicateHandlingTypes",
};

const ItineraryPoliciesCarSettingsShowRatesWithDeposits = {
  displayName: "Show Rates that Require Deposits (Sabre Only)",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Car.ShowRatesWithDeposits",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const ItineraryPoliciesCarPolicies = {
  displayName: "Car Policies",
  dataAt: "ItineraryPolicies.$ItinPolIndex.Car.Policies",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: ItineraryPoliciesCarPoliciesItem,
  gridCols: [
    { name: "Policy Name", key: "Name" },
    { name: "Corporate Code", key: "CorporateCode" },
    { name: "Rate", key: "Rate" },
    { name: "Supplier", key: "Supplier.Title" },
    { name: "Code", key: "Supplier.Code" },
  ],
};

const ItineraryPoliciesHotelPoliciesLatLngMap = {
  displayName: "Policies Lat Long Map",
  dataAt: "ItineraryPolicies.$ItinPolIndex.Hotel.Policies",
  displayAs: constants.DISPLAY_AS.LAT_LNG_MAP,
};

const ItineraryPoliciesHotelDefaultPolicyRateMax = {
  displayName: "Hotel Policy Default Maximum Rate",
  dataAt: "ItineraryPolicies.$ItinPolIndex.Hotel.DefaultPolicy.Rate.Max",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: "number",
};

const ItineraryPoliciesHotelDefaultPolicyRateMin = {
  displayName: "Hotel Policy Default Minimum Rate",
  dataAt: "ItineraryPolicies.$ItinPolIndex.Hotel.DefaultPolicy.Rate.Min",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: "number",
};

const ItineraryPoliciesHotelSettingsExcludeDepositRequiredAndPrepayRates = {
  displayName: "Exclude Rates That Require Deposit/Prepay (Sabre Only)",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Hotel.Settings.ExcludeDepositRequiredAndPrepayRates",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const ItineraryPoliciesHotelSettingsExcludeHotelOtherExcludedKeywords = {
  displayName:
    "Exclude Other Rates By System-level Keywords (Sourced from Sabre)",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Hotel.Settings.ExcludeHotelOtherExcludedKeywords",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const ItineraryPoliciesHotelSettingsExcludeNonRefundableRates = {
  displayName: "Exclude Non-Refundable Rates (Sourced from Sabre)",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Hotel.Settings.ExcludeNonRefundableRates",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

// this should be removed in teh future
const ItineraryPoliciesHotelDefaultPolicyBenchmarkPreferredAgainstCheapestPreferred =
  {
    displayName: "Benchmark Preferred Against Cheapest Preferred",
    dataAt:
      "ItineraryPolicies.$ItinPolIndex.Hotel.DefaultPolicy.BenchmarkPreferredAgainstCheapestPreferred",
    displayAs: constants.DISPLAY_AS.BOOLEAN
  };

const ItineraryPoliciesHotelSettingsExcludedRates = {
  displayName: "Hotel Excluded Rates",
  dataAt: "ItineraryPolicies.$ItinPolIndex.Hotel.Settings.ExcludedRates",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const ItineraryPoliciesHotelSettingsIncludedRates = {
  displayName: "Restrict Rates by Keyword",
  dataAt: "ItineraryPolicies.$ItinPolIndex.Hotel.Settings.RestrictRatesByKeywords",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const ItineraryPoliciesHotelSettingsExcludedProviders = {
  displayName: "Hotel Excluded Providers",
  dataAt: "ItineraryPolicies.$ItinPolIndex.Hotel.Settings.ExcludedProviders",
  displayAs: constants.DISPLAY_AS.MULTI_SELECT,
  optionsAt: "GDSProviders",
};

const ItineraryPoliciesHotelSettingsExcludedAggregators = {
  displayName: "Hotel Excluded Aggregators",
  dataAt: "ItineraryPolicies.$ItinPolIndex.Hotel.Settings.ExcludedAggregators",
  displayAs: constants.DISPLAY_AS.O_DATA_SELECT,
  endpoint: "Settings",
  queryOption: "select",
  selectProperty: "HotelRateCategories",
  inputTitle: "Name",
  selectChoiceName: "Name",
  entityIdentifier: "Name",
  searchAllNo: true,
  isMultiSelect: true,
  additionalFilters: {
    "IsAggregator": true
  },
  showOnlySelectedField: true
};

const HotelEnableAggregators = {
  displayName: "Hotel Excluded Providers",
  dataAt: "ItineraryPolicies.$ItinPolIndex.Hotel.Settings.ExcludedProviders",
  displayAs: constants.DISPLAY_AS.MULTI_SELECT,
  optionsAt: "GDSProviders",
};

const ItineraryPoliciesHotelSettingsRateCodes = {
  displayName: "Hotel Rate Codes",
  dataAt: "ItineraryPolicies.$ItinPolIndex.Hotel.Settings.RateCodes",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const ItineraryPoliciesHotelSettingsApplyVirtualCreditCard = {  
  displayName: "Apply Virtual Credit Card",
  dataAt: "ItineraryPolicies.$ItinPolIndex.Hotel.Settings.ApplyVirtualCreditCard",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "HotelApplyVirtualCreditCardTypes",
  defaultValue: "UseagencyVCCconfig",
}

const ItineraryPoliciesHotelSettingsPolicyType = {
  displayName: "Hotel Policy Type",
  dataAt: "ItineraryPolicies.$ItinPolIndex.Hotel.Settings.PolicyType",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "HotelPolicyTypes",
  defaultValue: "PreferredFirst",
};

const ItineraryPoliciesHotelSettingsPerNightRateDisplay = {  
  displayName: "Per Night Rate Display",
  dataAt: "ItineraryPolicies.$ItinPolIndex.Hotel.Settings.PerNightRateDisplay",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "HotelPerNightRateDisplayTypes",
  defaultValue: "Highest",
}

const ItineraryPoliciesHotelPolicies = {
  displayName: "Policies",
  dataAt: "ItineraryPolicies.$ItinPolIndex.Hotel.Policies",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: ItineraryPoliciesHotelPoliciesItem,
  gridCols: [
    { name: "Policy Name", key: "PolicyName" },
    { name: "Location Code", key: "LocationCode" },
    { name: "Country Code", key: "CountryCode" },
  ],
};

const ItineraryPoliciesHotelRateCategories = {
  displayName: "Hotel Rate Categories",
  dataAt: "ItineraryPolicies.$ItinPolIndex.Hotel.RateCategories",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: ItineraryPoliciesHotelRateCategoriesItem,
  gridCols: [
    { name: "Rate Category", key: "Category" },
    { name: "Priority", key: "Priority" },
  ],
  sortable: true,
  htmlInner: "<small>All rows are shown. <br/>Sort rows by dragging and dropping to desired order for shopping results.</small>"
};

const ItineraryPoliciesHotelExcludedAggregatorChains = {
  displayName: "Exclude Aggregator Rates by Chain",
  dataAt: "ItineraryPolicies.$ItinPolIndex.Hotel.ExcludedAggregatorChains",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: ItineraryPoliciesHotelExcludedAggregatorChainsItem,
  gridCols: [
    { name: "Aggregator", key: "Aggregator" },
    { name: "Chains", key: "Chains" },
  ],
};

const ItineraryPoliciesHotelNoHotelPolicies = {
  displayName: "No Hotel Policy",
  dataAt: "ItineraryPolicies.$ItinPolIndex.Hotel.NoHotelPolicies",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: ItineraryPoliciesHotelNoHotelPoliciesItem,
  gridCols: [
    { name: "Title", key: "Title" },
    { name: "Code", key: "Code" },
  ],
};

const ItineraryPoliciesHotelSettingsEnablePerDiemRates = {
  displayName: "Per Diem Rates Enabled",
  dataAt: "ItineraryPolicies.$ItinPolIndex.Hotel.Settings.EnablePerDiemRates",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const ItineraryPoliciesHotelSettingsShowRatesWithinPerDiem = {
  displayName: "Show Only Rates Within Per Diem",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Hotel.Settings.ShowRatesWithinPerDiem",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const ItineraryPoliciesRailExcludedSuppliers = {
  displayName: "Rail Excluded Suppliers",
  dataAt: "ItineraryPolicies.$ItinPolIndex.Rail.ExcludedSuppliers",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const ItineraryPoliciesRailPolicyExceptions = {
  displayName: "Policy Exceptions",
  dataAt: "ItineraryPolicies.$ItinPolIndex.Rail.PolicyExceptions",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: ItineraryPoliciesRailPolicyExceptionsItem,
  gridCols: [
    { name: "Title", key: "Title" },
    { name: "Code", key: "Code" },
  ],
};

const ItineraryPoliciesRailPolicies = {
  displayName: "Policies",
  dataAt: "ItineraryPolicies.$ItinPolIndex.Rail.Policies",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: ItineraryPoliciesRailPoliciesItem,
  gridCols: [
    { name: "Suppliers", key: "Suppliers" },
    { name: "Corporate Code", key: "CorporateCode" },
    { name: "Policy Type", key: "PolicyType" },
    { name: "Group Type", key: "GroupTypes" },
  ],
};

const ItineraryPoliciesFlightPolicyExceptionSettings = {
  displayName: "Policy Exception Settings",
  dataAt: "ItineraryPolicies.$ItinPolIndex.Flight.PolicyExceptionSettings",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: ItineraryPoliciesFlightPolicyExceptionSettingsItem,
  gridCols: [
    { name: "Origin", key: "OriginCountryCode" },
    {
      name: "Dest",
      key: "DestinationCountryCode",
    },
    { name: "Type", key: "FlightType" },
    { name: "LLFGroup", key: "LowestFareGroupType" },
    { name: "GroupTypes", key: "GroupTypes" },
    { name: "MostDirect", key: "BenchmarkMostDirect" },
    { name: "Tolerance", key: "PriceTolerance" },
  ],
};

const ItineraryPoliciesFlightPolicyExceptionExcludedCarriers = {
  displayName: "Policy Exception Excluded Carriers",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Flight.PolicyExceptionExcludedCarriers",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
  validationRegex: "^$|^[A-Za-z0-9]{2}(?:[\\s,]+[A-Za-z0-9]{2})*$",
  validationMessage: "Use 2-character carrier codes (letters or numbers), e.g., AA, F9.",
};

const ItineraryPoliciesFlightEnableAncillaryFees = {
  displayName: "Policy Enable Ancillary Fees",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Flight.EnableAncillaryFees",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};
const ItineraryPoliciesFlightAncillaryFeeCodes = {
  displayName: "Policy Ancillary Fee Codes",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Flight.AncillaryFeeCodes",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const ItineraryPoliciesFlightPolicyLeadTimeForInPolicyBooking = {
  displayName: "Lead Time for In-Policy Booking",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Flight.PolicyLeadTimeForInPolicyBooking",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  //validationRegex: '[0-9]',
  //validationMessage: 'Only numbers'
};

const ItineraryPoliciesFlightPolicyExceptions = {
  displayName: "Policy Exceptions",
  dataAt: "ItineraryPolicies.$ItinPolIndex.Flight.PolicyExceptions",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: ItineraryPoliciesFlightPolicyExceptionsItem,
  gridCols: [
    { name: "Title", key: "Title" },
    { name: "Code", key: "Code" },
  ],
};

const ItineraryPoliciesFlightSettingsRateCodes = {
  displayName: "Flight Rate Codes",
  dataAt: "ItineraryPolicies.$ItinPolIndex.Flight.Settings.RateCodes",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
  validationItemLimit: "4",
  validationMessage: "The number of RateCodes is not allowed. Max 4.",
};

const ItineraryPoliciesFlightSettingsPolicyType = {
  displayName: "Flight Policy Type",
  dataAt: "ItineraryPolicies.$ItinPolIndex.Flight.Settings.PolicyType",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "AirlinePolicyTypes",
};

const ItineraryPoliciesFlightFlyAmericaActPolicyType = {
  displayName: "Fly America Act Policy Type",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Flight.FlyAmericaPolicy.FlyAmericaPolicyType",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "FlightFlyAmericaPolicyType",
};

const ItineraryPoliciesFlightFlyAmericaPolicyEnableExcludeNonCompliantFlights =
  {
    displayName: "Fly America Act Exclude Non Compliant Flights",
    dataAt:
      "ItineraryPolicies.$ItinPolIndex.Flight.FlyAmericaPolicy.FlyAmericaActExcludeNonCompliantFlights",
    displayAs: constants.DISPLAY_AS.BOOLEAN,
  };

const ItineraryPoliciesFlightSettingsExcludedRates = {
  displayName: "Flight Excluded Rates",
  dataAt: "ItineraryPolicies.$ItinPolIndex.Flight.Settings.ExcludedRates",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const ItineraryPoliciesFlightSettingsExcludedProviders = {
  displayName: "Flight Excluded Providers",
  dataAt: "ItineraryPolicies.$ItinPolIndex.Flight.Settings.ExcludedProviders",
  displayAs: constants.DISPLAY_AS.MULTI_SELECT,
  optionsAt: "GDSProviders",
};

const ItineraryPoliciesFlightPolicies = {
  displayName: "Policies",
  dataAt: "ItineraryPolicies.$ItinPolIndex.Flight.Policies",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: ItineraryPoliciesFlightPoliciesItem,
  gridCols: [
    { name: "Crr", key: "Carrier" },
    { name: "CtyDest",key: "DestinationLocationCode",},
    { name: "CtyOrig", key: "OriginLocationCode" },
    { name: "CtryDest",key: "DestinationCountryCode",},
    { name: "CtryOrig", key: "OriginCountryCode" },
    { name: "Policy", key: "PolicyType" },
    { name: "Duration", key: "DurationType" },
    { name: "Groups", key: "GroupTypes" },
    { name: "FareCls", key: "FareClasses" },
    { name: "Brand", key: "BrandCodes" },
    { name: "Weight", key: "Weight" }
  ],
};

const ItineraryPoliciesFlightBenchmarksExceptions = {
  displayName: "Benchmark Exceptions",
  dataAt: "ItineraryPolicies.$ItinPolIndex.Flight.Benchmarks.Exceptions",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: ItineraryPoliciesFlightBenchmarksExceptionsItem,
  gridCols: [
    { name: "Carrier", key: "Carrier" },
    {
      name: "DestinationLocationCode",
      key: "DestinationLocationCode",
    },
    { name: "OriginLocationCode", key: "OriginLocationCode" },
  ],
};

const ItineraryPoliciesFlightLowLogicFareTimeWindowType = {
  displayName: 'Time Window',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Flight.FlightLowestLogicalFareSettings.TimeWindowType',
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: 'FlighLowLogicFareTimeWindowType',
  defaultValue: 'CompanyTimeWindow'
};

const ItineraryPoliciesFlightLowLogicFareTimeWindowDefinedType = {
  displayName: 'Time Window Value',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Flight.FlightLowestLogicalFareSettings.TimeWindow',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const ItineraryPoliciesFlightLowLogicFareContractType = {
  displayName: 'Has Contract',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Flight.FlightLowestLogicalFareSettings.ContractType',
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: 'FlighLowLogicFareContractType',
  defaultValue: 'DoesNotMatter'
};

const ItineraryPoliciesFlightLowLogicFareStopType = {
  displayName: 'Number of Stops',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Flight.FlightLowestLogicalFareSettings.StopType',
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: 'FlighLowLogicFareStopType',
  defaultValue: 'DoesNotMatter'
};

const ItineraryPoliciesFlightLowLogicFareRefundability = {
  displayName: 'Refundability',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Flight.FlightLowestLogicalFareSettings.RefundType',
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: 'RefundabilityOptions',
  defaultValue: 'DoesNotMatter'
};

const ItineraryPoliciesLessThanXDayExceptions = {
  displayName: "Lead Time for In-Policy Booking Exceptions",
  dataAt: "ItineraryPolicies.$ItinPolIndex.Flight.PolicyLessThanXDays",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: ItineraryPoliciesLessThanXDayExceptionsItem,
  gridCols: [
    { name: "Title", key: "Title" },
    { name: "Code", key: "Code" },
  ],
};

const ItineraryPoliciesFlightFlyAmericaPolicyExceptions = {
  displayName: "Fly America Policy Exceptions",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Flight.FlyAmericaPolicy.FlyAmericaPolicyExceptions",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: ItineraryPoliciesFlightFlyAmericaPolicyExceptionsItem,
  gridCols: [
    { name: "Title", key: "Title" },
    { name: "Code", key: "Code" },
  ],
};

const ItineraryPoliciesFlightBenchmarksPolicies = {
  displayName: "Benchmark Policies",
  dataAt: "ItineraryPolicies.$ItinPolIndex.Flight.Benchmarks.Policies",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: ItineraryPoliciesFlightBenchmarksPoliciesItem,
  gridCols: [{ name: "Carrier", key: "Carrier" }],
};

const ItineraryPoliciesFlightLowLogicFare = {
  tabName: 'Flight-Lowest-Logical-Fare',
  dataAt: '',
  displayAs: constants.DISPLAY_AS.GROUP,
  children: [ItineraryPoliciesFlightLowLogicFareTimeWindowType,ItineraryPoliciesFlightLowLogicFareTimeWindowDefinedType,ItineraryPoliciesFlightLowLogicFareContractType,ItineraryPoliciesFlightLowLogicFareStopType,ItineraryPoliciesFlightLowLogicFareRefundability]
};

const ItineraryPoliciesFlightDisableFlight = {
  displayName: "Disable Flight",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Flight.DisableFlight",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const ItineraryPoliciesPaidSeatsEnabledType = {
  displayName: "Enable Paid Seats",
  dataAt: "ItineraryPolicies.$ItinPolIndex.Flight.PaidSeatsEnabled",
  displayAs: constants.DISPLAY_AS.SELECT,
  defaultValue: "DebtorConfiguration",
  optionsAt: "PaidSeatsEnabledType",
};

const ItineraryPoliciesGroundTransportationPreferredVendors = {
  displayName: "Preferred Vendors",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.GroundTransportation.PreferredVendors",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const ItineraryPoliciesGroundTransportationExcludedVendors = {
  displayName: "Excluded Vendors",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.GroundTransportation.ExcludedVendors",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const ItineraryPoliciesGroundTransportationDisableGroundTransportation = {
  displayName: "Disable Ground Transportation",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.GroundTransportation.DisableGroundTransportation",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const ItineraryPoliciesGroundTransportationIgnoreProviderPreferred = {
  displayName: "Ignore Provider Preferred",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.GroundTransportation.IgnoreProviderPreferred",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const ItineraryPoliciesItems = {
  displayName: "Items",
  dataAt: "ItineraryPolicies.$ItinPolIndex.Items",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: ItineraryPoliciesItemsItem,
  gridCols: [
    { name: "Code", key: "Code" },
    { name: "Title", key: "Title" },
  ],
};

const ItineraryPoliciesAgencyReasonCodes = {
  displayName: "Agency Reason Codes",
  dataAt: "ItineraryPolicies.$ItinPolIndex.AgencyReasonCodes",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const ItineraryPoliciesMultiPaxPnrHandlingType = {  
  displayName: "Multi Passenger Pnr Handling",
  dataAt: "ItineraryPolicies.$ItinPolIndex.PolicyMultiPaxPnrHandling",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "PolicyDebtorMultiPaxPnrHandlingType",
  defaultValue: "DebtorConfiguration",
}

const ItineraryPoliciesGuestTravelType = {  
  displayName: "Guest Traveler",
  dataAt: "ItineraryPolicies.$ItinPolIndex.PolicyGuestTravelType",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "DebtorPolicyGuestTravelType",
  defaultValue: "EnableArrangerOnly",
}

const DebtorApproversTravellersEmail = {
  displayName: "Email",
  dataAt:
    "DebtorApprovers.$debtorApproversIndex.Travellers.$travellersIndex.Email",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: "email",
};

const DebtorApproversTravellersTitle = {
  displayName: "Title",
  dataAt:
    "DebtorApprovers.$debtorApproversIndex.Travellers.$travellersIndex.Title",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const DebtorApproversTravellersId = {
  displayName: "Id",
  dataAt:
    "DebtorApprovers.$debtorApproversIndex.Travellers.$travellersIndex.Id",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const DebtorGdsCorporateIdentifiersItem = {
  displayName: "Corporate Identifiers Item",
  dataAt: "Gds.$GdsItem.CorporateIdentifiers.$corpId",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    DebtorGdsCorporateIdentifiersItemSupplierCode,
    DebtorGdsCorporateIdentifiersItemCorporateCode,
  ],
  endpoint: "Debtors",
  removeParamId: "corpId",
  canDelete: true,
};

const DebtorGdsMiQuestionsItem = {
  displayName: "Mi Questions Item",
  dataAt: "Gds.$GdsItem.MiQuestions.$MiItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    DebtorGdsMiQuestionsItemSupplier,
    DebtorGdsMiQuestionsItemQuestions,
  ],
  endpoint: "Debtors",
  removeParamId: "MiItem",
  canDelete: true,
};

const PaymentTypesItem = {
  displayName: "Payment Type",
  dataAt: "PaymentConfigurations.$payConItem.PaymentTypes.$payConPayTypItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    PaymentConfigurationsPaymentTypesType,
    PaymentConfigurationsPaymentTypesIsOptionalPaymentType,
    PaymentConfigurationsPaymentTypesConfigurations,
  ],
  endpoint: "Debtors",
  routeParamId: "debtorId",
  removeParamId: "payConPayTypItem",
  canDelete: true,
};

const CompanyReferencesChildrenItem = {
  displayName: "Children",
  dataAt: "CompanyReferences.$compRefItem.Children.$compRefChildItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    CompanyReferencesChildrenMatch,
    {
      displayAs: constants.DISPLAY_AS.SUB_HEADING,
      label: "Match options",
    },
    {
      displayAs: constants.DISPLAY_AS.SUB_HEADING,
      label: "Default: value equals parent value",
    },
    {
      displayAs: constants.DISPLAY_AS.SUB_HEADING,
      label:
        "Regular Expression: prepending <regex> to value match value. Example: <regex>^[0-9]{1,1}",
    },
    CompanyReferencesChildrenCode,
    CompanyReferencesChildrenTitle,
    CompanyReferencesChildrenPlaceHolderText,
    CompanyReferencesChildrenListId,
    CompanyReferencesChildrenOptions,
    CompanyReferencesChildrenFlags,
    CompanyReferencesChildrenMandatory,
  ],
  endpoint: "Debtors",
  routeParamId: "debtorId",
  removeParamId: "compRefChildItem",
  canDelete: true,
};

const ItineraryPoliciesCar = {
  tabName: "Car",
  dataAt: "",
  displayAs: constants.DISPLAY_AS.GROUP,
  children: [
    ItineraryPoliciesCarDisableCar,
    ItineraryPoliciesCarPolicies,
    ItineraryPoliciesCarTypeDuplicateHandling,
    ItineraryPoliciesCarSettingsShowRatesWithDeposits,
    ItineraryPoliciesCarSettingsRateCodes,
    ItineraryPoliciesCarSettingsExcludedProviders,
    ItineraryPoliciesCarSettingsExcludedRates,
    ItineraryPoliciesCarPolicyExceptions,
    ItineraryPoliciesCarPolicyExceptionSettings,
    ItineraryPoliciesCarPolicyPreferred,
    ItineraryPoliciesCarPolicyRestriction,
  ],
};

const ItineraryPoliciesHotel = {
  tabName: "Hotel",
  dataAt: "",
  displayAs: constants.DISPLAY_AS.GROUP,
  children: [
    ItineraryPoliciesHotelDisableHotel,
    ItineraryPoliciesHotelPolicies,
    ItineraryPoliciesHotelSettingsApplyVirtualCreditCard,
    ItineraryPoliciesHotelSettingsPolicyType,
    ItineraryPoliciesHotelSettingsPerNightRateDisplay,
    ItineraryPoliciesHotelSettingsRateCodes,
    ItineraryPoliciesHotelNoHotelPolicies,
    ItineraryPoliciesHotelNoHotelPoliciesInfo,
    ItineraryPoliciesHotelRateCategories,
    ItineraryPoliciesHotelSettingsEnablePerDiemRates,
    ItineraryPoliciesHotelSettingsShowRatesWithinPerDiem,
    ItineraryPoliciesHotelSettingsExcludedProviders,
    ItineraryPoliciesHotelSettingsExcludedAggregators,
    ItineraryPoliciesHotelExcludedAggregatorChains,
    ItineraryPoliciesHotelSettingsIncludedRates,
    ItineraryPoliciesHotelSettingsExcludedRates,
    ItineraryPoliciesHotelSettingsExcludeDepositRequiredAndPrepayRates,
    ItineraryPoliciesHotelSettingsExcludeNonRefundableRates,
    ItineraryPoliciesHotelSettingsExcludeHotelOtherExcludedKeywords,
    ItineraryPoliciesHotelDefaultPolicyRateMax,
    ItineraryPoliciesHotelPoliciesLatLngMap,
  ],
};

const ItineraryPoliciesHotelPolicyExceptionSettingsItem = {
  displayName: "Policy Exception Settings",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Hotel.PolicyExceptionSettings.$ItinPolExcSetItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    ItineraryPoliciesHotelPolicyExceptionSettingsName,
    ItineraryPoliciesHotelPolicyExceptionSettingsLocationCode,
    ItineraryPoliciesHotelPolicyExceptionSettingsAirportCodes,
    ItineraryPoliciesHotelPolicyExceptionSettingsHotelIDs,
    ItineraryPoliciesHotelPolicyExceptionSettingsCountryCode,
    ItineraryPoliciesHotelPolicyExceptionSettingsMaximumDailyRate,
    ItineraryPoliciesHotelPolicyExceptionSettingsPriceTolerance,
    ItineraryPoliciesHotelPolicyExceptionSettingsPriceToleranceType,
    ItineraryPoliciesHotelPolicyExceptionSettingsRadius,
    ItineraryPoliciesHotelPolicyExceptionSettingsLatitude,
    ItineraryPoliciesHotelPolicyExceptionSettingsLongitude,
    ItineraryPoliciesHotelPolicyExceptionSettingsLatLong,
  ],
  endpoint: "Debtors",
  routeParamId: "debtorId",
  removeParamId: "ItinPolExcSetItem",
  canDelete: true,
};

const ItineraryPoliciesHotelPolicyExceptionsItem = {
  displayName: "Item",
  dataAt:
    "ItineraryPolicies.$ItinPolIndex.Hotel.PolicyExceptions.$hotelPolExcItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    ItineraryPoliciesHotelPolicyExceptionsTitle,
    ItineraryPoliciesHotelPolicyExceptionsCode,
    ItineraryPoliciesHotelPolicyExceptionsCountries,
  ],
  endpoint: "Debtors",
  routeParamId: "debtorId",
  removeParamId: "hotelPolExcItem",
  canDelete: true,
};

const ItineraryPoliciesHotelPolicyExceptions = {
  displayName: "Policy Exceptions",
  dataAt: "ItineraryPolicies.$ItinPolIndex.Hotel.PolicyExceptions",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: ItineraryPoliciesHotelPolicyExceptionsItem,
  gridCols: [
    { name: "Title", key: "Title" },
    { name: "Code", key: "Code" },
  ],
};

const ItineraryPoliciesHotelPolicyExceptionSettings = {
  displayName: "Policy Exception Settings",
  dataAt: "ItineraryPolicies.$ItinPolIndex.Hotel.PolicyExceptionSettings",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: ItineraryPoliciesHotelPolicyExceptionSettingsItem,
  gridCols: [
    { name: "Name", key: "Name" },
    { name: "Location Code", key: "LocationCode" },
    { name: "Airport Codes", key: "AirportCodes" },
    { name: "Country Code", key: "CountryCode" },
    { name: "Maximum Daily Rate", key: "MaximumDailyRate" },
  ],
};

const ItineraryPoliciesHotelBenchmarkingPreferredBenchmarkAgainst = {
  displayName: "Benchmark Against",
  dataAt: "ItineraryPolicies.$ItinPolIndex.Hotel.Benchmarking.Preferred.BenchmarkAgainst",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "ItineraryPoliciesHotelBenchmarkingBenchmarkAgainst",
};

const ItineraryPoliciesHotelBenchmarkingPreferredStarRatingMinimum = {
  displayName: "Star Rating Minimum",
  dataAt: "ItineraryPolicies.$ItinPolIndex.Hotel.Benchmarking.Preferred.StarRatingMinimum",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "ItineraryPoliciesHotelBenchmarkingStarRating",
};

const ItineraryPoliciesHotelBenchmarkingPreferredExcludeRateCategoriesForBenchmark = {
  displayName: "Exclude Rate Categories For Benchmark",
  dataAt: "ItineraryPolicies.$ItinPolIndex.Hotel.Benchmarking.Preferred.ExcludeRateCategoriesForBenchmark",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
  html:"<p class='help-block'>Type the <strong>Rate Categories</strong> from <a href='/#/settings/hotel' target='_blank'>System Settings - Hotel</a></p>"
};

const ItineraryPoliciesHotelBenchmarkingNonPreferredBenchmarkAgainst = {
  displayName: "Benchmark Against",
  dataAt: "ItineraryPolicies.$ItinPolIndex.Hotel.Benchmarking.NonPreferred.BenchmarkAgainst",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "ItineraryPoliciesHotelBenchmarkingBenchmarkAgainst",
};

const ItineraryPoliciesHotelBenchmarkingNonPreferredStarRatingMinimum = {
  displayName: "Star Rating Minimum",
  dataAt: "ItineraryPolicies.$ItinPolIndex.Hotel.Benchmarking.NonPreferred.StarRatingMinimum",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "ItineraryPoliciesHotelBenchmarkingStarRating"
};

const ItineraryPoliciesHotelBenchmarkingNonPreferredExcludeRateCategoriesForBenchmark = {
  displayName: "Exclude Rate Categories For Benchmark",
  dataAt: "ItineraryPolicies.$ItinPolIndex.Hotel.Benchmarking.NonPreferred.ExcludeRateCategoriesForBenchmark",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
  html:"<p class='help-block'>Type the <strong>Rate Categories</strong> from <a href='/#/settings/hotel' target='_blank'>System Settings - Hotel</a></p>"
};

const ItineraryPoliciesHotelBenchmarking = {
  tabName: 'Hotel-Lost-Savings',
  dataAt: '',
  displayAs: constants.DISPLAY_AS.GROUP,
  children: [
    ItineraryPoliciesHotelDefaultPolicyBenchmarkPreferredAgainstCheapestPreferred,
    {
      displayAs: constants.DISPLAY_AS.SUB_HEADING,
      html: "<br/><h4>Benchmarking Preferred</h4>",
    },
    ItineraryPoliciesHotelBenchmarkingPreferredBenchmarkAgainst,
    ItineraryPoliciesHotelBenchmarkingPreferredStarRatingMinimum,
    ItineraryPoliciesHotelBenchmarkingPreferredExcludeRateCategoriesForBenchmark,
    {
      displayAs: constants.DISPLAY_AS.SUB_HEADING,
      html: "<br/><h4>Benchmarking Non-Preferred</h4>",
    },
    ItineraryPoliciesHotelBenchmarkingNonPreferredBenchmarkAgainst,
    ItineraryPoliciesHotelBenchmarkingNonPreferredStarRatingMinimum,
    ItineraryPoliciesHotelBenchmarkingNonPreferredExcludeRateCategoriesForBenchmark,
    {
      displayAs: constants.DISPLAY_AS.SUB_HEADING,
      html: "<br/><br/>",
    },
    ItineraryPoliciesHotelPolicyExceptions,
    ItineraryPoliciesHotelPolicyExceptionSettings
  ]
};



const ItineraryPoliciesRail = {
  tabName: "Rail",
  dataAt: "",
  displayAs: constants.DISPLAY_AS.GROUP,
  children: [
    ItineraryPoliciesRailDisableRail,
    ItineraryPoliciesRailPolicies,
    ItineraryPoliciesRailPolicyExceptions,
    ItineraryPoliciesRailExcludedSuppliers,
  ],
};

const ItineraryPoliciesFlight = {
  tabName: "Flight",
  dataAt: "",
  displayAs: constants.DISPLAY_AS.GROUP,
  children: [
    ItineraryPoliciesPaidSeatsEnabledType,
    ItineraryPoliciesFlightDisableFlight,
    ItineraryPoliciesFlightBenchmarksPolicies,
    ItineraryPoliciesFlightBenchmarksExceptions,
    ItineraryPoliciesFlightPolicies,
    ItineraryPoliciesFlightSettingsExcludedProviders,
    ItineraryPoliciesFlightSettingsExcludedRates,
    ItineraryPoliciesFlightSettingsPolicyType,
    ItineraryPoliciesFlightSettingsRateCodes,
    ItineraryPoliciesFlightEnableAncillaryFees,
    ItineraryPoliciesFlightAncillaryFeeCodes,
    ItineraryPoliciesFlightPolicyExceptions,
    ItineraryPoliciesFlightPolicyExceptionExcludedCarriers,
    ItineraryPoliciesFlightPolicyExceptionSettings,
    ItineraryPoliciesFlightPolicyLeadTimeForInPolicyBooking,
    ItineraryPoliciesLessThanXDayExceptions,
    ItineraryPoliciesFlightFlyAmericaActPolicyType,
    ItineraryPoliciesFlightFlyAmericaPolicyEnableExcludeNonCompliantFlights,
    ItineraryPoliciesFlightFlyAmericaPolicyExceptions,
    {
      displayAs: constants.DISPLAY_AS.SUB_HEADING,
      label:
        "Leave Fly America Policy Exceptions empty to use system default exceptions.",
    },
  ],
};

const ItineraryPoliciesGroundTransportation = {
  tabName: "Ground",
  dataAt: "",
  displayAs: constants.DISPLAY_AS.GROUP,
  children: [
    ItineraryPoliciesGroundTransportationDisableGroundTransportation,
    ItineraryPoliciesGroundTransportationIgnoreProviderPreferred,
    ItineraryPoliciesGroundTransportationPreferredVendors,
    ItineraryPoliciesGroundTransportationExcludedVendors,
  ],
};

const ItineraryPoliciesGeneral = {
  tabName: "General",
  dataAt: "",
  displayAs: constants.DISPLAY_AS.GROUP,
  children: [ItineraryPoliciesItems, ItineraryPoliciesAgencyReasonCodes,ItineraryPoliciesMultiPaxPnrHandlingType,ItineraryPoliciesGuestTravelType, ItineraryPoliciesProfileAttributesItems],
};

const DebtorApproversTravellersItem = {
  displayName: "Debtor Approver",
  dataAt: "DebtorApprovers.$debtorApproversIndex.Travellers.$travellersIndex",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    DebtorApproversTravellersId,
    DebtorApproversTravellersTitle,
    DebtorApproversTravellersEmail,
  ],
  endpoint: "Debtors",
  routeParamId: "debtorId",
  removeParamId: "travellersIndex",
  canDelete: true,
};

const DebtorGdsCorporateIdentifiers = {
  displayName: "Corporate Identifiers",
  dataAt: "Gds.$GdsItem.CorporateIdentifiers",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: DebtorGdsCorporateIdentifiersItem,
  gridCols: [
    { name: "Supplier Code", key: "SupplierCode" },
    { name: "Corporate Code", key: "CorporateCode" },
  ],
};

const DebtorGdsMiQuestions = {
  displayName: "Mi Questions",
  dataAt: "Gds.$GdsItem.MiQuestions",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: DebtorGdsMiQuestionsItem,
  gridCols: [{ name: "Supplier", key: "Supplier" }],
};

const DebtorGdsSettings = {
  displayName: "Settings",
  dataAt: "Gds.$GdsItem.Settings",
  displayAs: constants.DISPLAY_AS.KEY_VALUE_PAIRS,
  keyOptions: "GDSSettingsOptions",
};

const DebtorGdsEnabled = {
  displayName: "Enabled",
  dataAt: "Gds.$GdsItem.Enabled",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const DebtorGdsName = {
  displayName: "Name",
  dataAt: "Gds.$GdsItem.Name",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const HotelConfigurationPaymentNarrativesIsDomesticOnly = {
  displayName: "Is Domestic Only",
  dataAt:
    "HotelConfiguration.PaymentNarratives.$hotConPaymentNarrativesItem.IsDomesticOnly",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const HotelConfigurationPaymentNarrativesAggregators = {
  displayName: "Hotel Aggregators",
  dataAt: "HotelConfiguration.PaymentNarratives.$hotConPaymentNarrativesItem.Aggregators",
  displayAs: constants.DISPLAY_AS.O_DATA_SELECT,
  endpoint: "Settings",
  queryOption: "select",
  selectProperty: "HotelRateCategories",
  inputTitle: "Name",
  selectChoiceName: "Name",
  entityIdentifier: "Name",
  searchAllNo: true,
  isMultiSelect: true,
  additionalFilters: {
    "IsAggregator": true
  },
  additionalOptions: [
    {
      Name: "Sabre",
      IsAggregator: true,
    }
  ],
  showOnlySelectedField: true
};

const HotelConfigurationPaymentNarrativesProviders = {
  displayName: "Hotel Providers",
  dataAt:
    "HotelConfiguration.PaymentNarratives.$hotConPaymentNarrativesItem.Providers",
  displayAs: constants.DISPLAY_AS.MULTI_SELECT,
  optionsAt: "GDSProviders",
};

const HotelConfigurationPaymentNarrativesServiceFeeCode = {
  displayName: "Service Fee Code (max 100 characters)",
  dataAt:
    "HotelConfiguration.PaymentNarratives.$hotConPaymentNarrativesItem.ServiceFeeCode",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  maxLength: 100,
};

const HotelConfigurationPaymentNarrativesPaymentInstructions = {
  displayName: "Hotel Payment Instructions",
  dataAt:
    "HotelConfiguration.PaymentNarratives.$hotConPaymentNarrativesItem.PaymentInstructions",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const HotelConfigurationPaymentNarrativesPaymentNarrative = {
  displayName: "Hotel Payment Narrative (max 50 characters)",
  dataAt:
    "HotelConfiguration.PaymentNarratives.$hotConPaymentNarrativesItem.PaymentNarrative",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  maxLength: 50,
};

const HotelConfigurationPaymentNarrativesPaymentCode = {
  displayName: "Hotel Payment Code (max 20 characters)",
  dataAt:
    "HotelConfiguration.PaymentNarratives.$hotConPaymentNarrativesItem.PaymentCode",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  maxLength: 20,
};

const HotelConfigurationRadiusCitiesRadius = {
  displayName: "Radius",
  dataAt: "HotelConfiguration.Radius.Cities.$hotConRadCitiesItem.Radius",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "RadiusOptions",
  optionsNumbers: true,
  required: true,
};

const HotelConfigurationRadiusCitiesCityCode = {
  displayName: "CityCode",
  dataAt: "HotelConfiguration.Radius.Cities.$hotConRadCitiesItem.CityCode",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const HotelConfigurationHotelAmenityFiltersDisplayName = {
  displayName: "Display Name",
  dataAt: "HotelConfiguration.HotelAmenityFilters.$hotConHotelAmenityFiltersItem.DisplayName",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const HotelConfigurationHotelAmenityFiltersMostPopular = {
  displayName: "Show in Most Popular Category",
  dataAt: "HotelConfiguration.HotelAmenityFilters.$hotConHotelAmenityFiltersItem.MostPopular",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const HotelConfigurationHotelAmenityFiltersAmenities = {
  displayName: "Amenities",
  dataAt: "HotelConfiguration.HotelAmenityFilters.$hotConHotelAmenityFiltersItem.Amenities",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const RailSupplierSettingsSettings = {
  displayName: "Settings",
  dataAt:
    "RailConfiguration.RailSupplierSettings.$railSuppSettingItem.Settings",
  displayAs: constants.DISPLAY_AS.KEY_VALUE_PAIRS,
};

const RailSupplierSettingsCode = {
  displayName: "Code",
  dataAt: "RailConfiguration.RailSupplierSettings.$railSuppSettingItem.Code",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const RailSupplierSettingsName = {
  displayName: "Name",
  dataAt: "RailConfiguration.RailSupplierSettings.$railSuppSettingItem.Name",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const FlightSearchWindowsDestinations = {
  displayName: "Destinations",
  dataAt:
    "FlightConfiguration.FlightWindowSettings.$flightSearchWindowItem.Destinations",
  displayAs: constants.DISPLAY_AS.COUNTRY_SELECT,
};

const FlightSearchWindowsOrigins = {
  displayName: "Origins",
  dataAt:
    "FlightConfiguration.FlightWindowSettings.$flightSearchWindowItem.Origins",
  displayAs: constants.DISPLAY_AS.COUNTRY_SELECT,
};

const FlightSearchWindowsFlightPolicyDepartureWindowTo = {
  displayName: "Policy Departure Window To",
  dataAt:
    "FlightConfiguration.FlightWindowSettings.$flightSearchWindowItem.FlightPolicyDepartureWindowTo",
  displayAs: constants.DISPLAY_AS.RANGE,
  min: 15,
  max: 720,
  step: 15,
  defaultValue: 3,
  divideResultBy: 60,
  units: "minutes",
};

const FlightSearchWindowsFlightPolicyDepartureWindowFrom = {
  displayName: "Policy Departure Window From",
  dataAt:
    "FlightConfiguration.FlightWindowSettings.$flightSearchWindowItem.FlightPolicyDepartureWindowFrom",
  displayAs: constants.DISPLAY_AS.RANGE,
  min: 15,
  max: 720,
  step: 15,
  defaultValue: 3,
  divideResultBy: 60,
  units: "minutes",
};

const FlightSearchWindowsFlightSearchWindowTo = {
  displayName: "Search Window To",
  dataAt:
    "FlightConfiguration.FlightWindowSettings.$flightSearchWindowItem.FlightSearchWindowTo",
  displayAs: constants.DISPLAY_AS.RANGE,
  min: 15,
  max: 720,
  step: 15,
  defaultValue: 3,
  divideResultBy: 60,
  units: "minutes",
};

const FlightSearchWindowsFlightSearchWindowFrom = {
  displayName: "Search Window From",
  dataAt:
    "FlightConfiguration.FlightWindowSettings.$flightSearchWindowItem.FlightSearchWindowFrom",
  displayAs: constants.DISPLAY_AS.RANGE,
  min: 15,
  max: 720,
  step: 15,
  defaultValue: 3,
  divideResultBy: 60,
  units: "minutes",
};

const FlightSearchWindowsIsAllDaySearch = {
  displayName: "Is All Day Search",
  dataAt:
    "FlightConfiguration.FlightWindowSettings.$flightSearchWindowItem.IsAllDaySearch",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const CombinableFareRulesDestination = {
  displayName: "Destination",
  dataAt:
    "FlightConfiguration.CombinableFareRules.$combFareRulesItem.Destination",
  displayAs: constants.DISPLAY_AS.COUNTRY_SELECT,
  selectType: "single",
};

const CombinableFareRulesOrigin = {
  displayName: "Origin",
  dataAt: "FlightConfiguration.CombinableFareRules.$combFareRulesItem.Origin",
  displayAs: constants.DISPLAY_AS.COUNTRY_SELECT,
  selectType: "single",
};

const OneWayFareRulesDestination = {
  displayName: "Destination",
  dataAt: "FlightConfiguration.OneWayFareRules.$oneWayFarRuItem.Destination",
  displayAs: constants.DISPLAY_AS.COUNTRY_SELECT,
  selectType: "single",
};

const OneWayFareRulesOrigin = {
  displayName: "Origin",
  dataAt: "FlightConfiguration.OneWayFareRules.$oneWayFarRuItem.Origin",
  displayAs: constants.DISPLAY_AS.COUNTRY_SELECT,
  selectType: "single",
};

const PaymentConfigurationsPaymentTypes = {
  displayName: "Payment Types",
  dataAt: "PaymentConfigurations.$payConItem.PaymentTypes",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: PaymentTypesItem,
  gridCols: [{ name: "Type", key: "Type" }],
};

const PaymentConfigurationsProvider = {
  displayName: "Provider",
  dataAt: "PaymentConfigurations.$payConItem.Provider",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "GDSProviders",
};

const DebtorAgencyReasonCodesTitle = {
  displayName: "Title",
  dataAt: "DebtorAgencyReasonCodes.$debAgReCoItem.Title",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const DebtorAgencyReasonCodesCode = {
  displayName: "Code",
  dataAt: "DebtorAgencyReasonCodes.$debAgReCoItem.Code",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const AgencyCreditCardsItemModifiedOn = {
  displayName: "Modified On",
  dataAt: "DebtorAgencyCreditCards.$debtAgCCItem.ModifiedOn",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: true,
};

const AgencyCreditCardsItemModifiedBy = {
  displayName: "Modified By",
  dataAt: "DebtorAgencyCreditCards.$debtAgCCItem.ModifiedBy",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: true,
};

const AgencyCreditCardsItemCreatedOn = {
  displayName: "Created On",
  dataAt: "DebtorAgencyCreditCards.$debtAgCCItem.CreatedOn",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: true,
};

const AgencyCreditCardsItemCreatedBy = {
  displayName: "Created By",
  dataAt: "DebtorAgencyCreditCards.$debtAgCCItem.CreatedBy",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: true,
};

const SegmentTypes = {
  displayName: "Segment Types",
  dataAt: "DebtorAgencyCreditCards.$debtAgCCItem.SegmentTypes",
  displayAs: constants.DISPLAY_AS.MULTI_SELECT,
  optionsAt: "SegmentTypes",
};

const CreditCardId = {
  displayName: "Credit Card Id",
  dataAt: "DebtorAgencyCreditCards.$debtAgCCItem.CreditCardId",
  displayAs: constants.DISPLAY_AS.O_DATA_SELECT,
  endpoint: "CreditCards",
  searchAllNo: true
};

const AgencyCreditCardsItemId = {
  displayName: "Id",
  dataAt: "DebtorAgencyCreditCards.$debtAgCCItem.Id",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: true,
};

const AgencyCreditCardsItemTitle = {
  displayName: "Title",
  dataAt: "DebtorAgencyCreditCards.$debtAgCCItem.Title",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const CompanyReferencesChildren = {
  displayName: "Children",
  dataAt: "CompanyReferences.$compRefItem.Children",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: CompanyReferencesChildrenItem,
  gridCols: [
    { name: "Match", key: "Match" },
    { name: "Code", key: "Code" },
    { name: "Title", key: "Title" },
    { name: "Mandatory", key: "Mandatory" },
    { name: "ListId", key: "ListId" },
  ],
};

const CompanyReferencesMandatory = {
  displayName: "Mandatory",
  dataAt: "CompanyReferences.$compRefItem.Mandatory",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const CompanyReferencesFlags = {
  displayName: "Flags",
  dataAt: "CompanyReferences.$compRefItem.Flags",
  displayAs: constants.DISPLAY_AS.MULTI_SELECT,
  optionsAt: "CompanyReferencesFlags",
};

const CompanyReferencesOptions = {
  displayName: "Options",
  dataAt: "CompanyReferences.$compRefItem.Options",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
  helpText: "Use a pipe | to delineate a value and display. \r\nExample: Y|Yes \r\nThis will display Yes to the booker and capture Y as the value."
};

const CompanyReferencesTitle = {
  displayName: "Title",
  dataAt: "CompanyReferences.$compRefItem.Title",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  required: true,
  validationMessage: "Title is required. Max length 100",
  validationRegex: "^.{1,100}$"
};

const CompanyReferencesPlaceHolderText = {
  displayName: "PlaceHolder Text",
  dataAt: "CompanyReferences.$compRefItem.PlaceHolderText",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const CompanyReferencesCode = {
  displayName: "Code",
  dataAt: "CompanyReferences.$compRefItem.Code",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  required: true,
  validationMessage: "Code is required. Max length 50",
  validationRegex: "^.{1,50}$"
};

const CompanyReferencesListId = {
  displayName: "ListId",
  dataAt: "CompanyReferences.$compRefItem.ListId",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const CompanyReferencesPlacementType = {
  displayName: 'Placement',
  dataAt: 'CompanyReferences.$compRefItem.PlacementType',
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: 'PlacementType',
};

const ItineraryPoliciesTabs = {
  dataAt: "",
  displayAs: constants.DISPLAY_AS.TABS,
  children: [
    ItineraryPoliciesGeneral,
    ItineraryPoliciesFlight,
    ItineraryPoliciesFlightLowLogicFare,
    ItineraryPoliciesRail,
    ItineraryPoliciesHotel,
    ItineraryPoliciesHotelBenchmarking,
    ItineraryPoliciesCar,
    ItineraryPoliciesGroundTransportation,
  ],
};

const ItineraryPoliciesBreakPolicyEscalationApprovalLevel = {
  displayName: "Break Policy Escalation Approval Level",
  dataAt: "ItineraryPolicies.$ItinPolIndex.BreakPolicyEscalationApprovalLevel",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "approvalLevels",
};

const ItineraryPoliciesApprovalLevel = {
  displayName: "Approval Level",
  dataAt: "ItineraryPolicies.$ItinPolIndex.ApprovalLevel",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "approvalLevels",
};

const ItineraryPoliciesCountries = {
  displayName: "Countries",
  dataAt: "ItineraryPolicies.$ItinPolIndex.Countries",
  displayAs: constants.DISPLAY_AS.COUNTRY_SELECT,
};

const ItineraryPoliciesTitle = {
  displayName: "Title",
  dataAt: "ItineraryPolicies.$ItinPolIndex.Title",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  maxLength: 30,
};

const ItineraryPoliciesCode = {
  displayName: "Code",
  dataAt: "ItineraryPolicies.$ItinPolIndex.Code",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  maxLength: 30,
};

const TermsAndConditionsSectionType = {
  displayName: "Section Type",
  dataAt: "TermsAndConditions.$debtorTermsItem.SectionType",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "SectionType",
};

const TermsAndConditionsText = {
  displayName: "Text",
  dataAt: "TermsAndConditions.$debtorTermsItem.Text",
  displayAs: constants.DISPLAY_AS.TEXT_AREA,
};

const TermsAndConditionsSegmentTypes = {
  displayName: "Segment Types",
  dataAt: "TermsAndConditions.$debtorTermsItem.SegmentTypes",
  displayAs: constants.DISPLAY_AS.MULTI_SELECT,
  optionsAt: "SegmentTypes",
};

const TermsAndConditionsCountries = {
  displayName: "Countries",
  dataAt: "TermsAndConditions.$debtorTermsItem.Countries",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const DebtorOrderNumberCodesTitle = {
  displayName: "Title",
  dataAt: "DebtorOrderNumberCodes.$debtorOrderNumberCodesIndex.Title",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  required: true,
};

const DebtorOrderNumberCodesCode = {
  displayName: "Code",
  dataAt: "DebtorOrderNumberCodes.$debtorOrderNumberCodesIndex.Code",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  required: true,
};

const DebtorGdsItem = {
  displayName: "Gds Item",
  dataAt: "Gds.$GdsItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    DebtorGdsName,
    DebtorGdsEnabled,
    DebtorGdsSettings,
    DebtorGdsMiQuestions,
    DebtorGdsCorporateIdentifiers,
    GdsPassiveFlightSegmentRemarks,
  ],
  endpoint: "Debtors",
  routeParamId: "debtorId",
  removeParamId: "GdsItem",
  canDelete: true,
};

const HotelConfigurationPaymentNarrativesItem = {
  displayName: "Hotel Payment Narrative",
  dataAt: "HotelConfiguration.PaymentNarratives.$hotConPaymentNarrativesItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    HotelConfigurationPaymentNarrativesPaymentCode,
    HotelConfigurationPaymentNarrativesPaymentNarrative,
    HotelConfigurationPaymentNarrativesPaymentInstructions,
    HotelConfigurationPaymentNarrativesServiceFeeCode,
    HotelConfigurationPaymentNarrativesProviders,
    HotelConfigurationPaymentNarrativesAggregators,
    HotelConfigurationPaymentNarrativesIsDomesticOnly,
  ],
  endpoint: "Debtors",
  routeParamId: "debtorId",
  removeParamId: "hotConPaymentNarrativesItem",
  canDelete: true,
};

const HotelConfigurationRadiusCitiesItem = {
  displayName: "City Radius",
  dataAt: "HotelConfiguration.Radius.Cities.$hotConRadCitiesItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    HotelConfigurationRadiusCitiesCityCode,
    HotelConfigurationRadiusCitiesRadius,
  ],
  endpoint: "Debtors",
  routeParamId: "debtorId",
  removeParamId: "hotConRadCitiesItem",
  canDelete: true,
};

const HotelConfigurationHotelAmenityFiltersItem = {
  displayName: "Hotel Amenity Filters",
  dataAt: "HotelConfiguration.HotelAmenityFilters.$hotConHotelAmenityFiltersItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    HotelConfigurationHotelAmenityFiltersDisplayName,
    HotelConfigurationHotelAmenityFiltersMostPopular,
    HotelConfigurationHotelAmenityFiltersAmenities,
  ],
  endpoint: "Debtors",
  routeParamId: "debtorId",
  removeParamId: "hotConHotelAmenityFiltersItem",
  canDelete: true,
};

const RailSupplierSettingsItem = {
  displayName: "Item",
  dataAt: "RailConfiguration.RailSupplierSettings.$railSuppSettingItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    RailSupplierSettingsName,
    RailSupplierSettingsCode,
    RailSupplierSettingsSettings,
  ],
  endpoint: "Debtors",
  routeParamId: "debtorId",
  removeParamId: "$railSuppSettingItem",
  canDelete: true,
};

const FlightSearchWindowItem = {
  displayName: "Flight Search Window",
  dataAt: "FlightConfiguration.FlightWindowSettings.$flightSearchWindowItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    FlightSearchWindowsIsAllDaySearch,
    FlightSearchWindowsFlightSearchWindowFrom,
    FlightSearchWindowsFlightSearchWindowTo,
    FlightSearchWindowsFlightPolicyDepartureWindowFrom,
    FlightSearchWindowsFlightPolicyDepartureWindowTo,
    FlightSearchWindowsOrigins,
    FlightSearchWindowsDestinations,
  ],
  endpoint: "Debtors",
  routeParamId: "debtorId",
  removeParamId: "$flightSearchWindowItem",
  canDelete: true,
};

const CombinableFareRulesItem = {
  displayName: "Combinable Fare Rule",
  dataAt: "FlightConfiguration.CombinableFareRules.$combFareRulesItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [CombinableFareRulesOrigin, CombinableFareRulesDestination],
  endpoint: "Debtors",
  routeParamId: "debtorId",
  removeParamId: "combFareRulesItem",
  canDelete: true,
};

const OneWayFareRulesItem = {
  displayName: "One Way Fare Rule",
  dataAt: "FlightConfiguration.OneWayFareRules.$oneWayFarRuItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [OneWayFareRulesOrigin, OneWayFareRulesDestination],
  endpoint: "Debtors",
  routeParamId: "debtorId",
  removeParamId: "oneWayFarRuItem",
  canDelete: true,
};

const PaymentConfigurationsItem = {
  displayName: "Payment Configuration",
  dataAt: "PaymentConfigurations.$payConItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [PaymentConfigurationsProvider, PaymentConfigurationsPaymentTypes],
  endpoint: "Debtors",
  routeParamId: "debtorId",
  removeParamId: "payConItem",
  canDelete: true,
};

const DebtorAgencyReasonCodesItem = {
  displayName: "Agency Reason Codes Item",
  dataAt: "DebtorAgencyReasonCodes.$debAgReCoItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [DebtorAgencyReasonCodesCode, DebtorAgencyReasonCodesTitle],
  endpoint: "Debtors",
  routeParamId: "debtorId",
  removeParamId: "debAgReCoItem",
  canDelete: true,
};

const AgencyCreditCardsItem = {
  displayName: "Agency Credit Card",
  dataAt: "DebtorAgencyCreditCards.$debtAgCCItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    AgencyCreditCardsItemTitle,
    AgencyCreditCardsItemId,
    CreditCardId,
    SegmentTypes,
    AgencyCreditCardsItemCreatedBy,
    AgencyCreditCardsItemCreatedOn,
    AgencyCreditCardsItemModifiedBy,
    AgencyCreditCardsItemModifiedOn,
  ],
  endpoint: "Debtors",
  routeParamId: "debtorId",
  removeParamId: "debtAgCCItem",
  canDelete: true,
};

const CompanyReferencesItemsItemTitle = {
  displayName: "Title",
  dataAt: "CompanyReferences.$compRefItem.Items.$compRefItemItemIndex.Title",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const CompanyReferencesItemsItemCode = {
  displayName: "Code",
  dataAt: "CompanyReferences.$compRefItem.Items.$compRefItemItemIndex.Code",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const CompanyReferencesItemsItem = {
  displayName: "Item",
  dataAt: "CompanyReferences.$compRefItem.Items.$compRefItemItemIndex",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [CompanyReferencesItemsItemCode, CompanyReferencesItemsItemTitle],
  endpoint: "Debtors",
  routeParamId: "debtorId",
  removeParamId: "compRefItemItemIndex",
  canDelete: true,
};

const CompanyReferencesItems = {
  displayName: "Employee Codes",
  dataAt: "CompanyReferences.$compRefItem.Items",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: CompanyReferencesItemsItem,
  gridCols: [
    { name: "Code", key: "Code" },
    { name: "Title", key: "Title" },
    { name: "ListId", key: "ListId" },
  ],
};

const CompanyReferencesGridItem = {
  displayName: "Company References",
  dataAt: "CompanyReferences.$compRefItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    CompanyReferencesCode,
    CompanyReferencesTitle,
    CompanyReferencesPlaceHolderText,
    CompanyReferencesPlacementType,
    CompanyReferencesListId,
    CompanyReferencesOptions,
    CompanyReferencesFlags,
    CompanyReferencesMandatory,
    CompanyReferencesChildren,
    CompanyReferencesItems,
  ],
  endpoint: "Debtors",
  routeParamId: "debtorId",
  removeParamId: "compRefItem",
  canDelete: true,
};

const ItineraryPoliciesItem = {
  displayName: "Itinerary Policy",
  dataAt: "ItineraryPolicies",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    ItineraryPoliciesCode,
    ItineraryPoliciesTitle,
    ItineraryPoliciesCountries,
    ItineraryPoliciesApprovalLevel,
    ItineraryPoliciesBreakPolicyEscalationApprovalLevel,
    ItineraryPoliciesTabs,
  ],
  endpoint: "Debtors",
  routeParamId: "debtorId",
  removeParamId: "ItinPolIndex",
  canDelete: true,
};

const TermsAndConditionsItem = {
  displayName: "Item",
  dataAt: "TermsAndConditions",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    TermsAndConditionsSectionType,
    TermsAndConditionsCountries,
    TermsAndConditionsSegmentTypes,
    TermsAndConditionsText,
  ],
  endpoint: "Debtors",
  removeParamId: "debtorTermsItem",
  canDelete: true,
};

const DebtorOrderNumberCodesItem = {
  displayName: "Debtor Order Number Codes",
  dataAt: "DebtorOrderNumberCodes",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [DebtorOrderNumberCodesCode, DebtorOrderNumberCodesTitle],
  endpoint: "Debtors",
  routeParamId: "debtorId",
  removeParamId: "debtorOrderNumberCodesIndex",
  canDelete: true,
};

const ModifiedOn = {
  displayName: "Modified on",
  dataAt: "ModifiedOn",
  disabled: true,
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const ModifiedBy = {
  displayName: "Modified by",
  dataAt: "ModifiedBy",
  disabled: true,
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const CreatedOn = {
  displayName: "Created on",
  dataAt: "CreatedOn",
  disabled: true,
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const CreatedBy = {
  displayName: "Created by",
  dataAt: "CreatedBy",
  disabled: true,
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const TramadaConfigurationDatabase = {
  displayName: "Tramada Configuration Database",
  dataAt: "TramadaConfiguration.Database",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const TramadaConfigurationDebtorAuthCode = {
  displayName: "Tramada Configuration Debtor Auth Code",
  dataAt: "TramadaConfiguration.DebtorAuthCode",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const TramadaConfigurationDebtorId = {
  displayName: "Tramada Configuration Debtor Id",
  dataAt: "TramadaConfiguration.DebtorId",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const TramadaConfigurationAgencyId = {
  displayName: "Tramada Configuration Agency Id",
  dataAt: "TramadaConfiguration.AgencyId",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};



const PccCity = {
  displayName: "Pcc City",
  dataAt: "SabreConfiguration.PccCity",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const Pcc = {
  displayName: "Pcc",
  dataAt: "SabreConfiguration.Pcc",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const TeamRejectionQueue = {
  label: "Queue",
  dataAt: "SabreConfiguration.TeamRejectionQueue",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: "number",
  formClass: "width100"
};

const ModificationQueue = {
  label: "Queue",
  dataAt: "SabreConfiguration.ModificationQueue",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: "number",
  formClass: "width100"
};

const UserHoldQueue = {
  label: "Queue",
  dataAt: "SabreConfiguration.UserHoldQueue",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: "number",
  formClass: "width100"
};

const AutoTicketingQueue = {
  label: "Queue",
  dataAt: "SabreConfiguration.AutoTicketingQueue",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: "number",
  formClass: "width100"
};

const AuthorisationHoldQueue = {
  label: "Queue",
  dataAt: "SabreConfiguration.AuthorisationHoldQueue",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: "number",
  formClass: "width100"
};

const CancelQueue = {
  label: "Queue",
  dataAt: "SabreConfiguration.CancelQueue",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: "number",
  formClass: "width100"
};

//QueuePCC
const TeamRejectionQueuePcc = {
  label: "Pcc",
  dataAt: "SabreConfiguration.TeamRejectionQueuePcc",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  formClass: "width100",
  maxLength: 4
};

const ModificationQueuePcc = {
  label: "Pcc",
  dataAt: "SabreConfiguration.ModificationQueuePcc",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  formClass: "width100",
  maxLength: 4
};

const UserHoldQueuePcc = {
  label: "Pcc",
  dataAt: "SabreConfiguration.UserHoldQueuePcc",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  formClass: "width100",
  maxLength: 4
};

const AutoTicketingQueuePcc = {
  label: "Pcc",
  dataAt: "SabreConfiguration.AutoTicketingQueuePcc",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  formClass: "width100",
  maxLength: 4
};

const AuthorisationHoldQueuePcc = {
  label: "Pcc",
  dataAt: "SabreConfiguration.AuthorisationHoldQueuePcc",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  formClass: "width100",
  maxLength: 4
};

const CancelQueuePcc = {
  
  dataAt: "SabreConfiguration.CancelQueuePcc",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  formClass: "width100",
  maxLength: 4,
  label:  "Pcc"
};

const DebtorGds = {
  displayName: "Gds",
  dataAt: "Gds",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: DebtorGdsItem,
  gridCols: [
    { name: "Name", key: "Name" },
    { name: "Enabled", key: "Enabled" },
  ],
};

const DebtorLimitCountries = {
  displayName: "Limit Countries",
  dataAt: "LimitCountries",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,  
  helpText: "Named lists are supported. Wrap name in ~ characters. Example: ~AllowedCountries~"
};

const DebtorLimitAirportClassification = {
  displayName: "Limit Airport Classification",
  dataAt: "LimitAirportClassification",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "AirportClassificationOptions",
};

const HotelConfigurationTags = {
  displayName: "Hotel Tagging",
  dataAt: "HotelConfiguration.Tags",
  displayAs: constants.DISPLAY_AS.HOTEL_TAG_SELECT,
};

const HotelConfigurationAggregators = {
  displayName: "Enable Aggregators",
  dataAt: "HotelConfiguration.Aggregators",
  displayAs: constants.DISPLAY_AS.O_DATA_SELECT,
  endpoint: "Settings",
  queryOption: "select",
  selectProperty: "HotelRateCategories",
  inputTitle: "Name",
  selectChoiceName: "Name",
  entityIdentifier: "Name",
  searchAllNo: true,
  isMultiSelect: true,
  additionalFilters: {
    "IsAggregator": true
  },
  showOnlySelectedField: true
};

const HotelConfigurationPaymentNarratives = {
  displayName: "Hotel Payment Narratives",
  dataAt: "HotelConfiguration.PaymentNarratives",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: HotelConfigurationPaymentNarrativesItem,
  gridCols: [
    { name: "Payment Narrative", key: "PaymentNarrative" },
    { name: "Providers", key: "Providers" },
    { name: "Aggregators", key: "Aggregators" },
    { name: "Is Domestic Only", key: "IsDomesticOnly" },
  ],
};

const HotelConfigurationRadiusCities = {
  displayName: "Cities",
  dataAt: "HotelConfiguration.Radius.Cities",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: HotelConfigurationRadiusCitiesItem,
  gridCols: [
    { name: "CityCode", key: "CityCode" },
    { name: "Radius", key: "Radius" },
  ],
};

const HotelConfigurationRadiusDefaultRadius = {
  displayName:
    "Default Radius (defaults to kilometers unless imperial system is checked)",
  dataAt: "HotelConfiguration.Radius.DefaultRadius",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "HotelConfigurationRadius",
  optionsNumbers: true,
  required: false,
};

const HotelConfigurationIsImperialSystem = {
  displayName: "Imperial System",
  dataAt: "IsImperialSystem",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const HotelConfigurationEnableOvernightHotelPrompt = {
  displayName: "Enable Overnight Hotel Prompt",
  dataAt: "HotelConfiguration.EnableOvernightHotelPrompt",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const HotelConfigurationHotelAmenityFiltersGrid = {
  displayName: "Hotel Amenity Filters",
  dataAt: "HotelConfiguration.HotelAmenityFilters",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: HotelConfigurationHotelAmenityFiltersItem,
  gridCols: [
    { name: "Display Name", key: "DisplayName" },
    { name: "Amenities", key: "Amenities" },
    { name: "Most Popular", key: "MostPopular" }
  ],
};

const EnableGroundTransportationConfiguration = {
  displayName: "Enable",
  dataAt: "GroundTransportationConfiguration.Enable",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const GroundTransportationConfigurationUiTitle = {
  displayName: "Ground Transportation UI Title",
  dataAt: "GroundTransportationConfiguration.GroundTransportationUiTitle",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const GroundTransportationConfigurationVehicleTypes = {
  displayName: "Vehicle Types",
  dataAt: "GroundTransportationConfiguration.VehicleTypes",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const GroundTransportationCompanyReferenceMappingFieldId = {
  displayName: "Field Id",
  dataAt: "GroundTransportationConfiguration.CompanyReferenceMappings.$companyReferenceItem.GroundFieldId",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const GroundTransportationCompanyReferenceMappingCode = {
  displayName: "Code",
  dataAt: "GroundTransportationConfiguration.CompanyReferenceMappings.$companyReferenceItem.CompanyReferenceCode",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const GroundTransportationCompanyReferenceMappingItem = {
  displayName: "Item",
  dataAt: "GroundTransportationConfiguration.CompanyReferenceMappings.$companyReferenceItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    GroundTransportationCompanyReferenceMappingCode,
    GroundTransportationCompanyReferenceMappingFieldId,
  ],
  endpoint: "Debtors",
  routeParamId: "debtorId",
  canDelete: true,
}

const GroundTransportationCompanyReferenceMapping = {
  displayName: "Company Reference Mappings",
  dataAt: "GroundTransportationConfiguration.CompanyReferenceMappings",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: GroundTransportationCompanyReferenceMappingItem,
  gridCols: [
    { name: "Code", key: "CompanyReferenceCode" },
    { name: "Field Id", key: "GroundFieldId" },
  ],
};

const RailSupplierSettings = {
  displayName: "Rail Supplier Settings",
  dataAt: "RailConfiguration.RailSupplierSettings",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: RailSupplierSettingsItem,
  gridCols: [
    { name: "Name", key: "Name" },
    { name: "Code", key: "Code" },
  ],
};

const UnusedTicketSettings = {
  displayName: "Enabled Unused Ticket Providers",
  dataAt:
    "FlightConfiguration.UnusedTicketConfiguration.EnabledUnusedTicketProviders",
  displayAs: constants.DISPLAY_AS.MULTI_SELECT,
  optionsAt: "UnusedTicketProviderTypes",
};

const EnableUnusedTicketDebtorSettings = {
  displayName: "Use Unused Ticket Debtor Configuration",
  dataAt: "FlightConfiguration.UnusedTicketConfiguration.IsUsingDebtorSettings",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const BookingThreshold = {
  displayName: "Booking Threshold (In Minutes)",
  dataAt:
    "BookingThresholdInMinutes",
  displayAs: constants.DISPLAY_AS.RANGE,
  min: 0,
  max: 36000,
  step: 15,
  defaultValue: 0,
  units: "minutes",
};

const TtlThresholdFlight = {
  displayName: "Flight Ttl Threshold (In Minutes)",
  dataAt:
    "TtlThreshold.Flight",
  displayAs: constants.DISPLAY_AS.RANGE,
  min: 0,
  max: 36000,
  step: 15,
  defaultValue: 0,
  units: "minutes",
};
const TtlThresholdHotel = {
  displayName: "Hotel Ttl Threshold (In Minutes)",
  dataAt:
    "TtlThreshold.Hotel",
  displayAs: constants.DISPLAY_AS.RANGE,
  min: 0,
  max: 36000,
  step: 15,
  defaultValue: 0,
  units: "minutes",
};
const TtlThresholdCar = {
  displayName: "Car Ttl Threshold (In Minutes)",
  dataAt:
    "TtlThreshold.Car",
  displayAs: constants.DISPLAY_AS.RANGE,
  min: 0,
  max: 36000,
  step: 15,
  defaultValue: 0,
  units: "minutes",
};
const TtlThresholdRail = {
  displayName: "Rail Ttl Threshold (In Minutes)",
  dataAt:
    "TtlThreshold.Rail",
  displayAs: constants.DISPLAY_AS.RANGE,
  min: 0,
  max: 36000,
  step: 15,
  defaultValue: 0,
  units: "minutes",
};
const TtlThresholdGround = {
  displayName: "Ground Ttl Threshold (In Minutes)",
  dataAt:
    "TtlThreshold.Ground",
  displayAs: constants.DISPLAY_AS.RANGE,
  min: 0,
  max: 36000,
  step: 15,
  defaultValue: 0,
  units: "minutes",
};

const HomeSearchDefaultSelection = {
  displayName: "Home Search Default Selection",
  dataAt: "HomeSearchDefaultSelection",
  displayAs: constants.DISPLAY_AS.MULTI_SELECT,
  optionsAt: "HomeSearchDefaultSelectionOptions",
  helpText: "Leave empty for current behaviour"
};

const EnableItineraryValidatorDebtorSettings = {
  displayName: "Use Itinerary Validator Debtor Configuration",
  dataAt: "ItineraryValidatorConfiguration.IsUsingDebtorSettings",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
  hideShowProperty: "IsUsingDebtorSettings",
};

const ItineraryValidatorSettings = {
  displayName: "Enabled Itinerary Validators",
  dataAt: "ItineraryValidatorConfiguration.EnabledItineraryValidators",
  displayAs: constants.DISPLAY_AS.MULTI_SELECT,
  optionsAt: "ItineraryValidatorTypes",
  formClass: "IsUsingDebtorSettings"
};

const EnableParallelSearches = {
  displayName: "Enable Parallel Searches",
  dataAt: "ParallelSearchesConfiguration.EnableParallelSearches",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const DisableLoyaltyPrograms = {
  displayName: "Disable Loyalty Programs",
  dataAt: "DisableLoyaltyPrograms",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const RailConfiguration = {
  displayName: "Rail Enabled",
  dataAt: "RailConfiguration.Enabled",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const FlightConfigurationRiskEngineFlightThresholdLimit = {
  displayName: "Risk Engine Flight Threshold Limit",
  dataAt: "FlightConfiguration.RiskEngineFlightThresholdLimit",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: "number",
};

const FlightExcludeAirports = {
  displayName: "Exclude Airports",
  dataAt: "FlightConfiguration.ExcludeAirports",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const FlightSearchWindows = {
  displayName: "Flight Search Windows",
  dataAt: "FlightConfiguration.FlightWindowSettings",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: FlightSearchWindowItem,
  gridCols: [
    { name: "Origins", key: "Origins" },
    { name: "Destinations", key: "Destinations" },
  ],
};

const CombinableFareRules = {
  displayName: "Combinable Fare Rules",
  dataAt: "FlightConfiguration.CombinableFareRules",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: CombinableFareRulesItem,
  gridCols: [
    { name: "Origin", key: "Origin" },
    { name: "Destination", key: "Destination" },
  ],
};

const OneWayFareRules = {
  displayName: "One Way Fare Rules",
  dataAt: "FlightConfiguration.OneWayFareRules",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: OneWayFareRulesItem,
  gridCols: [
    { name: "Origin", key: "Origin" },
    { name: "Destination", key: "Destination" },
  ],
};

const FlightPolicyDepatureWindowTo = {
  displayName: "Depature Window To",
  dataAt: "FlightConfiguration.FlightPolicyDepatureWindowTo",
  displayAs: constants.DISPLAY_AS.RANGE,
  min: 15,
  max: 720,
  step: 15,
  divideResultBy: 60,
  units: "minutes",
};

const FlightPolicyDepatureWindowFrom = {
  displayName: "Depature Window From",
  dataAt: "FlightConfiguration.FlightPolicyDepatureWindowFrom",
  displayAs: constants.DISPLAY_AS.RANGE,
  min: 15,
  max: 720,
  step: 15,
  divideResultBy: 60,
  units: "minutes",
};

const FlightCorporateRateCode = {
  displayName: "Corporate Rate Code",
  dataAt: "FlightConfiguration.CorporateRateCodes.$flightCorporateRateCodeItem.CorporateRateCode",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const FlightCorporateRateCodeCarriers = {
  displayName: "Carriers",
  dataAt: "FlightConfiguration.CorporateRateCodes.$flightCorporateRateCodeItem.Carriers",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
  html: "Optional: Only required with NDC. When shopping ATPCO fares system does not require carrier.",
  validationRegex: "^$|^[A-Za-z0-9]{2}(?:[\\s,]+[A-Za-z0-9]{2})*$",
  validationMessage: "Use 2-character carrier codes (letters or numbers), e.g., AA, F9.",
};

const FlightCorporateRateCodeGdsProviders = {
  displayName: "Gds Providers",
  dataAt: "FlightConfiguration.CorporateRateCodes.$flightCorporateRateCodeItem.GdsProviders",
  displayAs: constants.DISPLAY_AS.MULTI_SELECT,
  optionsAt: "GDSProviders",
  helpText: "Optional: Use to force only with specific provider."
};

const FlightCorporateRateCodeType = {
  displayName: "Rate Code Type",
  dataAt: "FlightConfiguration.CorporateRateCodes.$flightCorporateRateCodeItem.RateCodeType",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "FlightCorporateRateCodeType",
  hideShowProperty: "FlightCorporateRateCodeType"
};

const FlightCorporateRateCodeValue = {
  displayName: "Rate Code Value",
  dataAt: "FlightConfiguration.CorporateRateCodes.$flightCorporateRateCodeItem.RateCodeValue",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  formClass: "FlightCorporateRateCodeType_Qualifier",
};

const FlightCorporateRateCodeItem = {
  displayName: "Flight Corporate Rate Code",
  dataAt: "FlightConfiguration.CorporateRateCodes.$flightCorporateRateCodeItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    FlightCorporateRateCode,
    FlightCorporateRateCodeCarriers,
    FlightCorporateRateCodeGdsProviders,
    FlightCorporateRateCodeType,
    FlightCorporateRateCodeValue
  ],
  endpoint: "Debtors",
  routeParamId: "debtorId",
  removeParamId: "flightCorporateRateCodeItem",
  canDelete: true,
};

const FlightCorporateRateCodes = {
  displayName: "Flight Corporate Rate Codes",
  dataAt: "FlightConfiguration.CorporateRateCodes",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: FlightCorporateRateCodeItem,
  gridCols: [
    { name: "CorporateRateCode", key: "CorporateRateCode" },
    { name: "Carriers", key: "Carriers" },
    { name: "GdsProviders", key: "GdsProviders" },
    { name: "RateCodeType", key: "RateCodeType" },
    { name: "RateCodeValue", key: "RateCodeValue" },
  ],
  html: "Coporate Rate codes can be used instead of Policy Rate Codes. System will pull from both places."
};

const PaymentConfigurations = {
  displayName: "Payment Configurations",
  dataAt: "PaymentConfigurations",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: PaymentConfigurationsItem,
  gridCols: [{ name: "Provider", key: "Provider" }],
};

const DebtorAgencyPostcode = {
  displayName: "Agency Postcode",
  dataAt: "DebtorAgency.Postcode",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  validationRegex: "^[0-9]{5}(?:-[0-9]{4})?$",
  validationMessage: "Not a valid postal code",
};

const DebtorAgencyState = {
  displayName: "Agency State",
  dataAt: "DebtorAgency.State",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const DebtorAgencyCity = {
  displayName: "Agency City",
  dataAt: "DebtorAgency.City",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const DebtorAgencyStreet = {
  displayName: "Agency Street",
  dataAt: "DebtorAgency.Street",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const DebtorAgencyAddress = {
  displayName: "Agency Address",
  dataAt: "DebtorAgency.Address",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const DebtorAgencyEmail = {
  displayName: "Agency Email",
  dataAt: "DebtorAgency.Email",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const DebtorModificationAlertEmails = {
  displayName: "Modification Alert Emails",
  dataAt: "DebtorAgency.ModificationAlertEmails",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const DebtorConfirmationAlertEmails = {
  displayName: "Confirmation Alert Emails",
  dataAt: "DebtorAgency.ConfirmationAlertEmails",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const DebtorCancellationAlertEmails = {
  displayName: "Cancellation Alert Emails",
  dataAt: "DebtorAgency.CancellationAlertEmails",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const DebtorAgencySendConfirmationToTraveler = {
  displayName: "Send Confirmation Email to Traveler",
  dataAt: "DebtorAgency.SendConfirmationToTraveler",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const DebtorAgencySendConfirmationToBooker = {
  displayName: "Send Confirmation Email to Booker",
  dataAt: "DebtorAgency.SendConfirmationToBooker",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const DebtorAgencyConfirmationEmailHeaderText = {
  displayName: "Confirmation Email Custom Header",
  dataAt: "DebtorAgency.ConfirmationEmailHeaderText",
  displayAs: constants.DISPLAY_AS.TEXT_AREA,
  validationMessage: "Max length 250",
  validationRegex: "^.{0,250}$"
};

const DebtorAgencyConfirmationEmailFooterText = {
  displayName: "Confirmation Email Custom Footer",
  dataAt: "DebtorAgency.ConfirmationEmailFooterText",
  displayAs: constants.DISPLAY_AS.TEXT_AREA,
  validationMessage: "Max length 250",
  validationRegex: "^.{0,250}$"
};

const DebtorAgencyPhone = {
  displayName: "Agency Phone",
  dataAt: "DebtorAgency.Phone",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const DebtorAgencyReasonCodes = {
  displayName: "Agency Reason Codes",
  dataAt: "DebtorAgencyReasonCodes",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: DebtorAgencyReasonCodesItem,
  gridCols: [
    { name: "Code", key: "Code" },
    { name: "Title", key: "Title" },
  ],
};

const AllowArrangerFormsOfPayment = {
  displayName: "Allow Arranger Forms of Payment",
  dataAt: "AllowArrangerFormsOfPayment",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const AgencyReasonDisplayName = {
  displayName: "Reason for travel display name",
  dataAt: "AgencyReasonDisplayName",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const AgencyCreditCards = {
  displayName: "Agency Credit Cards",
  dataAt: "DebtorAgencyCreditCards",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: AgencyCreditCardsItem,
  gridCols: [
    { name: "Title", key: "Title" },
    { name: "Credit Card Id", key: "CreditCardId" },
  ],
};

const CompanyReferencesGrid = {
  displayName: "Company References",
  dataAt: "CompanyReferences",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: CompanyReferencesGridItem,
  gridCols: [
    { name: "Code", key: "Code" },
    { name: "Title", key: "Title" },
    { name: 'Placement', key: 'PlacementType' },
    { name: "Mandatory", key: "Mandatory" },
    { name: "ListId", key: "ListId" },
  ],
};

const ItineraryPolicies = {
  displayName: "Itinerary Policies",
  dataAt: "ItineraryPolicies",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: ItineraryPoliciesItem,
  gridCols: [
    { name: "Code", key: "Code" },
    { name: "Title", key: "Title" },
  ],
};

const DebtorApproverFileDownloader = {
  displayName: "Approver File Download",
  dataAt: "DebtorApproverFileDownloader",
  displayAs: constants.DISPLAY_AS.FILE_DOWNLOADER,
  fileNameSuffix: "Approvers.xlsx",
  parameterValueFromActiveItemProperty: "Name",
  parameterName: "debtorIdentifier",
  endPointController: "DebtorApproverDownload",
};

const DebtorApproverFileUpload = {
  displayName: "Approver File Upload",
  dataAt: "DebtorApproverFileUpload",
  displayAs: constants.DISPLAY_AS.FILE_UPLOADER,
  fileContainer: "DebtorApproverBatchUpload",
  uploadType: "xlsx",
  fileNamePrefixProperty: "Name",
  fileNameFormat: "yyyymmdd",
  excludeFromPost: true,
};

const RestrictSelfApproval = {
  displayName: "Restrict Self Approval",
  dataAt: "RestrictSelfApproval",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const DebtorApprovalsCommentEnabled = {
  displayName: "Free Format Approval Reason",
  dataAt: "Approvals.Comment.Enabled",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const DebtorApprovalRestrictionThresholdMin = 
{
  dataAt: "Approvals.ApprovalRestrictionThresholdMin",
  displayAs: constants.DISPLAY_AS.RANGE,
  min: 0,
  max: 720,
  step: 15,
  units: "minutes",
};

const DebtorApprovalRestrictionThresholdMinTitle = {
      displayAs: constants.DISPLAY_AS.SUB_HEADING,
      html:
        "<h4>Approval Restriction Threshold</h4><small>Threshold time to restrict booking. For example, if TTL is 120 minutes from Now booking will not be allowed.</small>",
}

const DebtorCTMApproveStatusLookupEnabled = {
  displayName: "CTM Approve Status Lookup",
  dataAt: "IsCTMApproveStatusLookupEnabled",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const DebtorCTMApprovePendingRestrictModify = {
  displayName: "Restrict Modifications on CTM Approve Status Pending",
  dataAt: "CTMApprovePendingRestrictModify",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const DebtorBookingConfirmationWebHookUrl = {
  displayName: "Booking Confirmation Web Hook",
  dataAt: "BookingConfirmationWebhookUrl",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const TermsAndConditions = {
  displayName: "Terms and Conditions",
  dataAt: "TermsAndConditions",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: TermsAndConditionsItem,
  gridCols: [
    { name: "SectionType", key: "SectionType" },
    { name: "Countries", key: "Countries" },
    { name: "SegmentTypes", key: "SegmentTypes" },
  ],
};

const DebtorMultiPaxPnrHandlingType = {  
  displayName: "Multi Passenger Pnr Handling",
  dataAt: "TravellerConfiguration.MultiPaxPnrHandling",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "DebtorMultiPaxPnrHandlingType",
  defaultValue: "NotAllowed",
}
const MultiPaxPnrHandlingText = {
  displayName: "Multi Passenger Pnr Handling Question Text",
  dataAt: "TravellerConfiguration.MultiPaxPnrHandlingText",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  html: "Default Text: Create single booking for all passengers."
};

const TravellerConfigurationGuestTravellerProfileName = {
  displayName: "Traveller Configuration Guest Profile Name",
  dataAt: "TravellerConfiguration.GuestTravellerProfileName",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const TravellerConfigurationProfilePnrBuilder = {
  displayName: "Traveller Configuration Profile PNR Builder",
  dataAt: "TravellerConfiguration.ProfilePnrBuilder",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const TravellerConfigurationPcc = {
  displayName: "Traveller Configuration Pcc",
  dataAt: "TravellerConfiguration.Pcc",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const TravellerConfigurationSource = {
  displayName: "Traveller Configuration Source",
  dataAt: "TravellerConfiguration.Source",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "TravellerConfigurationSources",
};

const PointsOfInterestFileUploader = {
  displayName: "Points Of Interest File Upload",
  dataAt: "PointsOfInterestFile",
  displayAs: constants.DISPLAY_AS.FILE_UPLOADER,
  fileContainer: "PointOfInterestBatchUpload",
  uploadType: "xlsx",
  fileNamePrefixProperty: "Name",
  fileNameSuffix: "_poi_import",
  fileNameFormat: "yyyymmdd",
  excludeFromPost: true,
};

const ShowPoiOnTop = {
  displayName: "Show Points of Interest at top of list",
  dataAt: "ShowPoiOnTop",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const HostCommands = {
  displayName: "Host Commands",
  dataAt: "HostCommands",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const AdditionalPnrRemarksAncillary = {
  displayName: "Ancillary Remarks",
  dataAt: "AdditionalPnrRemarksAncillary",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const HomeCountryCode = {
  displayName: "Home Country Code",
  dataAt: "HomeCountryCode",
  displayAs: constants.DISPLAY_AS.COUNTRY_SELECT,
  selectType: "single",
};

const DomesticCountryCodes = {
  displayName: "Domestic Country Codes",
  dataAt: "DomesticCountryCodes",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const DebtorOrderNumberCodes = {
  displayName: "Debtor Order Number Codes",
  dataAt: "DebtorOrderNumberCodes",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: DebtorOrderNumberCodesItem,
  gridCols: [
    { name: "Code", key: "Code" },
    { name: "Title", key: "Title" },
  ],
};

const AdditionalPnrRemarks = {
  displayName: "Additional Pnr Remarks",
  dataAt: "AdditionalPnrRemarks",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const AdditionalPnrRemarksModify = {
  displayName: "Additional Pnr Modify Remarks",
  dataAt: "AdditionalPnrRemarksModify",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const AdditionalPnrRemarksCancel = {
  displayName: "Additional Pnr Cancel Remarks",
  dataAt: "AdditionalPnrRemarksCancel",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const AdditionalPnrUserHoldRemarks = {
  displayName: "Additional Pnr User Hold Remarks",
  dataAt: "AdditionalPnrUserHoldRemarks",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const AdditionalPnrUserHoldConfirmedRemarks = {
  displayName: "Additional Pnr User Hold Confirmed Remarks",
  dataAt: "AdditionalPnrRemarksUserHoldConfirmed",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const AdditionalFinishBookingRemarks = {
  displayName: "Additional Finish Booking Remarks",
  dataAt: "AdditionalPnrRemarksFinishBooking",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const AdditionalPnrRemarksGuestTraveler = {
  displayName: "Additional Guest Traveler Remarks",
  dataAt: "AdditionalPnrRemarksGuestTraveler",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const ProfileCompanySize = {
  displayName: "Profile Company Size (no. of people)",
  dataAt: "Profile.CompanySize",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const ProfileIndustry = {
  displayName: "Profile Industry",
  dataAt: "Profile.Industry",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const ProfileAfterHoursPhoneNumber = {
  displayName: "Profile After Hours Phone Number",
  dataAt: "Profile.AfterHoursPhoneNumber",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const ProfileDaytimePhoneNumber = {
  displayName: "Profile Daytime Phone Number",
  dataAt: "Profile.DaytimePhoneNumber",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const ProfileCompanyIdentifier = {
  displayName: "Profile Company Identifier (Business number)",
  dataAt: "Profile.CompanyIdentifier",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const DebtorAddressCountryCode = {
  displayName: "Debtor Address Country Code",
  dataAt: "DebtorAddress.CountryCode",
  displayAs: constants.DISPLAY_AS.COUNTRY_SELECT,
  selectType: "single",
};

const DebtorAddressPostcode = {
  displayName: "Debtor Address Postcode",
  dataAt: "DebtorAddress.Postcode",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  validationRegex: "^[0-9]{5}(?:-[0-9]{4})?$",
  validationMessage: "Not a valid postal code",
};

const DebtorAddressState = {
  displayName: "Debtor Address State",
  dataAt: "DebtorAddress.State",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const DebtorAddressCityCode = {
  displayName: "Debtor Address City Code",
  dataAt: "DebtorAddress.CityCode",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const DebtorAddressCity = {
  displayName: "Debtor Address City",
  dataAt: "DebtorAddress.City",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const DebtorAddressStreet = {
  displayName: "Debtor Address Street",
  dataAt: "DebtorAddress.Street",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const DebtorAddressAddress = {
  displayName: "Debtor Address",
  dataAt: "DebtorAddress.Address",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const DebtorAddressLastname = {
  displayName: "Debtor Address Last name",
  dataAt: "DebtorAddress.Lastname",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const DebtorAddressFirstname = {
  displayName: "Debtor Address First name",
  dataAt: "DebtorAddress.Firstname",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const DebtorSupportCurrencyCode = {
  displayName: "Debtor Support Currency Code",
  dataAt: "DebtorSupport.CurrencyCode",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const DebtorSupportEmailAddress = {
  displayName: "Debtor Support Email",
  dataAt: "DebtorSupport.EmailAddress",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: "email",
};

const DebtorSupportPhoneNumber = {
  displayName: "Debtor Support Phone Number",
  dataAt: "DebtorSupport.PhoneNumber",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const DepartmentEnabled = {
  displayName: "Department Editable",
  dataAt: "Department.Enabled",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const DepartmentMandatory = {
  displayName: "Department Selection Mandatory",
  dataAt: "Department.Mandatory",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const DepartmentDisplayName = {
  displayName: "Department Display Name",
  dataAt: "DepartmentDisplayName",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const CostCentreEnabled = {
  displayName: "Cost Center Editable",
  dataAt: "CostCentre.Enabled",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const CostCentreMandatory = {
  displayName: "Cost Center Selection Mandatory",
  dataAt: "CostCentre.Mandatory",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const CostCentreDisplayName = {
  displayName: "Cost Center Display Name",
  dataAt: "CostCentreDisplayName",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const OrderNumberDisplayName = {
  displayName: "Order Number Display Name",
  dataAt: "OrderNumberDisplayName",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const ConsultingTeamEmail = {
  displayName: "Consulting Team Email",
  dataAt: "ConsultingTeamEmail",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  //inputType: 'email',
  validationRegex: "^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,6}$",
  validationMessage: "required or not a valid email address",
};

const DebtorName = {
  displayName: "Debtor Name",
  dataAt: "Name",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  validationRegex: "^(?!s*$).+",
  validationMessage: "Name is required",
};

const OrderNumberEnabled = {
  displayName: "Order Number Enabled",
  dataAt: "OrderNumberEnabled",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const OrderNumberMandatory = {
  displayName: "Order Number Selection Mandatory",
  dataAt: "OrderNumberMandatory",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const EnablePreBookSeatSelection = {
  displayName: "Enable Pre-Booking Seat Selection",
  dataAt: "FlightConfiguration.EnablePreBookSeatSelection",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

//LimitPassengerPolicy

const EnablePassengerLimit = {
  displayName: "Enable Limit Passenger Policy",
  dataAt: "FlightConfiguration.LimitPassengerPolicy.IsEnabled",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const FlightConfigurationPassengerLimit = {
  displayName: "Limit Count",
  dataAt: "FlightConfiguration.LimitPassengerPolicy.LimitCount",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: "number",
};

//LimitPassengerPolicy-DebtorIdentification

const LimitPassengerPolicyDebtorIdentificationType = {
  displayName: "Type",
  dataAt: "FlightConfiguration.LimitPassengerPolicy.DebtorIdentification.DebtorIdentificationType",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "DebtorIdentificationType",
  hideShowProperty: "DebtorIdentificationType"
};

const LimitPassengerPolicyDebtorIdentificationDefinedDks = {
  displayName: "DefinedDks",
  dataAt: "FlightConfiguration.LimitPassengerPolicy.DebtorIdentification.DefinedDks",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
  formClass: "DebtorIdentificationType_DefinedDks"
};

const LimitPassengerPolicyDebtorIdentificationGroupCodeValue = {
  displayName: "GroupCodeValue",
  dataAt: "FlightConfiguration.LimitPassengerPolicy.DebtorIdentification.GroupCodeValue",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  formClass: "DebtorIdentificationType_DefinedGroupCode"
};

//LimitPassengerPolicy-UdidConfigurations

const LimitPassengerPolicyUdidConfigurationType = {
  displayName: "Type",
  dataAt: "FlightConfiguration.LimitPassengerPolicy.UdidConfigurations.$udidConfigItem.UdidType",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "UdidConfigurationType",
  hideShowProperty: "UdidConfigurationType"
};

const LimitPassengerPolicyUdidStaticPreTripCode = {
  displayName: "PreTripCode",
  dataAt: "FlightConfiguration.LimitPassengerPolicy.UdidConfigurations.$udidConfigItem.PreTripCode",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
   formClass: "UdidConfigurationType_StaticUdid"
};

const LimitPassengerPolicyUdidStaticValue = {
  displayName: "Value",
  dataAt: "FlightConfiguration.LimitPassengerPolicy.UdidConfigurations.$udidConfigItem.Value",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  formClass: "UdidConfigurationType_StaticUdid"
};

const LimitPassengerPolicyUdidCompanyReferencePreTripCode = {
  displayName: "PreTripCode",
  dataAt: "FlightConfiguration.LimitPassengerPolicy.UdidConfigurations.$udidConfigItem.PreTripCode",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  formClass: "UdidConfigurationType_CompanyReference"
};

const LimitPassengerPolicyUdidCompanyReferenceCompanyRefCode = {
  displayName: "Code",
  dataAt: "FlightConfiguration.LimitPassengerPolicy.UdidConfigurations.$udidConfigItem.Value",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  formClass: "UdidConfigurationType_CompanyReference"
};


const LimitPassengerPolicyUdidAgencyReasonCodePreTripCode = {
  displayName: "PreTripCode",
  dataAt: "FlightConfiguration.LimitPassengerPolicy.UdidConfigurations.$udidConfigItem.PreTripCode",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  formClass: "UdidConfigurationType_AgencyReasonCode"
};

const LimitPassengerPolicyUdidItem = {
  displayName: "Udid Config",
  dataAt: "FlightConfiguration.LimitPassengerPolicy.UdidConfigurations.$udidConfigItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    LimitPassengerPolicyUdidConfigurationType,
    LimitPassengerPolicyUdidStaticPreTripCode,
    LimitPassengerPolicyUdidStaticValue,
    LimitPassengerPolicyUdidCompanyReferenceCompanyRefCode,
    LimitPassengerPolicyUdidCompanyReferencePreTripCode,
    LimitPassengerPolicyUdidAgencyReasonCodePreTripCode
  ],
  endpoint: "Debtors",
  routeParamId: "debtorId",
  removeParamId: "udidConfigItem",
  canDelete: true,
}

const UdidConfigurations = {
  displayName: "Udid Configurations",
  dataAt: "FlightConfiguration.LimitPassengerPolicy.UdidConfigurations",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: false,
  canAddNew: true,
  gridItem: LimitPassengerPolicyUdidItem,
  gridCols: [
    { name: "Type", key: "UdidType" },
    { name: "PreTripCode", key: "PreTripCode" },
    { name: "Value", key: "Value" }
  ]
};

//LimitPassengerPolicy-PolicyRestriction

const LimitPassengerPolicyRestrictiontionRestrictionType = {
  displayName: "Type",
  dataAt: "FlightConfiguration.LimitPassengerPolicy.PolicyRestriction.RestrictionType",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "PolicyRestrictionType",
  hideShowProperty: "PolicyRestrictionType"
};

const LimitPassengerPolicyRestrictionShowButNotAllowMessage = {
  displayName: "Message",
  dataAt: "FlightConfiguration.LimitPassengerPolicy.PolicyRestriction.DisplayMessage.Message",
  displayAs: constants.DISPLAY_AS.TEXT_AREA,
   formClass: "PolicyRestrictionType_ShowButNotAllow"
};

const LimitPassengerPolicyRestrictionDisplayMessageTitle = {
  displayName: "Title",
  dataAt: "FlightConfiguration.LimitPassengerPolicy.PolicyRestriction.DisplayMessage.Title",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  formClass: "PolicyRestrictionType_MessagePopup"
};

const LimitPassengerPolicyRestrictionDisplayMessage = {
  displayName: "Message",
  dataAt: "FlightConfiguration.LimitPassengerPolicy.PolicyRestriction.DisplayMessage.Message",
  displayAs: constants.DISPLAY_AS.TEXT_AREA,
  formClass: "PolicyRestrictionType_MessagePopup"
};

const LimitPassengerPolicyRestrictionSetOutOfPolicyMessage = {
  displayName: "Message",
  dataAt: "FlightConfiguration.LimitPassengerPolicy.PolicyRestriction.DisplayMessage.Message",
  displayAs: constants.DISPLAY_AS.TEXT_AREA,
  formClass: "PolicyRestrictionType_PolicyViolation"
};

const LimitPassengerPolicyRestrictionSetOutOfPolicyListId = {
  displayName: "ListId",
  dataAt: "FlightConfiguration.LimitPassengerPolicy.PolicyRestriction.PolicyViolation.ListId",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  formClass: "PolicyRestrictionType_PolicyViolation",
  html: "Company Reference ListId to pull option values to choose from."
};

const LimitPassengerPolicyRestrictionSetOutOfPolicyRemarkFormat = {
  displayName: "RemarkFormat",
  dataAt: "FlightConfiguration.LimitPassengerPolicy.PolicyRestriction.PolicyViolation.RemarkFormat",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  formClass: "PolicyRestrictionType_PolicyViolation",
  html: "Smart.Format used to write remark to booking.<br/>Exmple: .S*UD110 VIOLATION CODE {Value}<br/><i>Properties</i>" 
    + "<ul><li>ValueDescription</li><li>Value</li></ul>"
};

const DisableColleagueSeatMapDisplay = {
  displayName: "Colleague Seat Map Display Disabled",
  dataAt: "FlightConfiguration.DisableColleagueSeatMapDisplay",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const EnableSharedFlightOptions = {
  displayName: "Enable Shared Flight Options",
  dataAt: "FlightConfiguration.EnableSharedFlightOptions",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const CollectContactInformationForNDCBookings = {
  displayName: "Collect Contact Information for NDC Bookings",
  dataAt: "FlightConfiguration.CollectContactInformationForNDCBookings",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const EnableFareCodeDisplay = {
  displayName: "Fare Code Display Enabled",
  dataAt: "FlightConfiguration.EnableFareCodeDisplay",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const DisableTravelRequirements = {
  displayName: "Disable Travel Requirements",
  dataAt: "FlightConfiguration.DisableTravelRequirements",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const EnableMobileAirBooking = {
  displayName: "Enable Mobile Air Booking",
  dataAt: "FlightConfiguration.EnableMobileAirBooking",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const EnableMobileHotelBooking = {
  displayName: "Enable Mobile Hotel Booking",
  dataAt: "HotelConfiguration.EnableMobileHotelBooking",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const EnableMobileRailBooking = {
  displayName: "Enable Mobile Rail Booking",
  dataAt: "RailConfiguration.EnableMobileRailBooking",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const EnableMobileCarBooking = {
  displayName: "Enable Mobile Car Booking",
  dataAt: "CarConfiguration.EnableMobileCarBooking",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const EnabledAggregatorsForMobileHotelBooking = {
  displayName: "Enable Aggregators for Mobile Hotel Booking",
  dataAt: "HotelConfiguration.EnabledAggregatorsForMobileHotelBooking",
  displayAs: constants.DISPLAY_AS.O_DATA_SELECT,
  endpoint: "Settings",
  queryOption: "select",
  selectProperty: "HotelRateCategories",
  inputTitle: "Name",
  selectChoiceName: "Name",
  entityIdentifier: "Name",
  searchAllNo: true,
  isMultiSelect: true,
  additionalFilters: {
    "IsAggregator": true
  },
  showOnlySelectedField: true
};

const EnableCSL = {
  displayName: "Enable CSL",
  dataAt: "HotelConfiguration.EnableCSL",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const HotelConfigurationDisplayTax = {
  displayName: "Rate Display - Tax Inclusion Override",
  dataAt: "HotelConfiguration.TaxDisplayMode",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "TaxDisplayMode"
};

const HotelConfigurationPreferredTagsSourceType = {
  displayName: "CTM Preferred Tier Labels",
  dataAt: "HotelConfiguration.PreferredTagsSourceType",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "DebtorHotelPreferredTagsSourceType",
};

const HotelConfigurationTagsToIgnoreFromDatabaseSourceType = {
  displayName: "Hotel Config Tags to Ignore from Database",
  dataAt: "HotelConfiguration.TagsToIgnoreFromDatabaseSourceType",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "DebtorHotelConfigTagsToIgnoreFromDatabaseSourceType",
  hideShowProperty: "HotelConfigurationTagsToIgnoreFromDatabaseSourceType"
};

const HotelConfigurationTagsToIgnoreFromDatabase = {
  displayName: "Tags to Ignore",
  dataAt: "HotelConfiguration.TagsToIgnoreFromDatabase",
  displayAs: constants.DISPLAY_AS.O_DATA_SELECT,
  formClass: "HotelConfigurationTagsToIgnoreFromDatabaseSourceType_Customize",
  endpoint: "Hotels/GetAllTags",
  searchAllNo: true,
  isMultiSelect: true,
  showOnlySelectedField: true,
};

const EnableHotelAllowedCardRestriction = {
  displayName: "Enable Hotel Allowed Card Restriction",
  dataAt: "HotelConfiguration.EnableHotelAllowedCardRestriction",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const EnableSabreHotelDisplayOrder = {
  displayName: "Enable Sabre Hotel Display Order",
  dataAt: "HotelConfiguration.EnableSabreHotelDisplayOrder",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const HideSoldOutHotels = {
  displayName: "Default to hide hotels with sold out / out of policy rates",
  dataAt: "HotelConfiguration.HideSoldOutHotels",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const ExpandAdvancedHotelSearchOptions = {
  displayName: "Expand advanced hotel search options",
  dataAt: "HotelConfiguration.ExpandAdvancedHotelSearchOptions",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const HotelQuickSearchEnabled = {
  displayName: "Enable Hotel Quick Search (POC)",
  dataAt: "HotelConfiguration.QuickSearch.Enabled",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const HotelQuickSearchInitialPageCount = {
  displayName: "Hotel Quick Search Initial Page Count",
  dataAt: "HotelConfiguration.QuickSearch.InitialPageCount",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: "number",
};

const HotelQuickSearchAutoLoad = {
  displayName: "Hotel Quick Search Auto Load",
  dataAt: "HotelConfiguration.QuickSearch.AutoLoad",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const IataId = {
  displayName: "Hotel IATA ID (Sabre / AGT field)",
  dataAt: "HotelConfiguration.IataId",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const GuestTraveller = {
  displayName: "Guest Traveller Enabled",
  dataAt: "GuestTraveller.Enabled",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};
const GuestTravellerDeptCostCenterFop = {
  displayName:
    "Guest Traveller Enabled Department and Cost Center Fop Handling",
  dataAt: "GuestTraveller.EnableGuestDeptCostCtrFopHandling",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const GuestTravellerAllowTempCards = {
  displayName: "Guest Traveller Allow Temp/Personal Cards",
  dataAt: "GuestTraveller.GuestTravellerAllowTempCards",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const GuestTravellerAllowTempCardsSub = {
  displayAs: constants.DISPLAY_AS.SUB_HEADING,
  label:
    "Guest Traveler Allow Temp/Personal Cards. Overrides Debtor Settings configured for Temp Cards.",
};

const ShowCommentToTravelAgent = {
  displayName: "Show Comment to Travel Agent",
  dataAt: "ShowCommentToTravelAgent",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const CancelBookingEnabled = {
  displayName: "Cancel Booking Enabled",
  dataAt: "CancelBookingEnabled",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const UserHoldEnabled = {
  displayName: "User Hold Enabled",
  dataAt: "UserHoldEnabled",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};
const CancellationWindowMinutes = {
  displayName: "Cancellation Window in Minutes",
  dataAt: "CancellationWindowMinutes",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: "number",
};

const OfflinePnrEnabled = {
  displayName: "Offline PNR Enabled",
  dataAt: "OfflinePnrEnabled",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const AdditionalTravelerInfo = {
  displayName: "Additional Traveler Information Enabled",
  dataAt: "GuestTraveller.AdditionalTravelerInfo",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const PaymentMethodDisabled = {
  displayName: "Payment Methods Disabled",
  dataAt: "PaymentMethodDisabled",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
  helpText: "Disables temporary form of payment."
};

const PaymentMethodSelectionMandatory = {
  displayName: "Payment Method Selection Mandatory",
  dataAt: "PaymentMethodSelectionMandatory",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
  helpText: "When checked system will not default form of payment."
};

const Disabled = {
  displayName: "DISABLED",
  dataAt: "Disabled",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const TestAccount = {
  displayName: "TEST ACCOUNT",
  dataAt: "DebtorIsTest",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const FareDebugging = {
  displayName: "Fare Debugging Enabled",
  dataAt: "IsFareDebuggingEnabled",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const EnableCarAiRecommendation = {
  displayName: "Enable Car AI Recommendations",
  dataAt: "AiMlConfigs.IsCarAIRecommendationsEnabled",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const EnableHotelAiRecommendation = {
  displayName: "Enable Hotel AI Recommendations",
  dataAt: "AiMlConfigs.IsHotelAIRecommendationsEnabled",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const EnableModificationCar = {
  displayName: "Enable Car Modify",
  dataAt: "Modifications.IsCarModifyEnabled",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};
const EnableModificationHotel = {
  displayName: "Enable Hotel Modify",
  dataAt: "Modifications.IsHotelModifyEnabled",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};
const EnableModificationAir = {
  displayName: "Enable Air Modify",
  dataAt: "Modifications.IsAirModifyEnabled",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};
const EnableModificationGround = {
  displayName: "Enable Ground Modify",
  dataAt: "Modifications.IsGroundModifyEnabled",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};
const EnableModificationRail = {
  displayName: "Enable Rail Modify",
  dataAt: "Modifications.IsRailModifyEnabled",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const HotelCarFopHandlingType = {
  displayName: "Hotel Car Only Booking Fop Handling Type",
  dataAt: "HotelCarOnlyFopHandling.FopHandlingType",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "DebtorFopHandlingTypes",
};

const HotelCarDefinedCreditCardId = {
  displayName: "Hotel Car Only Booking Fop Defined Credit Card Id",
  dataAt: "HotelCarOnlyFopHandling.DefinedCreditCardId",
  displayAs: constants.DISPLAY_AS.O_DATA_SELECT,
  endpoint: "CreditCards",
  searchType: "Title",
  expression: "contains",
  searchAllNo: true,
};

const EnableHonoluluTripFeed = {
  displayName: "Enable Honolulu TripFeed",
  dataAt: "MobileConfigs.UseHonoluluTripFeed",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const Title = {
  displayName: "Title",
  dataAt: "Title",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  required: true,
};

const Id = {
  displayName: "Identifier",
  dataAt: "Id",
  disabled: true,
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const DateFormatLongSettings = {
  displayName: "Date Format Long",
  dataAt: "DateTimeSettings.DateFormatLong",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  label: "Default format: MMM Do YYYY."
}

const DateFormatMediumSettings = {
  displayName: "Date Format Medium",
  dataAt: "DateTimeSettings.DateFormatMedium",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  label: "Default format: MMM DD, YYYY."
}

const DateFormatShortSettings = {
  displayName: "Date Format Short",
  dataAt: "DateTimeSettings.DateFormatShort",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  label: "Default format: MM/DD/YYYY."
}

const DatetimeFormatLongSettings = {
  displayName: "Datetime Format",
  dataAt: "DateTimeSettings.DateTimeFormatLong",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  label: "Default format: ddd, MMM D YYYY [at] h:mm a."
}

const TimeFormatLongSettings = {
  displayName: "Time Format Long",
  dataAt: "DateTimeSettings.TimeFormatLong",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  label: "Default format: h:mm a."
}

const EnableNewUiHandlingType = {
  displayName: "Enable New UI",
  dataAt: "EnableNewUiHandlingType",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "EnableNewUiHandlingType"
};

const AdminPanel = {
  tabName: "Admin",
  dataAt: "",
  displayAs: constants.DISPLAY_AS.GROUP,
  children: [CreatedBy, CreatedOn, ModifiedBy, ModifiedOn],
};

const DatetimeFormatPanel = {
  tabName: "Datetime-Format",
  dataAt: "",
  displayAs: constants.DISPLAY_AS.GROUP,
  children: [ DateFormatLongSettings, DateFormatMediumSettings, DateFormatShortSettings, DatetimeFormatLongSettings, TimeFormatLongSettings ],
};

const TramadaConfigurationPanel = {
  dataAt: "",
  displayAs: constants.DISPLAY_AS.GROUP,
  tabName: "Tramada",
  children: [
    TramadaConfigurationAgencyId,
    TramadaConfigurationDebtorId,
    TramadaConfigurationDebtorAuthCode,
    TramadaConfigurationDatabase,
  ],
};

const GdsProviderPrimary = {
  displayName: "Gds Provider Primary",
  dataAt: "GdsProviderPrimary",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "GDSProvidersPrimary",
};

///GDS Amedeus Configuration
const GdsAmadeusBranch = {
  displayName: "Debtor Branch",
  dataAt: "GdsConfigurationAmadeus.Branch",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const buildAmadeusQueueFields = (queueName, title) => {
  const dataAt = `GdsConfigurationAmadeus.${queueName}`;

  return [
    {
      displayAs: constants.DISPLAY_AS.SUB_HEADING,
      titleHeader: title,
      formClass: "clear"
    },
    {
      displayName: "Queue Number",
      dataAt: `${dataAt}.Number`,
      displayAs: constants.DISPLAY_AS.TEXT_INPUT,
      inputType: "number",
      min: 1,
      formClass: "width100"
    },
    {
      displayName: "Category",
      dataAt: `${dataAt}.Category`,
      displayAs: constants.DISPLAY_AS.TEXT_INPUT,
      formClass: "width100"
    },
    {
      displayName: "Office",
      dataAt: `${dataAt}.Office`,
      displayAs: constants.DISPLAY_AS.TEXT_INPUT,
      formClass: "width100",
      helpText: "Optional. Leave blank to use the Amadeus debtor branch."
    }
  ];
};

const GDSPanel = {
  dataAt: "",
  tabName: "GDS",
  displayAs: constants.DISPLAY_AS.GROUP,
  children: [
    DebtorGds,
    GdsProviderPrimary,
    {
      displayAs: constants.DISPLAY_AS.SUB_HEADING,
      html: "<div><h2>Sabre Gds Configuration</h2></div>"
      
    },
    Pcc,
    PccCity,
    {
      displayAs: constants.DISPLAY_AS.SUB_HEADING,
      html: "<h4>Queue Placements</h4><small>Leave Pcc blank to leverage debtor Pcc.</small>"
      
    },
    {
      displayAs: constants.DISPLAY_AS.SUB_HEADING,
      titleHeader: "Authorisation Hold",
      formClass: "widthLabe150 clear"
    },
    AuthorisationHoldQueuePcc,
    AuthorisationHoldQueue,
    {
      displayAs: constants.DISPLAY_AS.SUB_HEADING,
      titleHeader: "Auto Ticketing",
      formClass: "widthLabe150 clear"
    },
    AutoTicketingQueuePcc,
    AutoTicketingQueue,
    {
      displayAs: constants.DISPLAY_AS.SUB_HEADING,
      titleHeader: "Team Rejection",
      formClass: "widthLabe150 clear"
    },
    TeamRejectionQueuePcc,
    TeamRejectionQueue,
    {
      displayAs: constants.DISPLAY_AS.SUB_HEADING,
      titleHeader: "Cancel",
      formClass: "widthLabe150 clear"
    },
    CancelQueuePcc,
    CancelQueue,
    {
      displayAs: constants.DISPLAY_AS.SUB_HEADING,
      titleHeader: "Modification",
      formClass: "widthLabe150 clear"
    },
    ModificationQueuePcc,
    ModificationQueue,
    {
      displayAs: constants.DISPLAY_AS.SUB_HEADING,
      titleHeader: "User Hold",
      formClass: "widthLabe150 clear"
    },
    UserHoldQueuePcc,
    UserHoldQueue,
    {
      displayAs: constants.DISPLAY_AS.SUB_HEADING,
      formClass: "clear",
      html: "<div><h2>Amadeus Gds Configuration</h2></div>"
      
    },
    GdsAmadeusBranch,
    ...buildAmadeusQueueFields("AuthorisationHoldQueue", "Authorisation Hold Queue"),
    ...buildAmadeusQueueFields("AutoTicketingQueue", "Auto Ticketing Queue"),
    ...buildAmadeusQueueFields("CancelQueue", "Cancellation Queue"),
    ...buildAmadeusQueueFields("ModificationQueue", "Modification Queue"),
    ...buildAmadeusQueueFields("UserHoldQueue", "User Hold Queue"),
    ...buildAmadeusQueueFields("TeamRejectionQueue", "Team Rejection Queue")
  ]
};

const UnusedTicketPanel = {
  dataAt: "",
  tabName: "Unused-Tickets",
  displayAs: constants.DISPLAY_AS.GROUP,
  children: [
    EnableUnusedTicketDebtorSettings,
    {
      displayAs: constants.DISPLAY_AS.SUB_HEADING,
      label:
        "When Use Unused Ticket Debtor Configuration is checked, the below providers will be leveraged. When not checked system settings will be leveraged.",
    },
    UnusedTicketSettings,
  ],
};

const AllSectorConfigPanel = {
  dataAt: "",
  displayAs: constants.DISPLAY_AS.GROUP,
  tabName: "All-Sectors",
  children: [
    DebtorLimitCountries,
    DebtorLimitAirportClassification,
    EnableCarAiRecommendation,
    EnableHotelAiRecommendation,
    EnableModificationCar,
    EnableModificationHotel,
    EnableModificationAir,
    EnableModificationGround,
    EnableModificationRail,
    EnableParallelSearches,
    DisableLoyaltyPrograms,
    EnableItineraryValidatorDebtorSettings,
    ItineraryValidatorSettings,
    BookingThreshold,
    {
      displayAs: constants.DISPLAY_AS.SUB_HEADING,
      html:
        "TTL Threshold: Amount of time to subtract from the calculated last time to cancel. The default value is 1 hour when not set.<br/>" 
        + "<small>Example: Hotel booked 30 days in the future and last date to cancel is 25 days in the future then default TTL will be 24 days and 23 hours from booking.</small><br/>",
    },
   
    TtlThresholdFlight,
    TtlThresholdHotel,
    TtlThresholdCar,
    TtlThresholdRail,
    TtlThresholdGround,
    HomeSearchDefaultSelection
  ],
};

const MobileConfigPanel = {
  dataAt: "",
  displayAs: constants.DISPLAY_AS.GROUP,
  tabName: "Mobile",
  children: [
    EnableMobileAirBooking,
    EnableMobileHotelBooking,
    EnableMobileRailBooking,
    EnableMobileCarBooking,
    EnableHonoluluTripFeed,
    EnabledAggregatorsForMobileHotelBooking
  ],
};

const HotelConfigurationPanel = {
  dataAt: "",
  displayAs: constants.DISPLAY_AS.GROUP,
  tabName: "Hotel-Sectors",
  children: [
    HotelConfigurationEnableOvernightHotelPrompt,
    HotelConfigurationIsImperialSystem,
    EnableCSL,
    EnableHotelAllowedCardRestriction,
    EnableSabreHotelDisplayOrder,
    HideSoldOutHotels,
    ExpandAdvancedHotelSearchOptions,
    IataId,
    {
      displayAs: constants.DISPLAY_AS.SUB_HEADING,
      label:
        "Override Sabre TJR with /AGT field.",
    },
    HotelConfigurationAggregators,
    HotelConfigurationRadiusDefaultRadius,
    HotelConfigurationDisplayTax,
    HotelConfigurationPreferredTagsSourceType,
    HotelConfigurationTagsToIgnoreFromDatabaseSourceType,
    HotelConfigurationTagsToIgnoreFromDatabase,
    HotelConfigurationRadiusCities,
    HotelConfigurationHotelAmenityFiltersGrid,
    HotelConfigurationPaymentNarratives,
    HotelConfigurationTags,
    HotelQuickSearchEnabled,
    {
      displayAs: constants.DISPLAY_AS.SUB_HEADING,
      label:
        "Dark release POC used for testing only.",
    },
    HotelQuickSearchInitialPageCount,
    HotelQuickSearchAutoLoad,
  ],
};

const RailConfigPanel = {
  dataAt: "",
  displayAs: constants.DISPLAY_AS.GROUP,
  tabName: "Rail-Sectors",
  children: [RailConfiguration, RailSupplierSettings,
    {
      displayAs: constants.DISPLAY_AS.SUB_HEADING,
      html:
        "<h4>Rail Ticketing Configuration</h4><br/><small>When remark text is populated system will pause ticketing until remark exist in the Sabre booking.<br/>If no remark is set then system will ticket rail reservation immediately.</small>",
    },
    {
      displayName: "Rail Ticketing Use Debtor Setting",
      dataAt: "RailConfiguration.RailTicketingRemark.UserDebtorSetting",
      displayAs: constants.DISPLAY_AS.BOOLEAN,
      helpText: "When not checked system setting will be used."
    },
    {
      displayName: "Rail Ticketing Remark Type",
      dataAt: "RailConfiguration.RailTicketingRemark.RemarkType",
      displayAs: constants.DISPLAY_AS.SELECT,
      optionsAt: "RemarkType",
    },
    {
      displayName: "Rail Ticketing Remark Text",
      dataAt: "RailConfiguration.RailTicketingRemark.RemarkText",
      displayAs: constants.DISPLAY_AS.TEXT_INPUT,
      html: "<small><i>Leave blank to not pause ticketing.</i> Remark Text can be a regular expression</small>"
    },
    {
      displayName: "Rail Ticketing Remark Code",
      dataAt: "RailConfiguration.RailTicketingRemark.RemarkCode",
      displayAs: constants.DISPLAY_AS.TEXT_INPUT,
      label: "Optional value used when remark type is Alpha-Coded"
    },
    {
      displayName: "Additional Confirmation Emails (max 2)",
      dataAt: "RailConfiguration.AdditionalConfirmationEmails",
      displayAs: constants.DISPLAY_AS.TAG_INPUT,
      validationItemLimit: 2
    }
  ],
};

//Start FlightModificationSettingGdsProviders
const FlightModificationSettingGdsProviders = {
  displayName: "Gds Providers",
  dataAt: "FlightConfiguration.FlightModificationSettings.$iiflightModificationSettingItem.GdsProviders",
  displayAs: constants.DISPLAY_AS.MULTI_SELECT,
  optionsAt: "GDSProviders",
};

const FlightModificationSettingCarriersExcluded = {
  displayName: "Carriers Excluded",
  dataAt: "FlightConfiguration.FlightModificationSettings.$iiflightModificationSettingItem.CarriersExcluded",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
  validationRegex: "^$|^[A-Za-z0-9]{2}(?:[\\s,]+[A-Za-z0-9]{2})*$",
  validationMessage: "Use 2-character carrier codes (letters or numbers), e.g., AA, F9.",
};

const FlightModificationSettingCarriersIncluded = {
  displayName: "Carriers Included",
  dataAt: "FlightConfiguration.FlightModificationSettings.$iiflightModificationSettingItem.CarriersIncluded",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
  validationRegex: "^$|^[A-Za-z0-9]{2}(?:[\\s,]+[A-Za-z0-9]{2})*$",
  validationMessage: "Use 2-character carrier codes (letters or numbers), e.g., AA, F9.",
};

const FlightModificationSettingEnableCancelRebook = {
  displayName: "Enable Cancel Rebook",
  dataAt: "FlightConfiguration.FlightModificationSettings.$iiflightModificationSettingItem.EnableCancelRebook",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};
const FlightModificationSettingEnableExchanges = {
  displayName: "Enable Exchanges",
  dataAt: "FlightConfiguration.FlightModificationSettings.$iiflightModificationSettingItem.EnableExchanges",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};
const FlightModificationSettingEnableAdd = {
  displayName: "Enable Add",
  dataAt: "FlightConfiguration.FlightModificationSettings.$iiflightModificationSettingItem.EnableAdd",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};
const DebtorFlightModificationSettingItem = {
  displayName: "Item",
  dataAt: "FlightConfiguration.FlightModificationSettings.$iiflightModificationSettingItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [FlightModificationSettingGdsProviders,FlightModificationSettingCarriersExcluded,
    FlightModificationSettingCarriersIncluded,
    FlightModificationSettingEnableCancelRebook,
    FlightModificationSettingEnableExchanges,
    FlightModificationSettingEnableAdd
  ],
  endpoint: "Debtors",
  removeParamId: "iiflightModificationSettingItem",
  canDelete: true,
};
const FlightModificationSettingsGrid = {
  tabName: "Flight-Modification-Settings",
  displayName: "Flight Modification Settings",
  dataAt: "FlightConfiguration.FlightModificationSettings",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: DebtorFlightModificationSettingItem,
  copyWithoutCopyText: true,
  gridCols: [
    { name: "Providers", key: "GdsProviders" },
    { name: "CancelRebook", key: "EnableCancelRebook" },
    { name: "Exchanges", key: "EnableExchanges" },
    { name: "Add", key: "EnableAdd" },
    { name: "Excluded", key: "CarriersExcluded" },
    { name: "Included", key: "CarriersIncluded" },
  ]
};
//End FlightModificationSettingGdsProviders

//Start FlightSearch
const FlightSearchConfigurationConfigurationType = {
  displayName: "Flight Search Configuration Type",
  dataAt: "FlightConfiguration.FlightSearch.ConfigurationType",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "FlightSearchConfigurationType"
};

const FlightSearchConfigurationCarrierType = {
  displayName: "Carrier Type",
  dataAt: "FlightConfiguration.FlightSearch.Queries.$iflightSearchConfigurationItem.CarrierType",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "FlightSearchConfigurationQueryItemsType",
  helpText: "Single: 1 search performed which includes all defined carriers. Multi: 1 search for each carrier defined."
};

const FlightSearchConfigurationCarriers = {
  displayName: "Carriers",
  dataAt: "FlightConfiguration.FlightSearch.Queries.$iflightSearchConfigurationItem.Carriers",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
  html: "<span class=\"help-block\">" +
      "Named lists are supported. Wrap name in ~ characters. Example: ~ExcludedCarriers~<br/><br />" +
      "Enter XX with carrier type = Multi will perform an exclusion with all the other carriers excluded.<br/>" +
      "Example: XX, AA entered as values will perform 2 queries. 1 with AA and another with excluding AA and any other configured excluded carriers." +
      "</span>"
};

const FlightSearchConfigurationExcludeCarriers = {
  displayName: "Exclude Carriers",
  dataAt: "FlightConfiguration.FlightSearch.Queries.$iflightSearchConfigurationItem.ExcludeCarriers",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
  helpText: "Named lists are supported. Wrap name in ~ characters. Example: ~ExcludedCarriers~"
};

const FlightSearchConfigurationCabinType = {
  displayName: "Cabin Type",
  dataAt: "FlightConfiguration.FlightSearch.Queries.$iflightSearchConfigurationItem.CabinType",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "FlightSearchConfigurationQueryItemsTypeMultiOnly",
  helpText: "Sabre only supports single cabin queries. Therefore Multi is the only available option."
};

const FlightSearchConfigurationCabins = {
  displayName: "Cabins",
  dataAt: "FlightConfiguration.FlightSearch.Queries.$iflightSearchConfigurationItem.Cabins",
  displayAs: constants.DISPLAY_AS.MULTI_SELECT,
  optionsAt: "FlightCabins",
  
};
const FlightSearchPassengerTypes = {
  displayName: "Passenger Types",
  dataAt: "FlightConfiguration.FlightSearch.Queries.$iflightSearchConfigurationItem.PassengerTypes",
  displayAs: constants.DISPLAY_AS.MULTI_SELECT,
  optionsAt: "PassengerTypes",
  allowFreeform: true,
  transformUppercase: true,
  validationRegex: "^[A-Z0-9]{3}$",
  validationMessage: "Each passenger type must be exactly 3 alphanumeric characters",
};
const FlightSearchConfigurationIncDebtorPreferred = {
  displayName: "Include Debtor Preferred",
  dataAt: "FlightConfiguration.FlightSearch.Queries.$iflightSearchConfigurationItem.IncDebtorPreferred",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const FlightSearchConfigurationRefundableSearch = {
  displayName: "Penalty Search Type",
  dataAt: "FlightConfiguration.FlightSearch.Queries.$iflightSearchConfigurationItem.RefundableSearchTypes",
  displayAs: constants.DISPLAY_AS.MULTI_SELECT,
  optionsAt: "PenaltySearchTypes",
};

const FlightSearchConfigurationUnbrandedSearch = {
  displayName: "Unbranded Search",
  dataAt: "FlightConfiguration.FlightSearch.Queries.$iflightSearchConfigurationItem.UnbrandedSearch",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const FlightSearchConfigurationEnableATPCO = {
  displayName: "Enable ATPCO",
  dataAt: "FlightConfiguration.FlightSearch.Queries.$iflightSearchConfigurationItem.EnableATPCO",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const FlightSearchConfigurationEnableNDC = {
  displayName: "Enable NDC",
  dataAt: "FlightConfiguration.FlightSearch.Queries.$iflightSearchConfigurationItem.EnableNDC",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
  helpText: "Leave Enabled ATPCO and Enabled NDC un-checked to use Debtor Configuration."
};
const FlightSearchConfigurationMaxStopsQuantity = {
  displayName: "Max Stops Quantity",
  dataAt:
    "FlightConfiguration.FlightSearch.Queries.$iflightSearchConfigurationItem.MaxStopsQuantity",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: "number",
};
const FlightSearchConfigurationCountryOrigin = {
  displayName: "Origin Countries",
  dataAt: "FlightConfiguration.FlightSearch.Queries.$iflightSearchConfigurationItem.CountryOrigin",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
  helpText: "If set, query will only be used if Origin country codes are in the list. ** Named list support"
};
const FlightSearchConfigurationCountryDestination = {
  displayName: "Destination Countries",
  dataAt: "FlightConfiguration.FlightSearch.Queries.$iflightSearchConfigurationItem.CountryDestination",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
  helpText: "If set, query will only be used if Destination country codes are in the list. ** Named list support"
};

const FlightSearchConfigurationPriority = {
  displayName: "Priority",
  dataAt: "FlightConfiguration.FlightSearch.Queries.$iflightSearchConfigurationItem.Priority",
  displayAs: constants.DISPLAY_AS.MULTI_SELECT,
  optionsAt: "FlightConfigurationPriority",
  html:"Leave blank for system configuration. Enter the order of priority. First 1 in list is the highest priority."
};

const FlightSearchConfigurationKeepSameCabin = {
  displayName: "Keep Same Cabin",
  dataAt: "FlightConfiguration.FlightSearch.Queries.$iflightSearchConfigurationItem.KeepSameCabin",
  helpText: "BFM Configuration leave blank for default configuration",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "BoolNullableType",
  handleAsString:true,
  allowNullable:true
};

const FlightSearchConfigurationFareFocusRulesExclude = {
  displayName: "Fare Focus Rules Exclude",
  dataAt: "FlightConfiguration.FlightSearch.Queries.$iflightSearchConfigurationItem.FareFocusRulesExclude",
  helpText: "BFM Configuration leave blank for default configuration",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "BoolNullableType",
  handleAsString:true,
  allowNullable:true
};
const FlightSearchConfigurationOfferControlRulesExclude = {
  displayName: "Offer Control Rules Exclude",
  dataAt: "FlightConfiguration.FlightSearch.Queries.$iflightSearchConfigurationItem.OfferControlRulesExclude",
  helpText: "BFM Configuration leave blank for default configuration",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "BoolNullableType",
  handleAsString:true,
  allowNullable:true
};
const FlightSearchConfigurationItineraryCount = {
  displayName: "Itinerary Count",
  dataAt: "FlightConfiguration.FlightSearch.Queries.$iflightSearchConfigurationItem.ItineraryCount",
  helpText: "BFM Configuration leave blank for default configuration",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: "number",
};
const FlightSearchConfigurationNumTrips = {
  displayName: "Num Trips",
  dataAt: "FlightConfiguration.FlightSearch.Queries.$iflightSearchConfigurationItem.NumTrips",
  helpText: "BFM Configuration leave blank for default configuration",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: "number",
};
const FlightSearchConfigurationVendorPrefApplicabilityAtLeastOne = {
  displayName: "Vendor Pref Applicability AtLeast One",
  dataAt: "FlightConfiguration.FlightSearch.Queries.$iflightSearchConfigurationItem.VendorPrefApplicabilityAtLeastOne",
  helpText: "BFM Configuration leave blank for default configuration",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "BoolNullableType",
  handleAsString:true,
  allowNullable:true
};
const FlightSearchConfigurationCarrierFilterApplyValidatingCarrier = {
  displayName: "Carrier Filter Apply Validating Carrier",
  dataAt: "FlightConfiguration.FlightSearch.Queries.$iflightSearchConfigurationItem.CarrierFilterApplyValidatingCarrier",
  helpText: "BFM Configuration leave blank for default configuration",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "BoolNullableType",
  handleAsString:true,
  allowNullable:true
};
const FlightSearchConfigurationDiversityHandling = {
  displayName: "Diversity Handling",
  dataAt: "FlightConfiguration.FlightSearch.Queries.$iflightSearchConfigurationItem.DiversityHandling",
  helpText: "BFM Configuration leave blank for default configuration",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "DiversityHandlingType"
};

const FlightSearchConfigurationAdditionalNonStopsPercentage = {
  displayName: "Additional NonStops Percentage",
  dataAt: "FlightConfiguration.FlightSearch.Queries.$iflightSearchConfigurationItem.AdditionalNonStopsPercentage",
  helpText: "BFM Configuration leave blank for default configuration",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: "number",
};
const FlightSearchConfigurationLowFareBucketFareCutOffPercentage = {
  displayName: "Low Fare Bucket Fare Cut Off Percentage",
  dataAt: "FlightConfiguration.FlightSearch.Queries.$iflightSearchConfigurationItem.LowFareBucketFareCutOffPercentage",
  helpText: "BFM Configuration leave blank for default configuration",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: "number",
};
const FlightSearchConfigurationLowFareBucketOptionsPercentage = {
  displayName: "Low FareBucket Options Percentage",
  dataAt: "FlightConfiguration.FlightSearch.Queries.$iflightSearchConfigurationItem.LowFareBucketOptionsPercentage",
  helpText: "BFM Configuration leave blank for default configuration.",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: "number",
};
const FlightSearchConfigurationSetBrandedFareOptions = {
  displayName: "Set BrandedF are Options",
  dataAt: "FlightConfiguration.FlightSearch.Queries.$iflightSearchConfigurationItem.SetBrandedFareOptions",
  helpText: "When not checked system will use system configuration. To override check this box and set Multiple and Single branded fare values below.",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const FlightSearchConfigurationMultipleBrandedFare = {
  displayName: "Multiple Branded Fare",
  dataAt: "FlightConfiguration.FlightSearch.Queries.$iflightSearchConfigurationItem.MultipleBrandedFare",
  helpText: "BFM Configuration leave blank for default configuration. Ignored when Set Branded Fare Options = false",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "BoolNullableType",
  handleAsString:true,
  allowNullable:true
};
const FlightSearchConfigurationSingleBrandedFare = {
  displayName: "Single Branded Fare",
  dataAt: "FlightConfiguration.FlightSearch.Queries.$iflightSearchConfigurationItem.SingleBrandedFare",
  helpText: "BFM Configuration leave blank for default configuration. Ignored when Set Branded Fare Options = false",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "BoolNullableType",
  handleAsString:true,
  allowNullable:true
};

const FlightSearchConfigurationTimeWindowsOutbound = {
  displayName: "Time Windows Outbound",
  dataAt: "FlightConfiguration.FlightSearch.Queries.$iflightSearchConfigurationItem.TimeWindowsOutbound",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
  html: "List of time windows. <br/>- use for empty value. This means system will use configured time window. Either none or configured default time window. <br/>" + 
  "Format: HHmmHHmm example: 12002359 Begin time in HHmm followed by end time HHmm. Note end time 2400 is not valid. Enter 2359.<br/> " + 
  "Example all day: 00002359<br/>" + 
  "Enter number for plus or minus range. Example 120 will be plus and minus 120 min from chosen depart time.",
};

const FlightSearchConfigurationTimeWindowRange = {
  displayName: "Time Window Range (Min)",
  dataAt: "FlightConfiguration.FlightSearch.Queries.$iflightSearchConfigurationItem.TimeWindowRange",
  helpText: "Overrides configuration with defined plus and minus time wondow for searched for time. Enter number of minutes to define range for search time.",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: "number",
};

const FlightSearchConfigurationIsCombinable = {
  displayName: "Is Combinable",
  dataAt: "FlightConfiguration.FlightSearch.Queries.$iflightSearchConfigurationItem.IsCombinable",
  helpText: "Search configuration is only included if doing a combinable search or not. Leave blank or not set to always include.",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "BoolNullableType",
  handleAsString:true,
  allowNullable:true
};
const FlightSearchConfigurationIncludeCountryCarriers = {
  displayName: "Include Country Carriers",
  dataAt: "FlightConfiguration.FlightSearch.Queries.$iflightSearchConfigurationItem.IncludeCountryCarriers",
  helpText: "System to include Country Carriers in carrier list. Based on origin and destination countries.",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "BoolNullableType",
  handleAsString:true,
  allowNullable:true
};

const DebtorFlightSearchConfigurationItem = {
  displayName: "Item",
  dataAt: "FlightConfiguration.FlightSearch.Queries.$iflightSearchConfigurationItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [FlightSearchConfigurationCarrierType,
    FlightSearchConfigurationCarriers,
    FlightSearchConfigurationExcludeCarriers,
    FlightSearchConfigurationCabinType,
    FlightSearchConfigurationCabins,
    FlightSearchConfigurationRefundableSearch,
    FlightSearchPassengerTypes,
    FlightSearchConfigurationIncDebtorPreferred,
    FlightSearchConfigurationUnbrandedSearch,
    FlightSearchConfigurationEnableATPCO,
    FlightSearchConfigurationEnableNDC,
    FlightSearchConfigurationMaxStopsQuantity,
    FlightSearchConfigurationCountryOrigin,
    FlightSearchConfigurationCountryDestination,

    FlightSearchConfigurationIsCombinable,
    FlightSearchConfigurationIncludeCountryCarriers,
    FlightSearchConfigurationTimeWindowsOutbound,
    FlightSearchConfigurationTimeWindowRange,
    FlightSearchConfigurationPriority,
    FlightSearchConfigurationKeepSameCabin,
    FlightSearchConfigurationFareFocusRulesExclude,
    FlightSearchConfigurationOfferControlRulesExclude,
    FlightSearchConfigurationItineraryCount,
    FlightSearchConfigurationNumTrips,
    FlightSearchConfigurationVendorPrefApplicabilityAtLeastOne,
    FlightSearchConfigurationCarrierFilterApplyValidatingCarrier,
    FlightSearchConfigurationDiversityHandling,
    FlightSearchConfigurationAdditionalNonStopsPercentage,
    FlightSearchConfigurationLowFareBucketFareCutOffPercentage,
    FlightSearchConfigurationLowFareBucketOptionsPercentage,
    FlightSearchConfigurationSetBrandedFareOptions,
    FlightSearchConfigurationMultipleBrandedFare,
    FlightSearchConfigurationSingleBrandedFare,
    
],
  endpoint: "Debtors",
  removeParamId: "iflightSearchConfigurationItem",
  canDelete: true,
};
const FlightSearchGrid = {
  tabName: "Flight-Search-Configuration",
  displayName: "Flight Search Configuration",
  dataAt: "FlightConfiguration.FlightSearch.Queries",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  copyWithoutCopyText: true,
  gridItem: DebtorFlightSearchConfigurationItem,
  gridCols: [
   { name: "CrrT", key: "CarrierType" },
    { name: "Crrs", key: "Carriers" },
    { name: "ExCrrs", key: "ExcludeCarriers" },
    { name: "CbnT", key: "CabinType" },
    { name: "Cbn", key: "Cabins" },
    { name: "Rfd", key: "RefundableSearchTypes" },
    { name: "Pax", key: "PassengerTypes" },
    { name: "Pref", key: "IncDebtorPreferred" },
    { name: "UnBrd", key: "UnbrandedSearch" },
    { name: "ATPCO", key: "EnableATPCO" },
    { name: "NDC", key: "EnableNDC" },
    { name: "Stp", key: "MaxStopsQuantity" },
    { name: "Org", key: "CountryOrigin" },
    { name: "Dst", key: "CountryDestination" },
  ]
};
//End FlightSearch

//Start Custom Airport Hubs
const DebtorCustomAirportHubName = {
  displayName: "Name",
  dataAt: "FlightConfiguration.CustomAirportHubs.$idebtorCustomAirportHubsItem.Name",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const DebtorCustomAirportHubAirports = {
  displayName: "Airports",
  dataAt: "FlightConfiguration.CustomAirportHubs.$idebtorCustomAirportHubsItem.Airports",
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const DebtorCustomAirportHubsItem = {
  displayName: "Item",
  dataAt: "FlightConfiguration.CustomAirportHubs.$idebtorCustomAirportHubsItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [DebtorCustomAirportHubName,
    DebtorCustomAirportHubAirports
],
  endpoint: "Debtors",
  removeParamId: "idebtorCustomAirportHubsItem",
  canDelete: true,
};

const DebtorCustomAirportHubsGrid = {
  tabName: "Custom-Airport-Hubs",
  displayName: "Custom Airport Hubs",
  dataAt: "FlightConfiguration.CustomAirportHubs",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  copyWithoutCopyText: true,
  gridItem: DebtorCustomAirportHubsItem,
  gridCols: [
   { name: "Name", key: "Name" },
    { name: "Airports", key: "Airports" }
  ]
};
//End Custom Airport Hubs

//Start FlightNdcAtpcoTieSettings
const FlightNdcAtpcoTieSettingsApplicationType = {
  displayName: "NDC ATPCO Tie Settings Application Type",
  dataAt: "FlightConfiguration.FlightNdcAtpcoTieSettings.ApplicationType",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "FlightNdcAtpcoTieSettingsApplicationType",
  html:constants.MESSAGES.NDC_TIE_SETTINGS
};

const FlightNdcAtpcoTieSettingsThresholdType = {
  displayName: "NDC ATPCO Tie Settings Threshold Type",
  dataAt: "FlightConfiguration.FlightNdcAtpcoTieSettings.ThresholdType",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "FlightNdcAtpcoTieSettingsThresholdType",
};

const FlightNdcAtpcoTieSettingsThresholdValue = {
  displayName: "NDC ATPCO Tie Settings Threshold Value",
  dataAt: "FlightConfiguration.FlightNdcAtpcoTieSettings.ThresholdValue",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: "number",
};
//End FlightNdcAtpcoTieSettings

const FlightConfigPanel = {
  dataAt: "",
  displayAs: constants.DISPLAY_AS.GROUP,
  tabName: "Flight-Sectors",
  children: [
    EnablePreBookSeatSelection,
    EnableFareCodeDisplay,
    DisableTravelRequirements,
    DisableColleagueSeatMapDisplay,
    EnableSharedFlightOptions,
    CollectContactInformationForNDCBookings,
    FlightPolicyDepatureWindowFrom,
    FlightPolicyDepatureWindowTo,
    OneWayFareRules,
    CombinableFareRules,
    FlightSearchWindows,
    FlightConfigurationRiskEngineFlightThresholdLimit,
    FlightExcludeAirports,
    FlightCorporateRateCodes,
    FlightModificationSettingsGrid,
    FlightSearchConfigurationConfigurationType,
    FlightSearchGrid,
    FlightNdcAtpcoTieSettingsApplicationType,
    FlightNdcAtpcoTieSettingsThresholdType,
    FlightNdcAtpcoTieSettingsThresholdValue,
    DebtorCustomAirportHubsGrid
  ],
};

const FlightLimitPassengerPolicy = {
  dataAt: "",
  displayAs: constants.DISPLAY_AS.GROUP,
  tabName: "Flight-Limit-Passenger-Policy",
  children: [
    EnablePassengerLimit,
    FlightConfigurationPassengerLimit,
    {
      displayAs: constants.DISPLAY_AS.SUB_HEADING,
      html:
        "<h4>Debtor Identification</h4>",
    },
    LimitPassengerPolicyDebtorIdentificationType,
    LimitPassengerPolicyDebtorIdentificationDefinedDks,
    LimitPassengerPolicyDebtorIdentificationGroupCodeValue,
    {
      displayAs: constants.DISPLAY_AS.SUB_HEADING,
      html:
        "<h4>Udid Configurations</h4>",
    },
    UdidConfigurations,
    {
      displayAs: constants.DISPLAY_AS.SUB_HEADING,
      html:
        "<h4>Policy Restrictions</h4>",
    },
    LimitPassengerPolicyRestrictiontionRestrictionType,
    LimitPassengerPolicyRestrictionShowButNotAllowMessage,
    LimitPassengerPolicyRestrictionDisplayMessageTitle,
    LimitPassengerPolicyRestrictionDisplayMessage,
    LimitPassengerPolicyRestrictionSetOutOfPolicyMessage,
    LimitPassengerPolicyRestrictionSetOutOfPolicyListId,
    LimitPassengerPolicyRestrictionSetOutOfPolicyRemarkFormat,
  ]
}

const GroundConfigurationPanel = {
  dataAt: "",
  displayAs: constants.DISPLAY_AS.GROUP,
  tabName: "Ground-Sectors",
  children: [
    EnableGroundTransportationConfiguration,
    GroundTransportationConfigurationUiTitle,
    GroundTransportationConfigurationVehicleTypes,
    GroundTransportationCompanyReferenceMapping,
    {
      displayAs: constants.DISPLAY_AS.SUB_HEADING,
      label: "All defined Company Reference Mappings will be sent to Groundspan during the booking process.",
    },
    {
      displayAs: constants.DISPLAY_AS.SUB_HEADING,
      label: "GDS Setting UserDefinedValues will be ignored if Company Reference Mappings exist.",
    }
  ],
};

const Agency = {
  dataAt: "",
  displayAs: constants.DISPLAY_AS.GROUP,
  tabName: "Agency",
  children: [
    AgencyCreditCards,
    AgencyReasonDisplayName,
    DebtorAgencyReasonCodes,
    DebtorAgencyAddress,
    DebtorAgencyStreet,
    DebtorAgencyCity,
    DebtorAgencyState,
    DebtorAgencyPostcode,
    DebtorAgencyEmail,
    DebtorAgencyPhone,
    DebtorAgencyVirtualCreditCardConfigurations,
    PaymentConfigurations,
    HotelCarFopHandlingType,
    HotelCarDefinedCreditCardId,
    DebtorModificationAlertEmails,
    DebtorConfirmationAlertEmails,
    DebtorCancellationAlertEmails,
    DebtorAgencySendConfirmationToTraveler,
    DebtorAgencySendConfirmationToBooker,
    DebtorAgencyConfirmationEmailHeaderText,
    DebtorAgencyConfirmationEmailFooterText
  ],
};

const CompanyReferencesPanel = {
  dataAt: "",
  displayAs: constants.DISPLAY_AS.GROUP,
  tabName: "Company-References",
  children: [CompanyReferencesGrid],
};

const PoliciesPanel = {
  tabName: "Policies",
  dataAt: "",
  displayAs: constants.DISPLAY_AS.GROUP,
  children: [ItineraryPolicies],
};

const ApprovalsPanel = {
  tabName: "Approvals",
  dataAt: "",
  displayAs: constants.DISPLAY_AS.GROUP,
  children: [
    DebtorBookingConfirmationWebHookUrl,
    DebtorApprovalsCommentEnabled,
    RestrictSelfApproval,
    DebtorCTMApproveStatusLookupEnabled,
    DebtorCTMApprovePendingRestrictModify,
    {
      displayAs: constants.DISPLAY_AS.SUB_HEADING,
      html:
        "<h4>Agent Claimed Remark</h4><small>When remark text is populated User hold and approval expiry will not occur when defined remark exist in booking.</small>",
    },
    {
      displayName: "Agent Claimed Remark Type",
      dataAt: "Approvals.ApprovalClaimedRemark.RemarkType",
      displayAs: constants.DISPLAY_AS.SELECT,
      optionsAt: "RemarkType",
    },
    {
      displayName: "Agent Claimed Remark Text",
      dataAt: "Approvals.ApprovalClaimedRemark.RemarkText",
      displayAs: constants.DISPLAY_AS.TEXT_INPUT,
      html: "<small><i>Leave blank to not pause ticketing.</i> Remark Text can be a regular expression</small>"
    },
    {
      displayName: "Agent Claimed Remark Code",
      dataAt: "Approvals.ApprovalClaimedRemark.RemarkCode",
      displayAs: constants.DISPLAY_AS.TEXT_INPUT,
      label: "Optional value used when remark type is Alpha-Coded"
    },
    {
      displayName: "Debtor Agent Claimed Remark Handling",
      dataAt: "Approvals.ApprovalClaimedRemark.DebtorAgentClaimedRemarkHandling",
      displayAs: constants.DISPLAY_AS.SELECT,
      optionsAt: "DebtorAgentClaimedRemarkHandlingType",
      defaultValue: "Debtor",
    },
    DebtorApprovalRestrictionThresholdMinTitle,
    DebtorApprovalRestrictionThresholdMin,
  ],
};

const InfoPanel = {
  dataAt: "",
  displayAs: constants.DISPLAY_AS.GROUP,
  tabName: "Info",
  children: [
    Id,
    Title,
    DebtorName,
    ConsultingTeamEmail,
    Disabled,
    TestAccount,
    EnableNewUiHandlingType,
    GuestTraveller,
    GuestTravellerDeptCostCenterFop,
    GuestTravellerAllowTempCards,
    GuestTravellerAllowTempCardsSub,
    AllowArrangerFormsOfPayment,
    PaymentMethodDisabled,
    PaymentMethodSelectionMandatory,
    ShowCommentToTravelAgent,
    AdditionalTravelerInfo,
    CancelBookingEnabled,
    UserHoldEnabled,
    CancellationWindowMinutes,
    OfflinePnrEnabled,
    OrderNumberMandatory,
    OrderNumberEnabled,
    OrderNumberDisplayName,
    CostCentreMandatory,
    CostCentreEnabled,
    CostCentreDisplayName,
    DepartmentMandatory,
    DepartmentEnabled,
    DepartmentDisplayName,
    FareDebugging,
    ProfileCompanyIdentifier,
    ProfileDaytimePhoneNumber,
    ProfileAfterHoursPhoneNumber,
    ProfileIndustry,
    ProfileCompanySize,
    DebtorOrderNumberCodes,
    HomeCountryCode,
    DomesticCountryCodes,
    PointsOfInterestFileUploader,
    ShowPoiOnTop,
    TravellerConfigurationSource,
    TravellerConfigurationPcc,
    TravellerConfigurationGuestTravellerProfileName,
    TravellerConfigurationProfilePnrBuilder,
    TermsAndConditions,
    DebtorMultiPaxPnrHandlingType,
    MultiPaxPnrHandlingText
  ],
};

const ItineraryTicketingPanel = {
  tabName: "Booking-TAW",
  dataAt: "",
  displayAs: constants.DISPLAY_AS.GROUP,
  children: [
    {
      displayAs: constants.DISPLAY_AS.SUB_HEADING,
      label: "Configure how TAW is written to the Sabre PNR.",
    },
    {
      displayAs: constants.DISPLAY_AS.SUB_HEADING,
      label:
        "7TAW{​​PCC}​​{​​TTL Date}​​{​​Queue Number}​​/{​​TTL Time}​​/{​​Short Text}​​",
    },
    {
      displayName: "Include TTL Date and Time in TAW entry",
      dataAt: "ApplyTicketingTimeLimit",
      displayAs: constants.DISPLAY_AS.BOOLEAN,
    },
    {
      displayName: "Pseudo City Code",
      dataAt: "TicketingPseudoCityCode",
      displayAs: constants.DISPLAY_AS.TEXT_INPUT,
    },
    {
      displayName: "Queue Number",
      dataAt: "TicketingQueue",
      displayAs: constants.DISPLAY_AS.TEXT_INPUT,
    },
    {
      displayName: "Taw Text - Confirmed",
      dataAt: "TicketingTawTextConfirmed",
      displayAs: constants.DISPLAY_AS.TEXT_INPUT,
    },
    {
      displayName: "Taw Text - User Hold",
      dataAt: "TicketingTawTextUserHold",
      displayAs: constants.DISPLAY_AS.TEXT_INPUT,
    },
    {
      displayName: "Taw Text - Approval",
      dataAt: "TicketingTawTextApproval",
      displayAs: constants.DISPLAY_AS.TEXT_INPUT,
    },
    {
      displayName: "Taw Text - Canceled",
      dataAt: "TicketingTawTextCanceled",
      displayAs: constants.DISPLAY_AS.TEXT_INPUT,
    },
    {
      displayName: "Taw Text - Modify",
      dataAt: "TicketingTawTextModify",
      displayAs: constants.DISPLAY_AS.TEXT_INPUT
    },
    {
     displayAs: constants.DISPLAY_AS.SUB_HEADING,
     label: "Use keyword {ModifyTrans} to add the transaction info of the modification. Example: AIR HOTEL CAR"
    },
    {
      displayAs: constants.DISPLAY_AS.SUB_HEADING,
      label: "TTL is derived from the stored fare",
    },
    {
      displayAs: constants.DISPLAY_AS.SUB_HEADING,
      label:
        "If no stored fare, TTL is calcualted using the GDS -> PCC City timezone and 24 hours from time of booking​​",
    }
  ],
};

const DebtorRemarksTab = {
  tabName: "Debtor-Remarks",
  dataAt: "",
  displayAs: constants.DISPLAY_AS.GROUP,
  children: [
    AdditionalPnrUserHoldRemarks,
    AdditionalPnrRemarksCancel,
    AdditionalPnrRemarksModify,
    AdditionalPnrRemarks,
    AdditionalPnrUserHoldConfirmedRemarks,
    AdditionalFinishBookingRemarks,
    AdditionalPnrRemarksGuestTraveler,
    AdditionalPnrRemarksAncillary,
    HostCommands,
  ],
};

const DebtorInfoTab = {
  tabName: "Debtor-Info",
  dataAt: "",
  displayAs: constants.DISPLAY_AS.GROUP,
  children: [
    DebtorSupportPhoneNumber,
    DebtorSupportEmailAddress,
    DebtorSupportCurrencyCode,
    DebtorAddressFirstname,
    DebtorAddressLastname,
    DebtorAddressAddress,
    DebtorAddressStreet,
    DebtorAddressCity,
    DebtorAddressCityCode,
    DebtorAddressState,
    DebtorAddressPostcode,
    DebtorAddressCountryCode
  ],
};

const DebtorTabs = {
  dataAt: "",
  displayAs: constants.DISPLAY_AS.TABS,
  children: [
    InfoPanel,
    ApprovalsPanel,
    PoliciesPanel,
    CompanyReferencesPanel,
    Agency,
    DebtorInfoTab,
    FlightConfigPanel,
    FlightLimitPassengerPolicy,
    UnusedTicketPanel,
    RailConfigPanel,
    HotelConfigurationPanel,
    GroundConfigurationPanel,
    AllSectorConfigPanel,
    MobileConfigPanel,
    GDSPanel,
    ItineraryTicketingPanel,
    DebtorRemarksTab,
    AdminPanel,
    DatetimeFormatPanel,
  ],
};

const DebtorNameLabel = {
  dataAt: "Name",
  displayAs: constants.DISPLAY_AS.SUB_HEADING,
  label: "Name:",
};

const DebtorAddResource = {
  displayAs: constants.DISPLAY_AS.ADD_GRID_RESOURCE,
  displayName: "Debtor",
  data: {
    Name: "",
    ConsultingTeamEmail: "",
    FlightConfiguration: {
      FlightPolicyDepatureWindowFrom: 3,
      FlightPolicyDepatureWindowTo: 3,
    },
    HotelConfiguration: { Radius: { DefaultRadius: null } },
  },
  children: [DebtorName, ConsultingTeamEmail],
  endpoint: "Debtors",
};

const Debtor = {
  displayName: "Debtor",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  dataAt: "",
  iconClass: "fa-user",
  children: [DebtorNameLabel, DebtorTabs],
  endpoint: "Debtors",
  routeParamId: "debtorId",
};

const DebtorList = {
  rootNode: true,
  displayName: "Debtors",
  endpoint: "Debtors",
  ODataArgs:
    "?$select=Id,Name,Title,ConsultingTeamEmail,Disabled",
  displayAs: constants.DISPLAY_AS.GRID,
  gridItem: Debtor,
  gridAdd: DebtorAddResource,
  canCopyResource: true,
  canFilterDisabled: true,
  disableProperty: "Disabled",
  iconClass: "fa-user",
  gridCols: [
    { name: "Name", key: "Name" },
    { name: "Title", key: "Title" },
    { name: "Email", key: "ConsultingTeamEmail" },
  ],
};


export default {
  DebtorList,
  Debtor,
  DebtorAddResource,
  DebtorNameLabel,
  DebtorTabs,
  DebtorName,
  ConsultingTeamEmail,
  InfoPanel,
  ApprovalsPanel,
  PoliciesPanel,
  CompanyReferencesPanel,
  Agency,
  FlightConfigPanel,
  FlightLimitPassengerPolicy,
  RailConfigPanel,
  HotelConfigurationPanel,
  GroundConfigurationPanel,
  AllSectorConfigPanel,
  MobileConfigPanel,
  GDSPanel,
  UnusedTicketPanel,
  TramadaConfigurationPanel,
  AdminPanel,
  DatetimeFormatPanel,
  Id,
  Title,
  Disabled,
  TestAccount,
  FareDebugging,
  GuestTraveller,
  GuestTravellerDeptCostCenterFop,
  OrderNumberMandatory,
  OrderNumberEnabled,
  CancelBookingEnabled,
  OfflinePnrEnabled,
  OrderNumberDisplayName,
  CostCentreMandatory,
  CostCentreEnabled,
  CostCentreDisplayName,
  DepartmentMandatory,
  DepartmentEnabled,
  DepartmentDisplayName,
  PaymentMethodSelectionMandatory,
  DebtorSupportPhoneNumber,
  DebtorSupportEmailAddress,
  DebtorSupportCurrencyCode,
  DebtorAddressFirstname,
  DebtorAddressLastname,
  DebtorAddressAddress,
  DebtorAddressStreet,
  DebtorAddressCity,
  DebtorAddressCityCode,
  DebtorAddressState,
  DebtorAddressPostcode,
  DebtorAddressCountryCode,
  ProfileCompanyIdentifier,
  ProfileDaytimePhoneNumber,
  ProfileAfterHoursPhoneNumber,
  ProfileIndustry,
  ProfileCompanySize,
  AdditionalPnrRemarks,
  DebtorOrderNumberCodes,
  HomeCountryCode,
  DomesticCountryCodes,
  HostCommands,
  AdditionalPnrRemarksAncillary,
  PointsOfInterestFileUploader,
  ShowPoiOnTop,
  TravellerConfigurationSource,
  TravellerConfigurationPcc,
  TravellerConfigurationGuestTravellerProfileName,
  TermsAndConditions,
  DebtorMultiPaxPnrHandlingType,
  MultiPaxPnrHandlingText,
  DebtorBookingConfirmationWebHookUrl,
  DebtorApprovalsCommentEnabled,
  DebtorApprovalRestrictionThresholdMinTitle,
  DebtorApprovalRestrictionThresholdMin,
  DebtorCTMApproveStatusLookupEnabled,
  DebtorCTMApprovePendingRestrictModify,
  RestrictSelfApproval,
  ItineraryPolicies,
  CompanyReferencesGrid,
  AllowArrangerFormsOfPayment,
  AgencyCreditCards,
  AgencyReasonDisplayName,
  DebtorAgencyReasonCodes,
  DebtorAgencyAddress,
  DebtorAgencyStreet,
  DebtorAgencyCity,
  DebtorAgencyState,
  DebtorAgencyPostcode,
  DebtorAgencyEmail,
  DebtorModificationAlertEmails,
  DebtorConfirmationAlertEmails,
  DebtorCancellationAlertEmails,
  DebtorAgencySendConfirmationToTraveler,
  DebtorAgencySendConfirmationToBooker,
  DebtorAgencyConfirmationEmailHeaderText,
  DebtorAgencyConfirmationEmailFooterText,
  DebtorAgencyPhone,
  DebtorAgencyVirtualCreditCardConfigurationsProvider,
  DebtorAgencyVirtualCreditCardConfigurationsRegionalConsumerId,
  DebtorAgencyVirtualCreditCardConfigurationsCacCode,
  DebtorAgencyVirtualCreditCardConfigurationsCustomNameDisplayed,
  DebtorAgencyVirtualCreditCardConfigurationsSectorTypes,
  DebtorAgencyVirtualCreditCardConfigurationsProvidersAllowed,
  DebtorAgencyVirtualCreditCardConfigurationsAggregatorsAllowed,
  DebtorAgencyVirtualCreditCardConfigurationsVirtualCreditCardApplicationType,
  DebtorAgencyVirtualCreditCardConfigurationsPaymentInformation,
  DebtorAgencyVirtualCreditCardConfigurationsItem,
  DebtorAgencyVirtualCreditCardConfigurations,
  DebtorAgencyVirtualCreditCardConfigurationsCompanyReferenceMappingSourceFieldType,
  DebtorAgencyVirtualCreditCardConfigurationsCompanyReferenceMappingSourceFieldCode,
  DebtorAgencyVirtualCreditCardConfigurationsCompanyReferenceMappingCustomDataKey,
  DebtorAgencyVirtualCreditCardConfigurationsCompanyReferenceMappingReportKey,
  DebtorAgencyVirtualCreditCardConfigurationsCompanyReferenceMappingItem,
  DebtorAgencyVirtualCreditCardConfigurationsCompanyReferenceMappings,
  DebtorAgencyVirtualCreditCardConfigurationsNotificationEmail,
  PaymentConfigurations,
  FlightPolicyDepatureWindowFrom,
  FlightPolicyDepatureWindowTo,
  UdidConfigurations,
  OneWayFareRules,
  CombinableFareRules,
  FlightSearchWindows,
  FlightConfigurationRiskEngineFlightThresholdLimit,
  FlightExcludeAirports,
  RailConfiguration,
  RailSupplierSettings,
  HotelConfigurationEnableOvernightHotelPrompt,
  HotelConfigurationIsImperialSystem,
  HotelConfigurationRadiusDefaultRadius,
  HotelConfigurationRadiusCities,
  HotelConfigurationPaymentNarratives,
  HotelConfigurationTags,
  HotelConfigurationAggregators,
  HotelConfigurationHotelAmenityFiltersGrid,
  EnableGroundTransportationConfiguration,
  GroundTransportationConfigurationUiTitle,
  GroundTransportationConfigurationVehicleTypes,
  GroundTransportationCompanyReferenceMapping,
  GroundTransportationCompanyReferenceMappingItem,
  GroundTransportationCompanyReferenceMappingCode,
  GroundTransportationCompanyReferenceMappingFieldId,
  DebtorLimitCountries,
  DebtorLimitAirportClassification,
  DebtorGds,
  UnusedTicketSettings,
  EnableUnusedTicketDebtorSettings,
  AuthorisationHoldQueue,
  AutoTicketingQueue,
  Pcc,
  PccCity,
  TeamRejectionQueue,
  CancelQueue,
  ModificationQueue,
  UserHoldQueue,
  TramadaConfigurationAgencyId,
  TramadaConfigurationDebtorId,
  TramadaConfigurationDebtorAuthCode,
  TramadaConfigurationDatabase,
  CreatedBy,
  CreatedOn,
  ModifiedBy,
  ModifiedOn,
  DebtorOrderNumberCodesItem,
  TermsAndConditionsItem,
  ItineraryPoliciesItem,
  CompanyReferencesGridItem,
  AgencyCreditCardsItem,
  DebtorAgencyReasonCodesItem,
  PaymentConfigurationsItem,
  OneWayFareRulesItem,
  CombinableFareRulesItem,
  FlightSearchWindowItem,
  RailSupplierSettingsItem,
  HotelConfigurationRadiusCitiesItem,
  HotelConfigurationPaymentNarrativesItem,
  HotelConfigurationHotelAmenityFiltersItem,
  DebtorGdsItem,
  LimitPassengerPolicyUdidItem,
  DebtorOrderNumberCodesCode,
  DebtorOrderNumberCodesTitle,
  TermsAndConditionsSectionType,
  TermsAndConditionsCountries,
  TermsAndConditionsSegmentTypes,
  TermsAndConditionsText,
  ItineraryPoliciesCode,
  ItineraryPoliciesTitle,
  ItineraryPoliciesCountries,
  ItineraryPoliciesApprovalLevel,
  ItineraryPoliciesBreakPolicyEscalationApprovalLevel,
  ItineraryPoliciesTabs,
  CompanyReferencesCode,
  CompanyReferencesTitle,
  CompanyReferencesPlaceHolderText,
  CompanyReferencesListId,
  CompanyReferencesOptions,
  CompanyReferencesFlags,
  CompanyReferencesMandatory,
  CompanyReferencesChildren,
  CompanyReferencesPlacementType,
  AgencyCreditCardsItemTitle,
  AgencyCreditCardsItemId,
  CreditCardId,
  SegmentTypes,
  AgencyCreditCardsItemCreatedBy,
  AgencyCreditCardsItemCreatedOn,
  AgencyCreditCardsItemModifiedBy,
  AgencyCreditCardsItemModifiedOn,
  DebtorAgencyReasonCodesCode,
  DebtorAgencyReasonCodesTitle,
  PaymentConfigurationsProvider,
  PaymentConfigurationsPaymentTypes,
  OneWayFareRulesOrigin,
  OneWayFareRulesDestination,
  CombinableFareRulesOrigin,
  CombinableFareRulesDestination,
  FlightSearchWindowsIsAllDaySearch,
  FlightSearchWindowsFlightSearchWindowFrom,
  FlightSearchWindowsFlightSearchWindowTo,
  FlightSearchWindowsFlightPolicyDepartureWindowFrom,
  FlightSearchWindowsFlightPolicyDepartureWindowTo,
  FlightSearchWindowsOrigins,
  FlightSearchWindowsDestinations,
  RailSupplierSettingsName,
  RailSupplierSettingsCode,
  RailSupplierSettingsSettings,
  HotelConfigurationRadiusCitiesCityCode,
  HotelConfigurationRadiusCitiesRadius,
  HotelConfigurationPaymentNarrativesPaymentCode,
  HotelConfigurationPaymentNarrativesPaymentNarrative,
  HotelConfigurationPaymentNarrativesPaymentInstructions,
  HotelConfigurationPaymentNarrativesServiceFeeCode,
  HotelConfigurationPaymentNarrativesProviders,
  HotelConfigurationPaymentNarrativesAggregators,
  HotelConfigurationPaymentNarrativesIsDomesticOnly,
  HotelConfigurationHotelAmenityFiltersDisplayName,
  HotelConfigurationHotelAmenityFiltersMostPopular,
  HotelConfigurationHotelAmenityFiltersAmenities,
  DebtorGdsName,
  DebtorGdsEnabled,
  DebtorGdsSettings,
  DebtorGdsMiQuestions,
  DebtorGdsCorporateIdentifiers,
  ItineraryPoliciesGeneral,
  ItineraryPoliciesFlight,
  ItineraryPoliciesRail,
  ItineraryPoliciesHotel,
  ItineraryPoliciesCar,
  ItineraryPoliciesGroundTransportation,
  CompanyReferencesChildrenItem,
  PaymentTypesItem,
  DebtorGdsMiQuestionsItem,
  DebtorGdsCorporateIdentifiersItem,
  DebtorApproversTravellersId,
  DebtorApproversTravellersTitle,
  DebtorApproversTravellersEmail,
  ItineraryPoliciesItems,
  ItineraryPoliciesAgencyReasonCodes,
  ItineraryPoliciesMultiPaxPnrHandlingType,
  ItineraryPoliciesFlightBenchmarksPolicies,
  ItineraryPoliciesFlightBenchmarksExceptions,
  ItineraryPoliciesFlightPolicies,
  ItineraryPoliciesFlightSettingsExcludedProviders,
  ItineraryPoliciesFlightSettingsExcludedRates,
  ItineraryPoliciesFlightSettingsPolicyType,
  ItineraryPoliciesFlightSettingsRateCodes,
  ItineraryPoliciesFlightPolicyExceptions,
  ItineraryPoliciesFlightPolicyExceptionExcludedCarriers,
  ItineraryPoliciesFlightPolicyLeadTimeForInPolicyBooking,
  ItineraryPoliciesFlightPolicyExceptionSettings,
  ItineraryPoliciesFlightFlyAmericaActPolicyType,
  ItineraryPoliciesFlightFlyAmericaPolicyEnableExcludeNonCompliantFlights,
  ItineraryPoliciesFlightFlyAmericaPolicyExceptions,
  ItineraryPoliciesFlightLowLogicFare,
  ItineraryPoliciesFlightLowLogicFareTimeWindowType,
  ItineraryPoliciesFlightLowLogicFareTimeWindowDefinedType,
  ItineraryPoliciesFlightLowLogicFareContractType,
  ItineraryPoliciesFlightLowLogicFareStopType,
  ItineraryPoliciesFlightLowLogicFareRefundability,
  ItineraryPoliciesFlightDisableFlight,
  ItineraryPoliciesPaidSeatsEnabledType,
  ItineraryPoliciesRailPolicies,
  ItineraryPoliciesRailPolicyExceptions,
  ItineraryPoliciesRailExcludedSuppliers,
  ItineraryPoliciesHotelPolicies,
  ItineraryPoliciesHotelSettingsApplyVirtualCreditCard,
  ItineraryPoliciesHotelSettingsPolicyType,
  ItineraryPoliciesHotelSettingsPerNightRateDisplay,
  ItineraryPoliciesHotelSettingsRateCodes,
  ItineraryPoliciesHotelRateCategories,
  ItineraryPoliciesHotelRateCategoriesCategory,
  ItineraryPoliciesHotelRateCategoriesPriority,
  ItineraryPoliciesHotelSettingsEnablePerDiemRates,
  ItineraryPoliciesHotelSettingsShowRatesWithinPerDiem,
  ItineraryPoliciesHotelSettingsExcludedProviders,
  ItineraryPoliciesHotelSettingsExcludedAggregators,
  ItineraryPoliciesHotelExcludedAggregatorChains,
  ItineraryPoliciesHotelExcludedAggregatorChainsAggregator,
  ItineraryPoliciesHotelExcludedAggregatorChainsChains,
  ItineraryPoliciesHotelNoHotelPolicies,
  ItineraryPoliciesHotelNoHotelPoliciesTitle,
  ItineraryPoliciesHotelNoHotelPoliciesCode,
  ItineraryPoliciesHotelNoHotelPoliciesInfo,
  ItineraryPoliciesHotelSettingsIncludedRates,
  ItineraryPoliciesHotelSettingsExcludedRates,
  ItineraryPoliciesHotelSettingsExcludeDepositRequiredAndPrepayRates,
  ItineraryPoliciesHotelSettingsExcludeNonRefundableRates,
  ItineraryPoliciesHotelSettingsExcludeHotelOtherExcludedKeywords,
  ItineraryPoliciesHotelPolicyExceptions,
  ItineraryPoliciesHotelDefaultPolicyRateMin,
  ItineraryPoliciesHotelDefaultPolicyRateMax,
  ItineraryPoliciesHotelPolicyExceptionSettings,
  ItineraryPoliciesHotelPoliciesLatLngMap,
  ItineraryPoliciesCarPolicies,
  ItineraryPoliciesCarTypeDuplicateHandling,
  ItineraryPoliciesCarSettingsShowRatesWithDeposits,
  ItineraryPoliciesCarSettingsRateCodes,
  ItineraryPoliciesCarSettingsExcludedProviders,
  ItineraryPoliciesCarSettingsExcludedRates,
  ItineraryPoliciesCarPolicyExceptions,
  ItineraryPoliciesCarPolicyExceptionSettings,
  ItineraryPoliciesCarPolicyPreferred,
  ItineraryPoliciesCarPolicyRestriction,
  ItineraryPoliciesGroundTransportationPreferredVendors,
  ItineraryPoliciesGroundTransportationExcludedVendors,
  ItineraryPoliciesGroundTransportationDisableGroundTransportation,
  ItineraryPoliciesGroundTransportationIgnoreProviderPreferred,
  CompanyReferencesChildrenMatch,
  CompanyReferencesChildrenCode,
  CompanyReferencesChildrenTitle,
  CompanyReferencesChildrenPlaceHolderText,
  CompanyReferencesChildrenListId,
  CompanyReferencesChildrenOptions,
  CompanyReferencesChildrenFlags,
  CompanyReferencesChildrenMandatory,
  PaymentConfigurationsPaymentTypesType,
  PaymentConfigurationsPaymentTypesIsOptionalPaymentType,
  PaymentConfigurationsPaymentTypesConfigurations,
  DebtorGdsMiQuestionsItemSupplier,
  DebtorGdsMiQuestionsItemQuestions,
  DebtorGdsCorporateIdentifiersItemSupplierCode,
  DebtorGdsCorporateIdentifiersItemCorporateCode,
  ItineraryPoliciesItemsItem,
  ItineraryPoliciesFlightBenchmarksPoliciesItem,
  ItineraryPoliciesFlightBenchmarksExceptionsItem,
  ItineraryPoliciesFlightPoliciesItem,
  ItineraryPoliciesFlightPolicyExceptionsItem,
  ItineraryPoliciesFlightPolicyExceptionSettingsItem,
  ItineraryPoliciesLessThanXDayExceptionsItem,
  ItineraryPoliciesFlightFlyAmericaPolicyExceptionsItem,
  ItineraryPoliciesRailPoliciesItem,
  ItineraryPoliciesRailPolicyExceptionsItem,
  ItineraryPoliciesHotelPoliciesItem,
  ItineraryPoliciesHotelPolicyExceptionsItem,
  ItineraryPoliciesHotelPolicyExceptionSettingsItem,
  ItineraryPoliciesHotelRateCategoriesItem,
  ItineraryPoliciesHotelExcludedAggregatorChainsItem,
  ItineraryPoliciesHotelNoHotelPoliciesItem,
  ItineraryPoliciesCarPoliciesItem,
  ItineraryPoliciesCarPolicyExceptionsItem,
  ItineraryPoliciesCarPolicyExceptionSettingsItem,
  ItineraryPoliciesCarPolicyPreferredItem,
  ItineraryPoliciesCarPolicyRestrictionItem,
  PaymentTypesConfigurationsItem,
  DebtorGdsMiQuestionsItemQuestionsItem,
  ItineraryPoliciesItemsCode,
  ItineraryPoliciesItemsTitle,
  ItineraryPoliciesFlightBenchmarksPoliciesCarrier,
  ItineraryPoliciesFlightBenchmarksPoliciesBookingCodes,
  ItineraryPoliciesFlightBenchmarksExceptionsCarrier,
  ItineraryPoliciesFlightBenchmarksExceptionsDestinationLocationCode,
  ItineraryPoliciesFlightBenchmarksExceptionsOriginLocationCode,
  ItineraryPolicyFlightWeight,
  ItineraryPolicyFlightWeightSub,
  ItineraryPoliciesFlightPoliciesCarrier,
  ItineraryPoliciesFlightPoliciesBookingCodes,
  ItineraryPoliciesFlightPoliciesDestinationLocationCode,
  ItineraryPoliciesFlightPoliciesOriginLocationCode,
  ItineraryPoliciesFlightPoliciesOriginCountryCode,
  ItineraryPoliciesFlightPoliciesDestinationCountryCode,
  ItineraryPoliciesFlightPoliciesDurationType,
  ItineraryPoliciesFlightPoliciesDurationFrom,
  ItineraryPoliciesFlightPoliciesDurationTo,
  ItineraryPoliciesFlightPoliciesGroupTypes,
  ItineraryPoliciesFlightPoliciesFareClasses,
  ItineraryPoliciesFlightPoliciesBrandCodes,
  ItineraryPoliciesFlightPoliciesPolicyType,
  ItineraryPoliciesFlightPolicyExceptionsTitle,
  ItineraryPoliciesFlightPolicyExceptionsCode,
  ItineraryPoliciesFlightPolicyExceptionsCountries,
  ItineraryPoliciesFlightPolicyExceptionSettingsOriginCountryCode,
  ItineraryPoliciesFlightPolicyExceptionSettingsDestinationCountryCode,
  ItineraryPoliciesFlightPolicyExceptionSettingsDurationFrom,
  ItineraryPoliciesFlightPolicyExceptionSettingsDurationTo,
  ItineraryPoliciesFlightPolicyExceptionSettingsGroupTypes,
  ItineraryPoliciesFlightPolicyExceptionSettingsPriceTolerance,
  ItineraryPoliciesFlightPolicyExceptionSettingsPriceToleranceType,
  ItineraryPoliciesFlightPolicyExceptionSettingsLowestFareGroupType,
  ItineraryPoliciesFlightPolicyExceptionSettingsFlightType,
  ItineraryPoliciesFlightPolicyExceptionSettingsBenchmarkMostDirect,
  ItineraryPoliciesRailPoliciesSuppliers,
  ItineraryPoliciesRailPoliciesCorporateCode,
  ItineraryPoliciesRailPoliciesPolicyType,
  ItineraryPoliciesRailPoliciesGroupTypes,
  ItineraryPoliciesRailPolicyExceptionsTitle,
  ItineraryPoliciesRailPolicyExceptionsCode,
  ItineraryPoliciesRailPolicyExceptionsCountries,
  ItineraryPoliciesRailDisableRail,
  ItineraryPoliciesHotelPoliciesPolicyName,
  ItineraryPoliciesHotelDisableHotel,
  ItineraryPoliciesHotelPoliciesMostPreferredHotels,
  ItineraryPoliciesHotelPoliciesMostPreferredChainCodes,
  ItineraryPoliciesHotelPoliciesHighlyPreferredHotels,
  ItineraryPoliciesHotelPoliciesHighlyPreferredChainCodes,
  ItineraryPoliciesHotelPoliciesHotels,
  ItineraryPoliciesHotelPoliciesChainCodes,
  ItineraryPoliciesHotelPoliciesRateMin,
  ItineraryPoliciesHotelPoliciesRateMax,
  ItineraryPoliciesHotelPoliciesLocationCode,
  ItineraryPoliciesHotelPoliciesCountryCode,
  ItineraryPoliciesHotelPoliciesPostCode,
  ItineraryPoliciesHotelPoliciesMinimumHotelRating,
  ItineraryPoliciesHotelPoliciesExcludedChainCodes,
  ItineraryPoliciesHotelPoliciesExcludedHotels,
  ItineraryPoliciesHotelPoliciesRadius,
  ItineraryPoliciesHotelPoliciesLatitude,
  ItineraryPoliciesHotelPoliciesLongitude,
  ItineraryPoliciesHotelPoliciesLatLong,
  ItineraryPoliciesHotelPolicyExceptionsTitle,
  ItineraryPoliciesHotelPolicyExceptionsCode,
  ItineraryPoliciesHotelPolicyExceptionsCountries,
  ItineraryPoliciesHotelPolicyExceptionSettingsName,
  ItineraryPoliciesHotelPolicyExceptionSettingsLocationCode,
  ItineraryPoliciesHotelPolicyExceptionSettingsAirportCodes,
  ItineraryPoliciesHotelPolicyExceptionSettingsHotelIDs,
  ItineraryPoliciesHotelPolicyExceptionSettingsCountryCode,
  ItineraryPoliciesHotelPolicyExceptionSettingsMaximumDailyRate,
  ItineraryPoliciesHotelPolicyExceptionSettingsPriceTolerance,
  ItineraryPoliciesHotelPolicyExceptionSettingsPriceToleranceType,
  ItineraryPoliciesHotelPolicyExceptionSettingsRadius,
  ItineraryPoliciesHotelPolicyExceptionSettingsLatitude,
  ItineraryPoliciesHotelPolicyExceptionSettingsLongitude,
  ItineraryPoliciesHotelPolicyExceptionSettingsLatLong,
  ItineraryPoliciesCarPoliciesName,
  ItineraryPoliciesCarPoliciesBillingReference,
  ItineraryPoliciesCarPoliciesUseCompanyRefCodeForBillingRef,
  ItineraryPoliciesCarPoliciesUseCompanyRefCodeForBillingRefSub,
  ItineraryPoliciesCarDisableCar,
  ItineraryPoliciesCarPoliciesSupplierCode,
  ItineraryPoliciesCarPoliciesSupplierTitle,
  ItineraryPoliciesCarPoliciesCorporateCode,
  ItineraryPoliciesCarPoliciesGuaranteeText,
  ItineraryPoliciesCarPoliciesDebtorRateOverTravelerId,
  ItineraryPoliciesCarPoliciesRate,
  ItineraryPoliciesCarPoliciesDepartments,
  ItineraryPoliciesCarPoliciesCostCentres,
  ItineraryPoliciesCarPoliciesAllowDeliveryAndCollection,
  ItineraryPoliciesCarPolicyExceptionsTitle,
  ItineraryPoliciesCarPolicyExceptionsCode,
  ItineraryPoliciesCarPolicyExceptionsCountries,
  ItineraryPoliciesCarPolicyExceptionSettingsLocationCode,
  ItineraryPoliciesCarPolicyExceptionSettingsCountryCode,
  ItineraryPoliciesCarPolicyExceptionSettingsSupplierCode,
  ItineraryPoliciesCarPolicyExceptionSettingsMaximumDailyRate,
  ItineraryPoliciesCarPolicyExceptionSettingsLocationCodes,
  ItineraryPoliciesCarPolicyExceptionSettingsCountryCodes,
  ItineraryPoliciesCarPolicyExceptionSettingsSuppliers,
  ItineraryPoliciesCarPolicyExceptionSettingsSipps,
  ItineraryPoliciesCarPolicyPreferredSuppliers,
  ItineraryPoliciesCarPolicyPreferredLocationCodes,
  ItineraryPoliciesCarPolicyPreferredCountryCodes,
  ItineraryPoliciesCarPolicyPreferredSipps,
  ItineraryPoliciesCarPolicyRestrictionSuppliers,
  ItineraryPoliciesCarPolicyRestrictionLocationCodes,
  ItineraryPoliciesCarPolicyRestrictionCountryCodes,
  ItineraryPoliciesCarPolicyRestrictionSipps,
  ItineraryPoliciesCarPolicyRestrictionMaximumDailyRate,
  ItineraryPoliciesCarPolicyRestrictionPolicyType,
  PaymentConfigurationsPaymentTypesConfigurationsSector,
  PaymentConfigurationsPaymentTypesConfigurationsSuppliers,
  DebtorGdsMiQuestionsItemQuestionsItemQuestion,
  DebtorGdsMiQuestionsItemQuestionsItemAnswerFormat,
  PaymentConfigurationsPaymentTypesConfigurationsSuppliersItem,
  PaymentConfigurationsPaymentTypesConfigurationsSuppliersName,
  PaymentConfigurationsPaymentTypesConfigurationsSuppliersSettings,
  EnableCarAiRecommendation,
  EnableHotelAiRecommendation,
  CompanyReferencesItemsItem,
  DebtorGdsPassiveFlightSegmentRemarkTemplate,
  EnableHonoluluTripFeed,
  HotelCarFopHandlingType,
  HotelCarDefinedCreditCardId,
  DebtorRemarksTab,
  DebtorInfoTab,
  EnableModificationCar,
  EnableModificationHotel,
  EnableModificationAir,
  EnableModificationGround,
  EnableModificationRail,
  EnableItineraryValidatorDebtorSettings,
  ItineraryValidatorSettings,
  BookingThreshold,
  FlightCorporateRateCodes,
  FlightCorporateRateCodeItem,
  FlightCorporateRateCodeCarriers,
  FlightCorporateRateCode,
  FlightCorporateRateCodeGdsProviders,
  FlightCorporateRateCodeType,
  FlightCorporateRateCodeValue,
  ItineraryPoliciesFlightEnableAncillaryFees,
  ItineraryPoliciesFlightAncillaryFeeCodes,
  DebtorFlightModificationSettingItem,
  DebtorFlightSearchConfigurationItem,
  LimitPassengerPolicyUdidConfigurationType,
  ItineraryPoliciesProfileAttributeSourceType,
  ItineraryPoliciesProfileAttributesItem,
  ItineraryPoliciesProfileAttributesItems,
  ItineraryPolicyEnhancedPolicyRulesConditionsItem,
  ItineraryPolicyEnhancedPolicyRulesConditions,
  DebtorCustomAirportHubsItem,
  DebtorCustomAirportHubName,
  DebtorCustomAirportHubAirports
};



// WEBPACK FOOTER //
// ./src/config/fields/debtors.js